// ============================================================
// 0. LOKALIZÁCIA — SK (EUR) / CZ (CZK)
//    window.CT(s)          → na českej verzii preloží slovenský text,
//                            na slovenskej vráti presne ten istý reťazec.
//    window.charmaMoney(c) → suma v centoch: "18,90 €" alebo "469 Kč".
//    window.CHARMA_L10N    → hranica dopravy zdarma, cena výdajného miesta.
// ============================================================
(function() {
  var S = window.Shopify || {};
  var loc = String(S.locale || document.documentElement.lang || 'sk').toLowerCase();
  var cur = (S.currency && S.currency.active) || 'EUR';
  var isCs = loc.indexOf('cs') === 0;
  var isPl = loc.indexOf('pl') === 0;
  var isCzk = cur === 'CZK';

  // Poradie je dôležité: najprv celé vety, potom frázy, na konci slová.
  var RULES = [
    // — EasyTabs (záložky na karte produktu); texty sú rozdelené <strong> na kúsky —
    [/Informácie o doručení/g, 'Informace o doručení'],
    [/Kompatibilita s náramkami Pandora/g, 'Kompatibilita s náramky Pandora'],
    [/Vašu objednávku odosielame čo najskôr – doručenie zvyčajne trvá/g, 'Vaši objednávku odesíláme co nejdříve – doručení obvykle trvá'],
    [/1 až 3 pracovné dni/g, '1 až 3 pracovní dny'],
    [/Môžete si vybrať z dvoch možností doručenia:/g, 'Můžete si vybrat ze dvou možností doručení:'],
    [/Adresa doručenia/g, 'Doručení na adresu'],
    [/– balíček vám prinesie kuriér priamo domov alebo do práce\./g, '– balíček vám kurýr přiveze přímo domů nebo do práce.'],
    [/Výdajné miesto Packeta/g, 'Výdejní místo Zásilkovna'],
    [/– pohodlne si vyzdvihnete zásielku na niektorom z tisícok výdajných miest Packeta vo vašom okolí\./g, '– zásilku si pohodlně vyzvednete na některém z tisíců výdejních míst Zásilkovny ve vašem okolí.'],
    [/O sledovaní zásielky vás budeme informovať e-mailom aj SMS správou\./g, 'O sledování zásilky vás budeme informovat e-mailem i SMS zprávou.'],
    [/Ak hľadáte darček, naše prívesky sú/g, 'Pokud hledáte dárek, naše přívěsky jsou'],
    [/Naše prívesky sú/g, 'Naše přívěsky jsou'],
    [/plne kompatibilné s náramkami typu Pandora/g, 'plně kompatibilní s náramky typu Pandora'],
    [/aj inými populárnymi typmi náramkov s rovnakým mechanizmom\./g, 'i s dalšími oblíbenými typy náramků se stejným mechanismem.'],
    [/Môžete ich jednoducho navliecť a kombinovať podľa vlastného štýlu – hodia sa k strieborným, pozláteným aj koženým náramkom\./g, 'Můžete je jednoduše navléct a kombinovat podle vlastního stylu – hodí se ke stříbrným, pozlaceným i koženým náramkům.'],
    [/ideálnym doplnkom ku náramkom Pandora/g, 'ideálním doplňkem k náramkům Pandora'],
    // — Charma Italia skladačka náramku (ci-charm-picker) —
    [/Vyber si až 10 príveskov a pridaj ich do košíka spolu s náramkom/g, 'Vyber si až 10 přívěsků a přidej je do košíku spolu s náramkem'],
    [/Späť na kategórie/g, 'Zpět na kategorie'],
    [/Pridaj šarmy do košíka/g, 'Přidej přívěsky do košíku'],
    [/(\d+) \/ 10 príveskov vybraných/g, '$1 / 10 přívěsků vybráno'],
    // — filtre / typy produktov —
    [/Visiace Prívesky/g, 'Visací přívěsky'],
    [/Visiace prívesky/g, 'Visací přívěsky'],
    [/Prívesky/g, 'Přívěsky'],
    [/Pridať do košíka/g, 'Přidat do košíku'],
    [/Vypredané/g, 'Vyprodáno'],
    [/Vybrať variant/g, 'Vybrat variantu'],
    [/Kompatibilné s náramkami /g, 'Kompatibilní s náramky '],
    [/, Charma, Apart a ďalšími značkami s prievlakom 4 mm/g, ', Charma, Apart a dalšími značkami s průvlekem 4 mm'],
    [/Tento darček je už uplatnený\. Ďalší náramok získate pri 7 ďalších príveskoch\./g, 'Tento dárek je již uplatněn. Další náramek získáte při 7 dalších přívěscích.'],
    [/Náramok zdarma už nie je k dispozícii/g, 'Náramek zdarma již není k dispozici'],
    [/Vyberte si náramok Charma Italia zadarmo/g, 'Vyberte si náramek Charma Italia zdarma'],
    [/Vašich 7 príveskov odomklo darček/g, 'Vašich 7 přívěsků odemklo dárek'],
    [/2\+1=4 — štvrtý šperk získate zadarmo/g, '2+1=4 — čtvrtý šperk získáte zdarma'],
    [/3\+1 ZADARMO — vyberte si 3 prívesky a 4\. máte od nás/g, '3+1 ZDARMA — vyberte si 3 přívěsky a 4. máte od nás'],
    [/a získate 4\. ZADARMO/g, 'a získáte 4. ZDARMA'],
    [/Darček je váš! Vyberte si prívesok ZADARMO/g, 'Dárek je váš! Vyberte si přívěsek ZDARMA'],
    [/Váš darček je v košíku · Skontrolovať košík/g, 'Váš dárek je v košíku · Zkontrolovat košík'],
    [/Doprava zadarmo od 49 €/g, 'Doprava zdarma od 1 199 Kč'],
    [/Zatiaľ ste nepridali žiadne prívesky\./g, 'Zatím jste nepřidali žádné přívěsky.'],
    [/Máte nárok na náramok zdarma!/g, 'Máte nárok na náramek zdarma!'],
    [/Máte nárok na náramok zadarmo/g, 'Máte nárok na náramek zdarma'],
    [/Váš náramok je zadarmo/g, 'Váš náramek je zdarma'],
    [/Špeciálna ponuka k vašej objednávke/g, 'Speciální nabídka k vaší objednávce'],
    [/Ponuka dostupná iba k tejto objednávke\./g, 'Nabídka platí pouze k této objednávce.'],
    [/Akcia 3\+1: <b>kúpte 3 prívesky, 4\. máte zadarmo<\/b>/g, 'Akce 3+1: <b>kupte 3 přívěsky, 4. máte zdarma</b>'],
    [/Teraz si vyberte/g, 'Teď si vyberte'],
    [/máte od nás/g, 'máte od nás'],
    [/Pridajte ešte/g, 'Přidejte ještě'],
    [/Máte dopravu zadarmo/g, 'Máte dopravu zdarma'],
    [/a máte dopravu zadarmo/g, 'a máte dopravu zdarma'],
    [/Pridať náramok do košíka/g, 'Přidat náramek do košíku'],
    [/Pridané do košíka/g, 'Přidáno do košíku'],
    [/Darček pridaný do košíka/g, 'Dárek přidán do košíku'],
    [/Zobraziť košík/g, 'Zobrazit košík'],
    [/Otvoriť košík/g, 'Otevřít košík'],
    [/Prejsť k pokladni/g, 'Přejít k pokladně'],
    [/Pokračovať vo výbere/g, 'Pokračovat ve výběru'],
    [/Vybrať náramok zdarma/g, 'Vybrat náramek zdarma'],
    [/DARČEK ODOMKNUTÝ/g, 'DÁREK ODEMČEN'],
    [/ĎALŠÍ NÁRAMOK ZADARMO/g, 'DALŠÍ NÁRAMEK ZDARMA'],
    [/NÁRAMOK ZADARMO/g, 'NÁRAMEK ZDARMA'],
    [/NÁRAMKY ZADARMO/g, 'NÁRAMKY ZDARMA'],
    [/náramok získaný/g, 'náramek získán'],
    [/náramky získané/g, 'náramky získány'],
    [/náramkov získaných/g, 'náramků získáno'],
    [/VAŠE PRÍVESKY/g, 'VAŠE PŘÍVĚSKY'],
    [/Vaše prívesky/g, 'Vaše přívěsky'],
    [/Doplňte svoj výber/g, 'Doplňte svůj výběr'],
    [/Vybrané pre vás/g, 'Vybrané pro vás'],
    [/Možno neskôr/g, 'Možná později'],
    [/Skúste znova/g, 'Zkuste znovu'],
    [/Ružové zlato/g, 'Růžové zlato'],
    [/Striebro/g, 'Stříbro'],
    [/Čierny/g, 'Černý'],
    [/Pridávam…/g, 'Přidávám…'],
    [/Pridané/g, 'Přidáno'],
    [/Pridať/g, 'Přidat'],
    [/Odstrániť/g, 'Odstranit'],
    [/Zobraziť/g, 'Zobrazit'],
    [/Zatvoriť/g, 'Zavřít'],
    [/Zavrieť/g, 'Zavřít'],
    [/Doprava zadarmo/g, 'Doprava zdarma'],
    [/Spolu:/g, 'Celkem:'],
    [/Ešte/g, 'Ještě'],
    [/ešte/g, 'ještě'],
    [/príveskov/g, 'přívěsků'],
    [/prívesky/g, 'přívěsky'],
    [/prívesok/g, 'přívěsek'],
    [/šperkov/g, 'šperků'],
    [/do náramku zdarma/g, 'do náramku zdarma'],
    [/náramok/g, 'náramek'],
    [/darček/g, 'dárek'],
    [/ZADARMO/g, 'ZDARMA'],
    [/zadarmo/g, 'zdarma'],
    // dolaďovanie po slovách
    [/pre tvoj náram/g, 'pro tvůj náram'],
    [/(^|[^\d])1 přívěsků/g, '$11 přívěsek'],
    [/(^|[^\d])([234]) přívěsků/g, '$1$2 přívěsky']
  ];

  // Celé texty (napr. názvy kategórií v skladačke), prekladajú sa len keď sa zhoduje celý uzol
  var EXACT = {
    'Strieborné': 'Stříbrné', 'Visiace prívesky': 'Visací přívěsky', 'Kvety': 'Květiny', 'Motyle': 'Motýli',
    'Zvieratka': 'Zvířátka', 'Srdcia': 'Srdce', 'Ovocie': 'Ovoce', 'Stastie': 'Štěstí', 'Masle': 'Mašle',
    'Krize': 'Křížky', 'Pridané ✓': 'Přidáno ✓', 'Pridávam…': 'Přidávám…'
  };
  var PL_RULES = [
    [/Pridaj ešte/g, "Dodaj jeszcze"],
    [/Pridaj jeszcze/g, "Dodaj jeszcze"],
    [/a získaj/g, "i otrzymaj"],
    [/Načítavanie charmsów…/g, "Ładowanie charmsów…"],
    [/Načítavanie príveskov/g, "Ładowanie charmsów"],
    [/Doprava do 3 dní/g, "Dostawa 1–2 dni robocze"],
    [/V košíku máte (\d+) príveskov\. Vyberte ešte \d+ prívesky a náramok dostanete/g, function(_,n){n=Number(n);return n>=7?'Masz w koszyku '+n+' charmsów. Bransoletkę otrzymasz':'Masz w koszyku '+n+' charmsów. Dodaj jeszcze '+(7-n)+' i odbierz bransoletkę';}],
    [/(\d+) \/ 10 príveskov/g, 'Wybrano: $1 charmsów'],
    [/Vyberte si štyri šperky, ktoré sa Vám páčia, a jeden z nich získate ako darček/g, "Wybierz cztery ozdoby, które Ci się podobają, a jedną otrzymasz w prezencie"],
    [/Doprava na výdajné miesto alebo do Z-BOXu len/g, "Dostawa do Paczkomatu InPost już od"],
    [/Vyber si charmsy pre tvoj bransoletka/g, "Wybierz charmsy do swojej bransoletki"],
    [/Vyber si charmsy pre tvoj náramok/g, "Wybierz charmsy do swojej bransoletki"],
    [/Doprava zdarma pri nákupe nad/g, "Darmowa dostawa przy zakupach powyżej"],
    [/Vyberte si hodinky CHARMA za/g, "Wybierz zegarek CHARMA za"],
    [/Kliknite pre detaily akcie/g, "Kliknij, aby poznać szczegóły promocji"],
    [/Špeciálna ponuka hodiniek/g, "Specjalna oferta zegarków"],
    [/Pokračovať v nákupe/g, "Kontynuuj zakupy"],
    [/Placeholder Product/g, "Produkt"],
    [/Decrease quantity/g, "Zmniejsz ilość"],
    [/Increase quantity/g, "Zwiększ ilość"],
    [/náramok dostanete/g, "bransoletkę otrzymasz"],
    [/Continue shopping/g, "Kontynuuj zakupy"],
    [/Popis produktu/g, "Opis produktu"],
    [/V košíku máte/g, "Masz w koszyku"],
    [/Pôvodná cena/g, "Cena regularna"],
    [/Celková cena/g, "Cena łączna"],
    [/Vyberte ešte/g, "Dodaj jeszcze"],
    [/Remove item/g, "Usuń produkt"],
    [/Gratulujeme/g, "Gratulacje"],
    [/Close cart/g, "Zamknij koszyk"],
    [/strieborný/g, "srebrny"],
    [/Strieborná/g, "Srebrny"],
    [/je prázdny/g, "jest pusty"],
    [/Váš Košík/g, "Twój koszyk"],
    [/Váš košík/g, "Twój koszyk"],
    [/Your Cart/g, "Twój koszyk"],
    [/Your cart/g, "Twój koszyk"],
    [/vybraných/g, ""],
    [/ZOBRAZIŤ/g, "ZOBACZ"],
    [/Platba →/g, "Przejdź do kasy →"],
    [/v košíku/g, "w koszyku"],
    [/Subtotal/g, "Suma częściowa"],
    [/Checkout/g, "Przejdź do kasy"],
    [/Discount/g, "Rabat"],
    [/Krystaly/g, "Kryształy"],
    [/Zadarmo/g, "Gratis"],
    [/Krajina/g, "Krajobrazy"],
    [/Farba:/g, "Kolor:"],
    [/Zľava:/g, "Rabat:"],
    [/Zdarma/g, "Gratis"],
    [/Platba/g, "Płatność"],
    [/Pridať/g, "Dodaj"],
    [/Zľava/g, "Rabat"],
    [/zlatý/g, "złoty"],
    [/modrý/g, "niebieski"],
    [/Zlatá/g, "Złoty"],
    [/Modrý/g, "Niebieski"],
    [/Perly/g, "Perły"],
    [/Informácie o doručení/g, "Informacje o dostawie"],
    [/Kompatibilita s náramkami Pandora/g, "Kompatybilność z bransoletkami Pandora"],
    [/Vašu objednávku odosielame čo najskôr – doručenie zvyčajne trvá/g, "Twoje zamówienie wysyłamy jak najszybciej — dostawa zwykle trwa"],
    [/1 až 3 pracovné dni/g, "1–2 dni robocze"],
    [/Môžete si vybrať z dvoch možností doručenia:/g, "Możesz wybrać jeden z dwóch sposobów dostawy:"],
    [/Adresa doručenia/g, "Dostawa pod adres"],
    [/– balíček vám prinesie kuriér priamo domov alebo do práce\./g, "— kurier dostarczy paczkę bezpośrednio do domu lub pracy."],
    [/Výdajné miesto Packeta/g, "Paczkomat InPost 24/7"],
    [/– pohodlne si vyzdvihnete zásielku na niektorom z tisícok výdajných miest Packeta vo vašom okolí\./g, "— wygodnie odbierz przesyłkę w jednym z tysięcy Paczkomatów InPost w Twojej okolicy."],
    [/O sledovaní zásielky vás budeme informovať e-mailom aj SMS správou\./g, "Informacje o śledzeniu przesyłki otrzymasz e-mailem i SMS-em."],
    [/Ak hľadáte darček, naše prívesky sú/g, "Jeśli szukasz prezentu, nasze charmsy są"],
    [/Naše prívesky sú/g, "Nasze charmsy są"],
    [/plne kompatibilné s náramkami typu Pandora/g, "w pełni kompatybilne z bransoletkami typu Pandora"],
    [/aj inými populárnymi typmi náramkov s rovnakým mechanizmom\./g, "oraz innymi popularnymi rodzajami bransoletek z takim samym mechanizmem."],
    [/Môžete ich jednoducho navliecť a kombinovať podľa vlastného štýlu – hodia sa k strieborným, pozláteným aj koženým náramkom\./g, "Możesz je łatwo nawlekać i łączyć według swojego stylu — pasują do bransoletek srebrnych, pozłacanych i skórzanych."],
    [/ideálnym doplnkom ku náramkom Pandora/g, "idealnym dodatkiem do bransoletek Pandora"],
    [/Vyber si až 10 príveskov a pridaj ich do košíka spolu s náramkom/g, "Wybierz charmsy i dodaj je do koszyka razem z bransoletką"],
    [/Späť na kategórie/g, "Wróć do kategorii"],
    [/Pridaj šarmy do košíka/g, "Dodaj charmsy do koszyka"],
    [/(\d+) \/ 10 príveskov vybraných/g, "Wybrano: $1 charmsów"],
    [/Visiace Prívesky/g, "Wiszące charmsy"],
    [/Visiace prívesky/g, "Wiszące charmsy"],
    [/Prívesky/g, "Charmsy"],
    [/Pridať do košíka/g, "Dodaj do koszyka"],
    [/Vypredané/g, "Wyprzedane"],
    [/Vybrať variant/g, "Wybierz wariant"],
    [/Kompatibilné s náramkami /g, "Pasuje do bransoletek "],
    [/, Charma, Apart a ďalšími značkami s prievlakom 4 mm/g, ", Charma, Apart i innych marek o średnicy otworu 4 mm"],
    [/Tento darček je už uplatnený\. Ďalší náramok získate pri 7 ďalších príveskoch\./g, "Ten prezent został już odebrany. Kolejną bransoletkę otrzymasz za następne 7 charmsów."],
    [/Náramok zdarma už nie je k dispozícii/g, "Darmowa bransoletka nie jest już dostępna"],
    [/Vyberte si náramok Charma Italia zadarmo/g, "Wybierz bransoletkę Charma Italia gratis"],
    [/Vašich 7 príveskov odomklo darček/g, "Twoje 7 charmsów odblokowało prezent"],
    [/2\+1=4 — štvrtý šperk získate zadarmo/g, "3+1 — czwartą ozdobę otrzymasz gratis"],
    [/3\+1 ZADARMO — vyberte si 3 prívesky a 4\. máte od nás/g, "3+1 GRATIS — wybierz 3 charmsy, a czwarty otrzymasz od nas"],
    [/a získate 4\. ZADARMO/g, "a czwarty otrzymasz GRATIS"],
    [/Darček je váš! Vyberte si prívesok ZADARMO/g, "Prezent jest Twój! Wybierz charms GRATIS"],
    [/Váš darček je v košíku · Skontrolovať košík/g, "Twój prezent jest w koszyku · Sprawdź koszyk"],
    [/Doprava zadarmo od 49 €/g, "Darmowa dostawa od 149 zł"],
    [/Zatiaľ ste nepridali žiadne prívesky\./g, "Nie dodano jeszcze żadnych charmsów."],
    [/Máte nárok na náramok zdarma!/g, "Możesz odebrać bransoletkę gratis!"],
    [/Máte nárok na náramok zadarmo/g, "Możesz odebrać bransoletkę gratis"],
    [/Váš náramok je zadarmo/g, "Twoja bransoletka jest gratis"],
    [/Špeciálna ponuka k vašej objednávke/g, "Oferta specjalna do Twojego zamówienia"],
    [/Ponuka dostupná iba k tejto objednávke\./g, "Oferta dostępna tylko przy tym zamówieniu."],
    [/Akcia 3\+1: <b>kúpte 3 prívesky, 4\. máte zadarmo<\/b>/g, "Promocja 3+1: <b>kup 3 charmsy, a czwarty otrzymasz gratis</b>"],
    [/Teraz si vyberte/g, "Teraz wybierz"],
    [/máte od nás/g, "otrzymasz od nas"],
    [/Pridajte ešte/g, "Dodaj jeszcze"],
    [/Máte dopravu zadarmo/g, "Masz darmową dostawę"],
    [/a máte dopravu zadarmo/g, "i otrzymasz darmową dostawę"],
    [/Pridať náramok do košíka/g, "Dodaj bransoletkę do koszyka"],
    [/Pridané do košíka/g, "Dodano do koszyka"],
    [/Darček pridaný do košíka/g, "Prezent dodany do koszyka"],
    [/Zobraziť košík/g, "Zobacz koszyk"],
    [/Otvoriť košík/g, "Otwórz koszyk"],
    [/Prejsť k pokladni/g, "Przejdź do kasy"],
    [/Pokračovať vo výbere/g, "Kontynuuj wybór"],
    [/Vybrať náramok zdarma/g, "Wybierz bransoletkę gratis"],
    [/DARČEK ODOMKNUTÝ/g, "PREZENT ODBLOKOWANY"],
    [/ĎALŠÍ NÁRAMOK ZADARMO/g, "KOLEJNA BRANSOLETKA GRATIS"],
    [/NÁRAMOK ZADARMO/g, "BRANSOLETKA GRATIS"],
    [/NÁRAMKY ZADARMO/g, "BRANSOLETKI GRATIS"],
    [/náramok získaný/g, "odebrana bransoletka"],
    [/náramky získané/g, "odebrane bransoletki"],
    [/náramkov získaných/g, "odebranych bransoletek"],
    [/VAŠE PRÍVESKY/g, "TWOJE CHARMSY"],
    [/Vaše prívesky/g, "Twoje charmsy"],
    [/Doplňte svoj výber/g, "Uzupełnij swój wybór"],
    [/Vybrané pre vás/g, "Wybrane dla Ciebie"],
    [/Možno neskôr/g, "Może później"],
    [/Skúste znova/g, "Spróbuj ponownie"],
    [/Ružové zlato/g, "Różowe złoto"],
    [/Striebro/g, "Srebro"],
    [/Čierny/g, "Czarny"],
    [/Pridávam…/g, "Dodawanie…"],
    [/Pridané/g, "Dodano"],
    [/Pridať/g, "Dodaj"],
    [/Odstrániť/g, "Usuń"],
    [/Zobraziť/g, "Zobacz"],
    [/Zatvoriť/g, "Zamknij"],
    [/Zavrieť/g, "Zamknij"],
    [/Doprava zadarmo/g, "Darmowa dostawa"],
    [/Spolu:/g, "Razem:"],
    [/Ešte/g, "Jeszcze"],
    [/ešte/g, "jeszcze"],
    [/príveskov/g, "charmsów"],
    [/prívesky/g, "charmsy"],
    [/prívesok/g, "charms"],
    [/šperkov/g, "ozdób"],
    [/do náramku zdarma/g, "do bransoletki gratis"],
    [/náramok/g, "bransoletka"],
    [/darček/g, "prezent"],
    [/ZADARMO/g, "GRATIS"],
    [/zadarmo/g, "gratis"],
    [/pre tvoj náram/g, "do Twojej bransole"],
    [/(^|[^\d])1 přívěsků/g, "$11 charms"],
    [/(^|[^\d])([234]) přívěsků/g, "$1$2 charmsy"],
  ];
  var PL_EXACT = {"Strieborné":"Srebrne","Visiace prívesky":"Wiszące charmsy","Kvety":"Kwiaty","Motyle":"Motyle","Zvieratka":"Zwierzęta","Srdcia":"Serca","Ovocie":"Owoce","Stastie":"Szczęście","Masle":"Kokardki","Krize":"Krzyżyki","Pridané ✓":"Dodano ✓","Pridávam…":"Dodawanie…","Cena":"Cena","Zlaté":"Złote","ks":"szt.","čierny":"czarny"};

  window.CT_EXACT = function(s) {
    if ((!isCs && !isPl) || s == null) return s;
    var k = String(s).trim();
    var activeExact = isPl ? PL_EXACT : EXACT;
    return activeExact[k] ? String(s).replace(k, activeExact[k]) : window.CT(s);
  };

  window.CT = function(s) {
    if ((!isCs && !isPl) || s == null) return s;
    s = String(s);
    var activeRules = isPl ? PL_RULES : RULES;
    for (var i = 0; i < activeRules.length; i++) s = s.replace(activeRules[i][0], activeRules[i][1]);
    if (isPl) {
      s = s.replace(/href=(\"|')\/(products|collections|cart|checkout|policies|pages)(?=[\/?\"'])/g, 'href=$1/pl/$2');
      if (/^\/(products|collections|cart|checkout|policies|pages)(?:[\/?.]|$)/.test(s)) s = '/pl' + s;
    }
    return s;
  };

  // Kč bez halierov s medzerou v tisícoch, € s dvomi desatinnými miestami.
  window.charmaMoney = function(cents, short) {
    if (isCzk) {
      var k = Math.round((cents || 0) / 100);
      return String(k).replace(/\B(?=(\d{3})+(?!\d))/g, '\u202f') + '\u202fKč';
    }
    var e = ((cents || 0) / 100).toFixed(2).replace('.', ',');
    if (short) e = e.replace(/,00$/, '');
    return e + (cur === 'PLN' ? ' zł' : ' €');
  };

  if (isPl) {
    var localizedFetch = window.fetch;
    window.fetch = function(input, init) {
      if (typeof input === 'string' && /^\/(?:cart|products|collections|recommendations|search)(?:[/.?]|$)/.test(input)) input = '/pl' + input;
      return localizedFetch.call(this, input, init);
    };
  }

  window.CHARMA_L10N = {
    locale: loc,
    currency: cur,
    isCs: isCs,
    isPl: isPl,
    isCzk: isCzk,
    freeShipCents: isCzk ? 119900 : (cur === 'PLN' ? 14900 : 4900),             // 1 199 Kč / 49 €
    pickupPrice: isCzk ? '69 Kč' : (cur === 'PLN' ? '12,99 zł' : '2,49 €'),
    braceletPrice: isCzk ? '489 Kč' : '19,95 €'
  };
})();

// ============================================================
// 1. OPUS CART — блокируем автооткрытие при Add to Cart
// ============================================================

// ============================================================
// СТРАТЕГИЯ: opusOpen = всегда no-op, кроме клика иконки корзины
// Источник проблемы: cdn.506.io/eg/script.js вызывает opusOpen() напрямую
// ============================================================

// Флаг: разрешить opusOpen только когда юзер кликнул иконку корзины
window.__charmaAllowOpen = false;
var __charmaRealOpen = null;

// Перехватываем opusOpen ДО загрузки Opus
Object.defineProperty(window, 'opusOpen', {
  get: function() {
    return function() {
      if (window.__charmaAllowOpen && __charmaRealOpen) {
        __charmaRealOpen.apply(this, arguments);
      }
      // Иначе — тихо игнорируем
    };
  },
  set: function(fn) { __charmaRealOpen = fn; },
  configurable: true
});

// Официальный флаг Opus — тоже блокируем
window.opusFetchCartAdd = true;

(function() {
  // Shadow DOM — ДВА окремих CSS блоки:
  // 1. COSMETIC — завжди присутній (ховає бейджики, "+" кнопки)
  // 2. BLOCK — тільки коли drawer заблокований (ховає сам drawer)

  var CSS_COSMETIC_ID = 'charma-shadow-cosmetic';
  var CSS_BLOCK_ID = 'charma-shadow-block';

  var CSS_COSMETIC = [
    // Ховаємо бейджики знижок і ВСЕ що всередині (іконка + текст)
    '.cd-discount-code { display: none !important; }',
    '.cd-discount-truncate { display: none !important; }',
    '[class*="badge-cart"] { display: none !important; }',
    // Ховаємо іконки зі знижками в межах товарів кошика
    '.cd-product-item .cd-icon-container { display: none !important; }',
    '.cd-product-item .cd-icon-container-wrapper { display: none !important; }',
    '.cd-product-item [class*="cd-icon"] { display: none !important; }'
  ].join(' ');

  var CSS_BLOCK = '.opus-drawer-container { display: none !important; }';

  var allowShadow = false;

  function injectShadowCSS() {
    var host = document.getElementById('opus-shadow-container');
    if (!host || !host.shadowRoot) return;
    var sr = host.shadowRoot;

    // Завжди: косметичний CSS
    var cosmetic = sr.getElementById(CSS_COSMETIC_ID);
    if (cosmetic) {
      if (cosmetic.textContent !== CSS_COSMETIC) cosmetic.textContent = CSS_COSMETIC;
    } else {
      var s1 = document.createElement('style');
      s1.id = CSS_COSMETIC_ID;
      s1.textContent = CSS_COSMETIC;
      sr.appendChild(s1);
    }

    // Тільки коли drawer заблокований: блокуючий CSS
    if (!allowShadow) {
      if (!sr.getElementById(CSS_BLOCK_ID)) {
        var s2 = document.createElement('style');
        s2.id = CSS_BLOCK_ID;
        s2.textContent = CSS_BLOCK;
        sr.appendChild(s2);
      }
    }
  }

  function removeShadowCSS() {
    allowShadow = true;
    var host = document.getElementById('opus-shadow-container');
    if (!host || !host.shadowRoot) return;
    // Видаляємо ТІЛЬКИ блокуючий CSS, косметичний залишається!
    var s = host.shadowRoot.getElementById(CSS_BLOCK_ID);
    if (s) s.remove();
  }

  setInterval(injectShadowCSS, 300);
  new MutationObserver(injectShadowCSS).observe(document.body, { childList: true, subtree: true });

  // Полная последовательность событий реального тапа. Разные сборки Opus
  // открывают корзину по разным событиям: где-то по pointerdown, где-то
  // только по click. Голый el.click() шлёт ТОЛЬКО click — если сборка ждёт
  // pointerdown, первый тап уходит впустую и приходится жать второй раз.
  function fireTap(el) {
    var o = { bubbles: true, cancelable: true, composed: true };
    el.dispatchEvent(new PointerEvent('pointerdown', o));
    el.dispatchEvent(new MouseEvent('mousedown', o));
    el.dispatchEvent(new MouseEvent('mouseup', o));
    el.dispatchEvent(new MouseEvent('click', o));
  }

  function cartOpenTarget() {
    // ТОЛЬКО собственная кнопка Opus. #cart-icon-bubble сюда больше НЕ
    // попадает: это <a href="/cart">, и синтетический click по ней
    // открывает корзину лишь если приложение успело перехватить событие
    // и вызвать preventDefault. Если не успело — браузер просто уходит
    // на страницу /cart. Именно отсюда росли «нужно нажать два раза».
    return document.querySelector('.opus-section-sticky');
  }

  function cartIsOpen() {
    if (document.querySelector('.opus-drawer-container.open')) return true;
    var h = document.getElementById('opus-shadow-container');
    if (h && h.shadowRoot && h.shadowRoot.querySelector('.opus-drawer-container.open')) return true;
    return document.body.classList.contains('opus-modal-open');
  }

  // Глобальная функция открытия Opus корзины (используется из gift callback и др.)
  //
  // Главный путь — прямой вызов собственной функции Opus, которую мы
  // перехватили выше через setter window.opusOpen (__charmaRealOpen).
  // Никаких синтетических событий: не зависит от того, какое событие
  // слушает приложение, и не трогает ссылку <a href="/cart">, поэтому
  // браузер физически не может уйти на страницу корзины вместо ящика.
  function doOpen() {
    window.__charmaAllowOpen = true;
    removeShadowCSS(); // снимает block CSS и ставит allowShadow = true

    if (typeof __charmaRealOpen === 'function') {
      try { __charmaRealOpen(); return true; } catch (e) {}
    }
    var el = cartOpenTarget();
    if (el) { fireTap(el); return true; }
    return false;
  }

  window.charmaOpenCart = function() {
    if (!doOpen()) { window.location.href = '/cart'; return; }

    // Одна повторная попытка, если корзина не открылась. Проверка идёт
    // по классу .open в обоих DOM — так повтор не может закрыть уже
    // открытую корзину. Больше одного раза не повторяем.
    setTimeout(function() {
      if (cartIsOpen()) return;
      doOpen();
    }, 350);
  };

  // Клик по иконке корзины — разрешаем открытие
  // Слушаем mousedown + touchstart + click чтобы флаг ставился ДО того как Opus откроется
  function onCartIconInteraction(e) {
    // #charma-float-cart — плавающая кнопка корзины на мобиле.
    // Разблокировка срабатывает уже на mousedown/touchstart, то есть
    // раньше, чем её собственный обработчик click. Вторая страховка
    // к вызову charmaOpenCart() из самой кнопки.
    var cartIcon = e.target.closest('#cart-icon-bubble, #charma-float-cart, [href="/cart"], [class*="header__icon--cart"], [aria-label*="art"], [class*="cart-icon"]');
    if (cartIcon) {
      window.__charmaAllowOpen = true;
      __charmaOpenedAt = Date.now();
      removeShadowCSS();
    }
  }
  // CAPTURE fáza: flag sa musí nastaviť SKÔR, než Opus spracuje ťuknutie na
  // ikonu. Pri bubbling fáze Opus stihol pridať 'opus-modal-open' ešte pred
  // nastavením flagu, observer nižšie to vyhodnotil ako „auto-otvorenie“ a
  // triedu z body zmazal — košík bol otvorený bez svojho režimu, a na mobile
  // sa pri prvom otvorení nedalo scrollovať (po zatvorení a otvorení už áno).
  ['pointerdown', 'touchstart', 'mousedown', 'click'].forEach(function(t) {
    document.addEventListener(t, onCartIconInteraction, { capture: true, passive: true });
  });

  // Відстежуємо клас opus-modal-open на body
  var __charmaCloseTimer = null;
  var __charmaOpenedAt = 0;
  new MutationObserver(function() {
    var isOpen = document.body.classList.contains('opus-modal-open');
    if (isOpen) {
      // Корзина відкрита — скасовуємо таймер закриття
      clearTimeout(__charmaCloseTimer);
      if (!window.__charmaAllowOpen) {
        // Авто-відкриття заблоковано — знімаємо клас щоб не блокувати скрол
        document.body.classList.remove('opus-modal-open');
      }
    } else {
      // Корзина закрита — чекаємо перед скиданням (Opus може перерисовувати до 1.5с)
      clearTimeout(__charmaCloseTimer);
      __charmaCloseTimer = setTimeout(function() {
        // Додаткова перевірка: не скидати якщо корзина була відкрита менше 2с тому
        if (!document.body.classList.contains('opus-modal-open') && Date.now() - __charmaOpenedAt > 2000) {
          window.__charmaAllowOpen = false;
          allowShadow = false;
          injectShadowCSS();
        }
      }, 1500);
    }
  }).observe(document.body, { attributes: true, attributeFilter: ['class'] });

  // Оновлення лічильника корзини в хедері
  function updateCartBadge() {
    fetch('/cart.js', { cache: 'no-store' })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var count = cart.item_count;
        // Dawn cart bubble
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble) {
          var cb = bubble.querySelector('.cart-count-bubble');
          if (count > 0) {
            if (!cb) {
              cb = document.createElement('div');
              cb.className = 'cart-count-bubble';
              cb.innerHTML = '<span aria-hidden="true"></span><span class="visually-hidden"></span>';
              bubble.appendChild(cb);
            }
            var spans = cb.querySelectorAll('span');
            if (spans[0]) spans[0].textContent = count;
            if (spans[1]) spans[1].textContent = count + ' items';
          } else if (cb) {
            cb.remove();
          }
        }
        // Dawn PubSub — на случай если тема слушает событие
        if (window.publish && window.PUB_SUB_EVENTS) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', cart: cart });
        }
      }).catch(function() {});
  }

  // Функция показа тоста
  function shakeCartIcon() {
    var icon = document.getElementById('cart-icon-bubble');
    if (!icon) return;
    icon.classList.remove('charma-cart-shake');
    void icon.offsetWidth; // reflow to restart
    icon.classList.add('charma-cart-shake');
    setTimeout(function() { icon.classList.remove('charma-cart-shake'); }, 700);
  }

  // Shared toast renderer
  function _showToastEl(html, timeout) {
    var t = document.getElementById('charma-toast');
    if (t) { clearTimeout(t._hideTimer); t.remove(); }
    var el = document.createElement('div');
    el.id = 'charma-toast';
    el.style.cssText = [
      'position:fixed',
      'bottom:24px',
      'left:50%',
      'transform:translateX(-50%) translateY(100px)',
      'background:#044a40',
      'color:#fff',
      'border-radius:12px',
      'padding:12px 20px',
      'font-size:14px',
      'font-weight:600',
      'z-index:2147483647',
      'display:flex',
      'align-items:center',
      'gap:14px',
      'box-shadow:0 6px 24px rgba(0,0,0,0.18)',
      'opacity:0',
      'transition:transform 0.35s cubic-bezier(.22,1,.36,1), opacity 0.3s',
      'white-space:nowrap',
      'max-width:calc(100vw - 32px)'
    ].join(';');
    el.innerHTML = window.CT(html);
    document.body.appendChild(el);
    requestAnimationFrame(function() {
      requestAnimationFrame(function() {
        el.style.transform = 'translateX(-50%) translateY(0)';
        el.style.opacity = '1';
      });
    });
    el._hideTimer = setTimeout(function() {
      el.style.transform = 'translateX(-50%) translateY(100px)';
      el.style.opacity = '0';
      setTimeout(function() { if (el.parentNode) el.remove(); }, 350);
    }, timeout || 4000);
    return el;
  }

  function showToast() {
    updateCartBadge();
    shakeCartIcon();
    _showToastEl(
      '<span style="font-size:18px">✓</span>' +
      '<span>Pridané do košíka</span>' +
      '<button onclick="if(window.charmaOpenCart)window.charmaOpenCart();document.getElementById(\'charma-toast\').remove()" ' +
        'style="color:#C9A35D;background:none;border:none;font-size:14px;font-weight:600;cursor:pointer;white-space:nowrap;padding:0;margin-left:4px;text-decoration:underline;text-underline-offset:2px">' +
        'Zobraziť košík →</button>' +
      '<button onclick="this.parentElement.remove()" style="background:none;border:none;color:#fff;font-size:20px;cursor:pointer;line-height:1;padding:0;opacity:.6;margin-left:4px">×</button>'
    );
    if (window.charmaNomRefresh) window.charmaNomRefresh();
  }

  // Global toast — usable from gift popup and other sections
  window.charmaToast = function(text, isGift) {
    _showToastEl(
      '<span style="font-size:18px">' + (isGift ? '🎁' : '✓') + '</span>' +
      '<span>' + text + '</span>' +
      '<button onclick="this.parentElement.remove()" style="background:none;border:none;color:#fff;font-size:20px;cursor:pointer;line-height:1;padding:0;opacity:.6;margin-left:4px">×</button>',
      isGift ? 3500 : 4000
    );
  };

  // XHR перехват — ловим /cart/add через XHR (EGO Cart использует XHR)
  var origXHROpen = XMLHttpRequest.prototype.open;
  var origXHRSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function(method, url) {
    this._charmaUrl = url;
    return origXHROpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function() {
    var xhr = this;
    if (xhr._charmaUrl && xhr._charmaUrl.indexOf('/cart/add') !== -1) {
      xhr.addEventListener('load', function() {
        if (xhr.status >= 200 && xhr.status < 300) { showToast(); showBtnSuccess(); }
      });
    }
    return origXHRSend.apply(this, arguments);
  };

  // Відстежуємо останню натиснуту кнопку add-to-cart (Dawn + CBB + будь-яка інша)
  var _lastAddBtn = null;
  document.addEventListener('mousedown', function(e) {
    var btn = e.target.closest('button[name="add"], .incubate-collections-add-to-cart-add-to-cart-button, [class*="add-to-cart-button"]');
    if (btn) _lastAddBtn = btn;
  }, true);

  // Overlay поверх кнопки — не залежить від того що CBB робить всередині
  function showBtnSuccess() {
    clearTimeout(window._charmaSuccessTimer);
    clearTimeout(window._charmaSuccessTimer2);

    var btn = _lastAddBtn;
    if (!btn) return;

    // Видаляємо попередній overlay якщо є
    var old = document.getElementById('charma-btn-overlay');
    if (old && old.parentNode) old.parentNode.removeChild(old);

    var overlay = document.createElement('div');
    overlay.id = 'charma-btn-overlay';
    overlay.style.cssText = [
      'position:absolute',
      'top:0', 'left:0', 'width:100%', 'height:100%',
      'background:#044a40',
      'color:#fff',
      'display:flex', 'align-items:center', 'justify-content:center',
      'font-size:12px', 'font-weight:700',
      'border-radius:8px',
      'cursor:pointer',
      'z-index:99',
      'pointer-events:all',
      'transition:opacity 0.3s'
    ].join(';');
    overlay.textContent = window.CT('✓ Pridané');
    overlay.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      window.location.href = '/cart';
    });

    // Кнопка повинна бути position:relative для absolute overlay
    var origPosition = btn.style.position;
    btn.style.position = 'relative';
    btn.appendChild(overlay);

    // Прибираємо overlay через 4с
    window._charmaSuccessTimer2 = setTimeout(function() {
      overlay.style.opacity = '0';
      setTimeout(function() {
        if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
        btn.style.position = origPosition;
        _lastAddBtn = null;
      }, 300);
    }, 4000);
  }

  // Fetch перехват — на случай если кто-то использует fetch
  var origFetch = window.fetch;
  window.fetch = function() {
    var url = arguments[0];
    if (typeof url === 'string' && url.indexOf('cart/add') !== -1) {
      return origFetch.apply(this, arguments).then(function(res) {
        if (res.ok) { showToast(); showBtnSuccess(); }
        return res;
      });
    }
    return origFetch.apply(this, arguments);
  };

})();


// ============================================================
// 2. БАННЕР QAB — скрываем через 10 секунд
// ============================================================
(function() {
  function hideQab() {
    var bar = document.getElementById('qab_container') || document.getElementById('qab_background');
    if (bar) {
      bar.style.transition = 'opacity 0.5s';
      bar.style.opacity = '0';
      setTimeout(function() { bar.style.display = 'none'; }, 500);
      return true;
    }
    return false;
  }

  var qabObserver = new MutationObserver(function() {
    if (document.getElementById('qab_container') || document.getElementById('qab_background')) {
      qabObserver.disconnect();
      setTimeout(hideQab, 10000);
    }
  });
  qabObserver.observe(document.body, { childList: true, subtree: true });
  setTimeout(function() { if (!hideQab()) setTimeout(hideQab, 5000); }, 10000);
})();


// ============================================================
// 3. БАННЕР — подтягивание под высоту хедера
// ============================================================
function adjustBannerOffset() {
  const header = document.querySelector('header');
  const banner = document.querySelector('#Banner-template--24744238088529__image_banner');
  if (header && banner) {
    const headerHeight = header.offsetHeight;
    if (window.innerWidth > 900) {
      gsap.to(banner, { duration: 1, marginTop: '-' + headerHeight + 'px', paddingTop: headerHeight + 550 + 'px', ease: 'expo.out' });
    } else {
      gsap.to(banner, { duration: 1, marginTop: '-' + headerHeight + 'px', paddingTop: headerHeight + 'px', ease: 'expo.out' });
    }
  }
}
window.addEventListener('load', adjustBannerOffset);
window.addEventListener('resize', adjustBannerOffset);


// ============================================================
// 4. ХЕДЕР — прозрачный на главной, меняется при скролле
// ============================================================
document.addEventListener('DOMContentLoaded', function() {
  const stickyHeader = document.querySelector('sticky-header');
  const banner = document.querySelector('.banner');
  if (!stickyHeader || !banner) return;
  const updateHeaderClass = function() {
    if (window.pageYOffset === 0) {
      stickyHeader.classList.add('homepage-header');
    } else {
      stickyHeader.classList.remove('homepage-header');
    }
  };
  updateHeaderClass();
  window.addEventListener('scroll', updateHeaderClass);
});


// ============================================================
// 5. STICKY HEADER — фиксируем после загрузки, учитываем QAB баннер
// ============================================================
window.addEventListener('load', function() {
  var sh = document.querySelector('sticky-header');
  if (!sh) return;
  sh.style.position = 'fixed';
  sh.style.left = '0';
  sh.style.width = '100%';
  sh.style.zIndex = '100000'; // вище ніж bm-quick-buy-button (z-index:4) і будь-яких інших елементів

  function getQabHeight() {
    var total = 0;
    var ann = document.getElementById('charma-annbar');
    if (ann) total += ann.getBoundingClientRect().height || ann.offsetHeight || 0;
    var qab = document.getElementById('qab_background') || document.getElementById('qab_container');
    if (qab) {
      var cs = window.getComputedStyle(qab);
      if (cs.display !== 'none') total += qab.getBoundingClientRect().height || qab.offsetHeight || 0;
    }
    return total;
  }

  function updateHeaderTop() {
    var qabH = getQabHeight();
    var nextTop = qabH + 'px';
    var nextPadding = (sh.getBoundingClientRect().height + qabH) + 'px';
    if (sh.style.top !== nextTop) sh.style.top = nextTop;
    if (document.body.style.paddingTop !== nextPadding) document.body.style.paddingTop = nextPadding;
  }

  window.__charmaUpdateHeaderTop = updateHeaderTop;
  updateHeaderTop();
  setTimeout(updateHeaderTop, 300);
  setTimeout(updateHeaderTop, 800);
  setTimeout(updateHeaderTop, 2000);
  window.addEventListener('resize', updateHeaderTop);

  // Пересчитываем когда QAB скрывается
  var headerUpdateQueued = false;
  new MutationObserver(function (records) {
    var relevant = records.some(function (record) {
      return record.type === 'childList' || (record.target !== sh && record.target !== document.body);
    });
    if (!relevant || headerUpdateQueued) return;
    headerUpdateQueued = true;
    requestAnimationFrame(function () {
      headerUpdateQueued = false;
      updateHeaderTop();
    });
  }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] });
});


// ============================================================
// 6. MPS BUY ME — фикс z-index + AVADA COOKIE BAR стиль
// ============================================================
(function() {
  var style = document.createElement('style');
  style.textContent = [
    // Ховаємо нативний Shopify cart-notification (замість нього наш toast)
    'cart-notification { display: none !important; }',
    // AVADA Cookie Bar — мінімалістичний стиль (перебиває всі інлайн стилі)
    '#Avada-CookiesBar, #Avada-CookiesBar div, #Avada-CookiesBar [class*="BtnEnd"] { background-color: #ffffff !important; background: #ffffff !important; }',
    '#Avada-CookiesBar .Avada-CookiesFull_bar { border-top: 1px solid #e0e0e0 !important; box-shadow: 0 -2px 12px rgba(0,0,0,0.07) !important; padding: 10px 16px !important; }',
    '#Avada-CookiesBar .Avada-CookiesBar_Icon { display: none !important; }',
    '#Avada-CookiesBar .Avada-CookiesBar__MessageInner, #Avada-CookiesBar .Avada-CookiesBar__MessageInner span { color: #444 !important; font-size: 12px !important; }',
    '#Avada-CookiesBar .Avada-CookiesBar__PolicyWrapper a { color: #044a40 !important; font-weight: 500 !important; text-decoration: underline !important; font-size: 12px !important; }',
    '#Avada-CookiesBar .Avada-CookiesBar_BtnAgree { background-color: transparent !important; background: transparent !important; border: 1.5px solid #044a40 !important; border-radius: 6px !important; box-shadow: none !important; padding: 0 !important; }',
    '#Avada-CookiesBar .Avada-CookiesBar_AgreeButtonText { color: #044a40 !important; font-size: 12px !important; font-weight: 500 !important; padding: 5px 14px !important; }',
    '#Avada-CookiesBar .CookiesBar-Pop__Close svg, #Avada-CookiesBar .CookiesBar-Pop__Close svg path { stroke: #999 !important; fill: #999 !important; }',
    // Cart icon — тільки shake анімація (без зміни розміру)
    '#cart-icon-bubble { transform-origin: center center; }',
    '@keyframes charma-cart-shake { 0%,100%{transform:rotate(0)} 15%{transform:rotate(-18deg) scale(1.15)} 30%{transform:rotate(14deg) scale(1.1)} 45%{transform:rotate(-10deg)} 60%{transform:rotate(7deg)} 75%{transform:rotate(-4deg)} }',
    '#cart-icon-bubble.charma-cart-shake { animation: charma-cart-shake 0.6s ease; }',
    // CBB Add To Cart — outlined стиль
    '.incubate-collections-add-to-cart-add-to-cart-button { border-radius: 8px !important; background: transparent !important; border: 1.5px solid #044a40 !important; color: #044a40 !important; font-weight: 600 !important; transition: background .2s, color .2s !important; flex: 1 1 0 !important; min-width: 0 !important; font-size: 12px !important; white-space: nowrap !important; overflow: hidden !important; text-overflow: ellipsis !important; }',
    '.incubate-collections-add-to-cart-add-to-cart-button:hover { background: #044a40 !important; color: #fff !important; }',
    '.incubate-collections-add-to-cart-widget { border-radius: 8px !important; overflow: hidden; }',
    // CBB quantity selector — compact
    '.incubate-collections-add-to-cart-button-super-container { width: 100% !important; }',
    '.incubate-collections-add-to-cart-quantity-selector-container { flex-shrink: 0 !important; }',
    '.incubate-collections-add-to-cart-quantity-selector-minus-button { padding: 0 5px 0 6px !important; font-size: 13px !important; }',
    '.incubate-collections-add-to-cart-quantity-selector-plus-button { padding: 0 6px 0 5px !important; font-size: 13px !important; }',
    '.incubate-collections-add-to-cart-quantity-selector-input { width: 22px !important; font-size: 12px !important; }',
    // Chatbot — скрыть кнопку и окно полностью
    '#charma-chat-btn { display: none !important; }',
    '#charma-chat-window { display: none !important; }',
    // Opus sticky cart — поднять выше на мобиле
    '@media (max-width: 768px) { .opus-section-sticky.opus-bottom-right { bottom: 80px !important; } }'
  ].join('\n');
  document.head.appendChild(style);
})();


// ============================================================
// 7. ДЕСКТОП БАННЕР — замена изображения
// ============================================================
function replaceDesktopImage() {
  if (window.innerWidth > 900) {
    const bannerBlock = document.getElementById('Banner-template--24744238088529__image_banner');
    if (bannerBlock) {
      bannerBlock.classList.add('no-before');
      const bannerContentBlock = bannerBlock.querySelector('.banner__content--middle-center');
      if (bannerContentBlock) bannerContentBlock.style.display = 'none';
      const img = bannerBlock.querySelector('.banner__media.media img');
      if (img) {
        gsap.set(img, { opacity: 0 });
        gsap.to(img, { duration: 0.5, opacity: 1, ease: 'power1.out' });
        img.src = 'https://cdn.shopify.com/s/files/1/0607/1163/3101/files/ps5.png?v=1744463507';
        img.removeAttribute('srcset');
      }
      bannerBlock.style.paddingTop = '540px';
    }
  }
}
document.addEventListener('DOMContentLoaded', replaceDesktopImage);


// ============================================================
// 7. PROMO TEXT анимация
// ============================================================
document.addEventListener('DOMContentLoaded', function() {
  var promoSection = document.querySelector('.section-template--24744238252369__image_with_text_QqwHXn-padding');
  var promoEl = document.querySelector('#ImageWithText--template--24744238252369__image_with_text_QqwHXn');
  if (promoSection) promoSection.classList.remove('page-width');
  if (promoEl) promoEl.classList.add('promo-text');

  if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
    gsap.registerPlugin(ScrollTrigger);
    gsap.from('.promo-text', {
      opacity: 0, y: 20, duration: 2, ease: 'power2.out', stagger: 0.4,
      scrollTrigger: { trigger: '.promo-text', start: 'top 80%', toggleActions: 'play none none none' }
    });
    gsap.to('.promo-text', { color: '#058271', duration: 4, repeat: -1, yoyo: true, ease: 'power1.inOut' });
  }
});


// ============================================================
// 7b. REWARD ENTITLEMENT — single source of truth for the 7+1 promotion
//     Entitlement = floor(eligibleCharmQty / 7). Enforced in cart logic, not
//     just in the UI: every claim re-validates against a fresh cart, and any
//     excess free bracelet is reconciled away automatically.
// ============================================================
(function() {
  var THRESHOLD = 7;
  // Všetkých 5 náramkov akcie 7+1 (musí sedieť so zľavou „Charma 7+1 — náramok zadarmo“)
  var GIFT_VARIANT_IDS = [
    51879076594001, // silver
    51879089340753, // golden
    51879096779089, // rose gold
    54987325702481, // blue
    54987325800785  // black
  ];
  window.CHARMA_BRACELET_VIDS = GIFT_VARIANT_IDS;

  var PROMO_MARK = 'charma_7_plus_1';

  function isCharmSku(sku) { return /^(ACC|A\d)/i.test(sku || ''); }

  // A line is a promotional reward ONLY when it carries the marker written at
  // claim time. Price is deliberately NOT part of this test: the reward
  // discount zeroes the bracelet variant, so a price-based check would label a
  // normally purchased bracelet as a reward — and reconcile() would then delete
  // an item the customer actually paid for. Entitlement and purchasing are
  // separate concepts and must never be inferred from each other.
  function isPromoLine(i) {
    var p = i.properties || {};
    if (p._promo_reward === PROMO_MARK) return true;
    return p._gift === 'true' || p._gift === true;   // legacy carts
  }

  // Paid units of the very same variant — never touched by the promotion.
  function isPaidBracelet(i) {
    return !isPromoLine(i) && GIFT_VARIANT_IDS.indexOf(i.variant_id) !== -1;
  }

  function read(cart) {
    var items = (cart && cart.items) || [];
    var charmQty = 0, current = 0, paid = 0, promoLines = [];
    items.forEach(function(i) {
      if (isPromoLine(i)) {
        current += i.quantity;
        promoLines.push({ key: i.key, qty: i.quantity });
        return;                       // promo bracelets never count as charms
      }
      // Paid bracelets are counted for visibility and then skipped. The bracelet
      // SKUs (ACC250–ACC255) match the charm pattern, so without this return a
      // paid bracelet would inflate charmQty and could hand out a free one.
      if (isPaidBracelet(i)) { paid += i.quantity; return; }
      if (isCharmSku(i.sku)) charmQty += i.quantity;
    });
    var allowed = Math.floor(charmQty / THRESHOLD);
    return {
      charmQty:       charmQty,
      allowed:        allowed,
      current:        current,       // marked reward units only
      paidBracelets:  paid,          // bracelets the customer added themselves
      // A bracelet the customer already chose (any of the 5 colours) is made
      // free by the automatic discount itself, so it covers the reward: the
      // picker must not offer a second bracelet. Paid lines are never removed.
      coveredByPaid:  Math.min(paid, Math.max(0, allowed - current)),
      canAdd:         current + paid < allowed,
      excess:         Math.max(0, current - allowed),
      promoLines:     promoLines     // only marked lines are ever modified
    };
  }

  function fetchState() {
    return fetch('/cart.js', { cache: 'no-store' })
      .then(function(r) { return r.json(); })
      .then(read);
  }

  function notify() {
    if (window.charmaNomRefresh) window.charmaNomRefresh();
    fetch('/cart.js', { cache: 'no-store' })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        ['cart:updated', 'cart:refresh', 'on:cart:update'].forEach(function(ev) {
          document.dispatchEvent(new CustomEvent(ev, { bubbles: true, detail: { cart: cart } }));
        });
        document.dispatchEvent(new CustomEvent('cart-drawer:refresh', { bubbles: true }));
      }).catch(function() {});
  }

  // Removing charms revokes entitlement — strip the bracelets that are no
  // longer earned. Runs on load, cart changes, drawer open and tab focus, so a
  // second tab or a page refresh cannot leave an unearned free bracelet behind.
  var _busy = false;
  function reconcile() {
    if (_busy) return Promise.resolve(null);
    _busy = true;
    return fetchState().then(function(st) {
      if (st.excess <= 0) { _busy = false; return st; }
      var toRemove = st.excess;
      var chain = Promise.resolve();
      st.promoLines.slice().reverse().forEach(function(line) {
        if (toRemove <= 0) return;
        var take = Math.min(toRemove, line.qty);
        var newQty = line.qty - take;
        toRemove -= take;
        chain = chain.then(function() {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: line.key, quantity: newQty })
          }).then(function(r) { return r.json(); });
        });
      });
      return chain.then(function() {
        _busy = false;
        notify();
        if (window.charmaToast) window.charmaToast('Náramok zdarma už nie je k dispozícii');
        return fetchState();
      });
    }).catch(function() { _busy = false; return null; });
  }

  // Claim one free bracelet. Re-validates against a fresh cart at click time,
  // holds a lock for the whole round trip, and trims immediately if a race
  // still slipped a second one through.
  var _adding = false;
  function claim(variantId) {
    if (_adding) return Promise.resolve({ ok: false, reason: 'busy' });
    _adding = true;
    return fetchState()
      .then(function(st) {
        if (!st.canAdd) return { ok: false, reason: 'not_entitled', state: st };
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          // Two markers: _promo_reward is the canonical one, _gift is kept so
          // the existing reward-bar code keeps recognising the line. Because a
          // paid bracelet carries no properties, Shopify cannot merge the two
          // into one line — free and paid units stay separate and keep their
          // own pricing and reward identity.
          body: JSON.stringify({
            id: variantId,
            quantity: 1,
            properties: { _promo_reward: PROMO_MARK, _gift: 'true' }
          })
        })
        .then(function(r) { return r.json(); })
        .then(function(data) {
          if (!(data && (data.id || data.variant_id))) return { ok: false, reason: 'add_failed' };
          return fetchState().then(function(after) {
            if (after.excess > 0) {
              return reconcile().then(function() { return { ok: false, reason: 'raced' }; });
            }
            return { ok: true, state: after };
          });
        });
      })
      .then(function(res) { _adding = false; return res; })
      .catch(function() { _adding = false; return { ok: false, reason: 'error' }; });
  }

  window.CharmaReward = {
    THRESHOLD:  THRESHOLD,
    read:       read,
    fetchState: fetchState,
    reconcile:  reconcile,
    claim:      claim,
    notify:     notify,
    isPromoLine:isPromoLine
  };

  // ── Validation triggers ──────────────────────────────────────────────────
  var t = null;
  function schedule() { clearTimeout(t); t = setTimeout(reconcile, 450); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
  ['cart:updated', 'cart:refresh', 'on:cart:update', 'cart-drawer:refresh'].forEach(function(ev) {
    document.addEventListener(ev, schedule);
  });
  if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
    window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, schedule);
  }
  // Returning from another tab that may have changed the cart
  document.addEventListener('visibilitychange', function() {
    if (!document.hidden) schedule();
  });
  // Cart drawer opening
  new MutationObserver(function() {
    if (document.body.classList.contains('opus-modal-open')) schedule();
  }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  // Fallback: cart badge changes
  var prevCount = -1;
  setInterval(function() {
    var sp = document.querySelector('#cart-icon-bubble .cart-count-bubble span[aria-hidden]');
    var c = sp ? (parseInt(sp.textContent) || 0) : 0;
    if (c !== prevCount) { prevCount = c; schedule(); }
  }, 2000);
})();

// ============================================================
// 8. GIFT BRACELET — inject inside Opus cart shadow DOM
// ============================================================
(function() {
  var GIFT_THRESHOLD = 7;
  var GIFT_VID = {
    silver: 51879076594001,
    gold:   51879089340753,
    rose:   51879096779089,
    blue:   54987325702481,
    black:  54987325800785
  };
  var GIFT_IMG = {
    silver: 'https://cdn.shopify.com/s/files/1/0607/1163/3101/files/IMG-9740.png?v=1772027408',
    gold:   'https://cdn.shopify.com/s/files/1/0607/1163/3101/files/IMG_9978.png?v=1772651620',
    rose:   'https://cdn.shopify.com/s/files/1/0607/1163/3101/files/IMG_3194.jpg?v=1760791197&width=200',
    blue:   'https://cdn.shopify.com/s/files/1/0607/1163/3101/files/IMG_5437.jpg?v=1789650721&width=200',
    black:  'https://cdn.shopify.com/s/files/1/0607/1163/3101/files/IMG_5438.jpg?v=1789650699&width=200'
  };
  var GIFT_ORDER = [
    ['silver', 'Striebro'],
    ['gold',   'Zlato'],
    ['rose',   'Ružové zlato'],
    ['blue',   'Modrý'],
    ['black',  'Čierny']
  ];

  // Nomination SKU detection: ACC*, A + digit (A304, A319, etc.)
  // CHC* sú hodinky/náramky, nie prívesky — do 7+1 sa nerátajú (ani v zľave Shopify)
  function isNomination(sku) {
    return /^(ACC|A\d)/i.test(sku || '');
  }

  // ── Inject popup styles once ────────────────────────────────
  function injectGiftStyles() {
    if (document.getElementById('cg-styles')) return;
    var s = document.createElement('style');
    s.id = 'cg-styles';
    s.textContent = [
      '#cg-overlay{position:fixed;inset:0;background:rgba(20,25,23,.55);',
      'backdrop-filter:blur(3px);-webkit-backdrop-filter:blur(3px);',
      'z-index:9999999;display:flex;align-items:center;justify-content:center;',
      'padding:16px;box-sizing:border-box}',

      '#cg-wrap{background:#F8F6F1;border-radius:22px;padding:26px 20px 22px;',
      'width:100%;max-width:390px;box-shadow:0 32px 80px rgba(0,0,0,.18);',
      'position:relative;box-sizing:border-box;font-family:inherit;',
      'animation:cg-in .24s cubic-bezier(.22,.8,.36,1)}',

      '@keyframes cg-in{from{opacity:0;transform:scale(.96)}to{opacity:1;transform:scale(1)}}',

      '#cg-close{position:absolute;top:14px;right:16px;background:none;border:none;',
      'color:#aaa;cursor:pointer;padding:4px;border-radius:50%;line-height:0;',
      'display:flex;align-items:center;justify-content:center;',
      'transition:color .15s,background .15s}',
      '#cg-close:hover{color:#444;background:rgba(0,0,0,.06)}',

      '.cg-header{text-align:center;margin-bottom:16px}',
      '.cg-icon{color:#C8A15A;margin-bottom:8px;line-height:0}',
      '.cg-title{font-size:28px;font-weight:800;color:#00594F;margin:0 0 6px;',
      'letter-spacing:-.025em;line-height:1.1}',
      '.cg-subtitle{font-size:14px;color:#444;margin:0 0 10px;line-height:1.4}',
      '.cg-divider{display:flex;align-items:center;gap:8px;margin:0}',
      '.cg-divider::before,.cg-divider::after{content:"";flex:1;height:1px;background:#C8A15A;opacity:.35}',
      '.cg-divider span{font-size:9px;letter-spacing:.14em;text-transform:uppercase;',
      'color:#C8A15A;white-space:nowrap}',

      '.cg-options{display:flex;flex-wrap:wrap;justify-content:center;gap:8px;margin-bottom:14px}',

      '.cg-opt{flex:0 0 calc((100% - 16px)/3);box-sizing:border-box;border:1.5px solid #DDD9D3;border-radius:14px;',
      'padding:10px 6px 9px;text-align:center;cursor:pointer;background:#fff;',
      'position:relative;transition:border-color .2s,background .2s;',
      '-webkit-tap-highlight-color:transparent;outline:none}',
      '.cg-opt:focus-visible{outline:2px solid #00594F;outline-offset:2px}',
      '.cg-opt.is-selected{border-color:#00594F;border-width:2px;background:#EFF5F4}',

      '.cg-check{position:absolute;top:9px;right:9px;width:20px;height:20px;',
      'border-radius:50%;background:#E0DDD8;display:flex;align-items:center;',
      'justify-content:center;transition:background .2s}',
      '.cg-opt.is-selected .cg-check{background:#00594F}',
      '.cg-check svg{opacity:0;transition:opacity .15s}',
      '.cg-opt.is-selected .cg-check svg{opacity:1}',

      '.cg-img{width:100%;max-width:76px;aspect-ratio:1/1;height:auto;object-fit:cover;border-radius:9px;',
      'display:block;margin:0 auto 7px}',

      '.cg-name{font-size:11px;font-weight:600;color:#202020;margin:0 0 3px;line-height:1.3}',
      '.cg-price-old{font-size:10.5px;color:#c0bbb5;text-decoration:line-through;margin:0 0 2px}',
      '.cg-free{font-size:11px;font-weight:700;color:#00594F;letter-spacing:.05em;margin:0}',
      '.cg-check{top:6px!important;right:6px!important;width:18px!important;height:18px!important}',

      '#cg-btn{width:100%;height:52px;background:#00594F;color:#fff;border:none;',
      'border-radius:100px;font-size:14px;font-weight:600;letter-spacing:.02em;',
      'cursor:pointer;display:flex;align-items:center;justify-content:center;gap:9px;',
      'transition:background .2s,opacity .2s;margin-bottom:10px;font-family:inherit;',
      '-webkit-tap-highlight-color:transparent}',
      '#cg-btn:disabled{opacity:.4;cursor:default}',
      '#cg-btn:not(:disabled):hover{background:#044a40}',
      '#cg-btn:focus-visible{outline:2px solid #C8A15A;outline-offset:2px}',

      '#cg-later{width:100%;background:none;border:none;color:#888;font-size:13px;',
      'cursor:pointer;text-decoration:underline;text-underline-offset:3px;',
      'padding:0;font-family:inherit;transition:color .15s}',
      '#cg-later:hover{color:#444}'
    ].join('');
    document.head.appendChild(s);
  }

  var _laterUntil = 0; // timestamp: skip popup until this time

  function injectGift() {
    if (document.getElementById('cg-overlay')) return;
    injectGiftStyles();

    var overlay = document.createElement('div');
    overlay.id = 'cg-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-labelledby', 'cg-title');

    var GIFT_SVG =
      '<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">' +
        '<rect x="3" y="13" width="26" height="17" rx="2" stroke="currentColor" stroke-width="1.8" fill="none"/>' +
        '<rect x="1" y="9" width="30" height="5" rx="1.5" stroke="currentColor" stroke-width="1.8" fill="none"/>' +
        '<line x1="16" y1="9" x2="16" y2="30" stroke="currentColor" stroke-width="1.8"/>' +
        '<path d="M16 9 C16 9 12 7 12 4.5 C12 3 13 2 14.5 2 C16 2 16 4 16 4 C16 4 16 2 17.5 2 C19 2 20 3 20 4.5 C20 7 16 9 16 9Z" stroke="currentColor" stroke-width="1.8" fill="none" stroke-linejoin="round"/>' +
      '</svg>';

    var CHECK_SVG =
      '<svg width="11" height="8" viewBox="0 0 11 8" fill="none" xmlns="http://www.w3.org/2000/svg">' +
        '<path d="M1 3.5L4 6.5L10 1" stroke="white" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg>';

    var CLOSE_SVG =
      '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">' +
        '<path d="M2 2L14 14M14 2L2 14" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>' +
      '</svg>';

    var BAG_SVG =
      '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">' +
        '<path d="M3 5.5h12l-1.5 9H4.5L3 5.5Z" stroke="white" stroke-width="1.5" fill="none"/>' +
        '<path d="M6.5 5.5V4a2.5 2.5 0 015 0v1.5" stroke="white" stroke-width="1.5" stroke-linecap="round" fill="none"/>' +
      '</svg>';

    function card(type, label, img) {
      return '<div class="cg-opt" data-type="' + type + '" role="radio" aria-checked="false" tabindex="0">' +
        '<div class="cg-check">' + CHECK_SVG + '</div>' +
        '<img src="' + img + '" class="cg-img" alt="Charma Italia ' + label + '" loading="eager">' +
        '<p class="cg-name">Charma Italia<br>' + label + '</p>' +
        '<p class="cg-price-old">' + window.CHARMA_L10N.braceletPrice + '</p>' +
        '<p class="cg-free">ZADARMO</p>' +
        '</div>';
    }

    overlay.innerHTML = window.CT(
      '<div id="cg-wrap">' +
        '<button id="cg-close" aria-label="Zatvoriť">' + CLOSE_SVG + '</button>' +
        '<div class="cg-header">' +
          '<div class="cg-icon">' + GIFT_SVG + '</div>' +
          '<h2 id="cg-title" class="cg-title">Gratulujeme!</h2>' +
          '<p class="cg-subtitle">Vyberte si náramok Charma Italia zadarmo</p>' +
          '<p class="cg-divider"><span>Vašich 7 príveskov odomklo darček</span></p>' +
        '</div>' +
        '<div class="cg-options">' +
          GIFT_ORDER.map(function(g) { return card(g[0], g[1], GIFT_IMG[g[0]]); }).join('') +
        '</div>' +
        '<button id="cg-btn" disabled>' + BAG_SVG + '<span>Pridať náramok do košíka</span></button>' +
        '<button id="cg-later">Možno neskôr</button>' +
      '</div>');

    document.body.appendChild(overlay);
    document.body.style.overflow = 'hidden';

    var wrap = document.getElementById('cg-wrap');
    var btn  = document.getElementById('cg-btn');
    var btnLabel = btn.querySelector('span');
    var selType  = null;

    function closeOverlay() {
      overlay.remove();
      document.body.style.overflow = '';
    }

    // Close handlers
    document.getElementById('cg-close').addEventListener('click', closeOverlay);
    overlay.addEventListener('click', function(e) { if (e.target === overlay) closeOverlay(); });
    document.addEventListener('keydown', function onEsc(e) {
      if (e.key === 'Escape') { closeOverlay(); document.removeEventListener('keydown', onEsc); }
    });

    // "Možno neskôr" — suppress for 10 min
    document.getElementById('cg-later').addEventListener('click', function() {
      _laterUntil = Date.now() + 10 * 60 * 1000;
      closeOverlay();
    });

    // Card selection (click + keyboard)
    wrap.querySelectorAll('.cg-opt').forEach(function(opt) {
      function select() {
        wrap.querySelectorAll('.cg-opt').forEach(function(o) {
          o.classList.remove('is-selected');
          o.setAttribute('aria-checked', 'false');
        });
        opt.classList.add('is-selected');
        opt.setAttribute('aria-checked', 'true');
        selType = opt.getAttribute('data-type');
        btn.disabled = false;
      }
      opt.addEventListener('click', select);
      opt.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); select(); }
      });
    });

    // Add to cart
    btn.addEventListener('click', function() {
      if (!selType || btn.disabled) return;
      btn.disabled = true;
      btnLabel.textContent = window.CT('Pridávam…');

      // Entitlement is re-checked against a fresh cart inside claim(), so a
      // stale modal, a double click or a second tab cannot over-claim.
      window.CharmaReward.claim(GIFT_VID[selType]).then(function(res) {
        if (res && res.ok) {
          // No discount code is applied here any more. Pricing is owned by the
          // Shopify automatic Buy-X-Get-Y discount "Charma 7+1 — náramok
          // zadarmo", which zeroes exactly one bracelet unit per 7 charms.
          // The old CHARMA-GIFT10 code was a flat 100%-off on both bracelet
          // products with no quantity cap, so it also zeroed bracelets the
          // customer had already paid for.
          closeOverlay();
          selType = null;
          if (window.charmaNomRefresh) window.charmaNomRefresh();
          if (window.charmaToast) { window.charmaToast('Darček pridaný do košíka', true); }
          // Re-fetch after the discount lands so the free-shipping bar sees €0
          setTimeout(function() {
            window.CharmaReward.notify();
            if (window.Shopify && window.Shopify.onError === undefined) {
              fetch('/cart?section_id=cart-free-shipping').catch(function(){});
            }
          }, 800);
          return;
        }

        var reason = res && res.reason;
        if (reason === 'not_entitled' || reason === 'raced' || reason === 'busy') {
          // Already consumed — close and tell the customer why
          closeOverlay();
          selType = null;
          if (window.charmaNomRefresh) window.charmaNomRefresh();
          if (window.charmaToast) {
            window.charmaToast('Tento darček je už uplatnený. Ďalší náramok získate pri 7 ďalších príveskoch.');
          }
          return;
        }
        // Network / add failure — let them retry
        btn.disabled = false;
        btnLabel.textContent = window.CT('Pridať náramok do košíka');
      });
    });
  }

  function removeGift() {
    var el = document.getElementById('cg-overlay');
    if (el) { el.remove(); document.body.style.overflow = ''; }
  }

  function checkAndInject() {
    if (Date.now() < _laterUntil) return; // user clicked "Možno neskôr"
    // Same entitlement source as the claim itself, so the picker can never be
    // shown for a reward that is already consumed.
    window.CharmaReward.fetchState()
      .then(function(st) {
        if (st.canAdd) injectGift();
        else removeGift();
      }).catch(function() {});
  }

  // Expose for manual trigger
  window.charmaCheckGift = checkAndInject;

  // Watch body class for opus-modal-open
  new MutationObserver(function() {
    if (document.body.classList.contains('opus-modal-open')) {
      setTimeout(checkAndInject, 400);
    }
  }).observe(document.body, { attributes: true, attributeFilter: ['class'] });

  // Watch shadow DOM for re-renders by Opus
  function watchSR() {
    var h = document.getElementById('opus-shadow-container');
    if (!h || !h.shadowRoot) { setTimeout(watchSR, 500); return; }
    var lastCheck = 0;
    new MutationObserver(function() {
      if (!document.body.classList.contains('opus-modal-open')) return;
      var now = Date.now();
      if (now - lastCheck < 600) return;
      lastCheck = now;
      setTimeout(checkAndInject, 300);
    }).observe(h.shadowRoot, { childList: true, subtree: true });
  }
  watchSR();
})();


// ============================================================
// 9. PANDORA COMPATIBILITY BADGE — бейдж сумісності для SCC товарів
// ============================================================
(function() {
  if (!document.querySelector('.product')) return;

  // Отримуємо handle з URL
  var match = window.location.pathname.match(/\/products\/([^/?]+)/);
  if (!match) return;
  var handle = match[1];

  fetch('/products/' + handle + '.js')
    .then(function(r) { return r.json(); })
    .then(function(product) {
      // Показуємо бейдж для всіх товарів з тегом Charms (колекція Korálky)
      var isCharms = product.tags && product.tags.indexOf('Charms') !== -1;
      if (!isCharms) return;

      // Перевіряємо чи вже є бейдж або текст про Pandora
      var desc = document.querySelector('.product__description, .product-description, [class*="description"]');
      // Inject бейдж — знаходимо ціну і вставляємо після неї
      var priceEl = document.querySelector('.price.price--large, .price--large, .price');
      if (!priceEl) return;

      var badge = document.createElement('div');
      badge.id = 'charma-compat-badge';
      badge.style.cssText = [
        'display:flex',
        'align-items:center',
        'gap:8px',
        'background:#F3F1EE',
        'border:1px solid #E2DDD8',
        'border-radius:8px',
        'padding:10px 14px',
        'margin:12px 0',
        'font-size:13px',
        'color:#171717',
        'font-weight:500',
        'line-height:1.4'
      ].join(';');
      badge.innerHTML =
        '<span style="font-size:20px;flex-shrink:0">🔗</span>' +
        window.CT('<span>Kompatibilné s náramkami <strong>Pandora</strong>, Charma, Apart a ďalšími značkami s prievlakom 4 mm</span>');

      priceEl.insertAdjacentElement('afterend', badge);
    })
    .catch(function() {});
})();


// ============================================================
// 10. STICKY CHECKOUT — фіксована кнопка "Платба" в корзині
// ============================================================
(function() {
  if (!/\/(?:cart)$/.test(window.location.pathname)) return;

  function initStickyCheckout() {
    fetch('/cart.js', { cache: 'no-store' })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        if (cart.item_count === 0) return;

        var price = (cart.total_price / 100).toFixed(2).replace('.', ',');

        var bar = document.createElement('div');
        bar.id = 'charma-sticky-checkout';
        bar.style.cssText = [
          'position:fixed',
          'bottom:0',
          'left:0',
          'width:100%',
          'z-index:99997',
          'padding:12px 20px',
          'background:#fff',
          'border-top:1px solid #e0e0e0',
          'box-shadow:0 -4px 20px rgba(0,0,0,0.10)',
          'display:flex',
          'align-items:center',
          'justify-content:space-between',
          'gap:12px',
          'box-sizing:border-box'
        ].join(';');
        price = window.charmaMoney(cart.total_price);
        bar.innerHTML = window.CT(
          '<span style="font-size:14px;color:#555;font-weight:500">Spolu: <strong style="color:#1a1a1a;font-size:16px">' + price + '</strong></span>' +
          '<a href="/checkout" style="background:#044a40;color:#fff;padding:12px 32px;border-radius:8px;font-size:15px;font-weight:700;text-decoration:none;white-space:nowrap;letter-spacing:.02em">Platba →</a>');
        document.body.appendChild(bar);

        // Враховуємо висоту cookie-бару якщо він є
        var cookieBar = document.getElementById('Avada-CookiesBar');
        var cookieH = (cookieBar && cookieBar.offsetHeight) ? cookieBar.offsetHeight : 0;
        bar.style.bottom = cookieH + 'px';

        // Падінг щоб контент не ховався за sticky bar
        var h = bar.getBoundingClientRect().height;
        document.body.style.paddingBottom = (h + cookieH + 8) + 'px';

        // Ховаємо якщо нативна кнопка видима у viewport
        var nativeBtn = document.querySelector('[name="checkout"], a[href="/checkout"]');
        if (nativeBtn) {
          var obs = new IntersectionObserver(function(entries) {
            bar.style.opacity = entries[0].isIntersecting ? '0' : '1';
            bar.style.pointerEvents = entries[0].isIntersecting ? 'none' : 'auto';
          }, { threshold: 0.5 });
          obs.observe(nativeBtn);
        }
      }).catch(function() {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyCheckout);
  } else {
    setTimeout(initStickyCheckout, 500);
  }
})();


// ============================================================
// 10. ANNOUNCEMENT BAR — динамический баннер с 3 акциями
// ============================================================
(function() {
  var giftSVG = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" style="display:inline-block;vertical-align:middle;margin-right:5px;margin-top:-2px"><polyline points="20 12 20 22 4 22 4 12"/><rect x="2" y="7" width="20" height="5"/><line x1="12" y1="22" x2="12" y2="7"/><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/></svg>';
  var msgs = [
    { id: 'pandora31', text: giftSVG + '2+1=4 — štvrtý šperk získate zadarmo', link: null },
    { id: 'italia71',  text: '7 príveskov Charma Italia = náramok zadarmo', link: '/collections/nomination-1' },
    { id: 'shipping',  text: 'Doprava zadarmo od 49 €', link: null }
  ];
  var idx = 0, timer = null;

  var style = document.createElement('style');
  style.textContent = [
    '#charma-annbar{position:fixed;top:0;left:0;width:100%;z-index:99998;background:#044a40;color:#fff;min-height:46px;display:flex;align-items:center;justify-content:center;font-family:var(--font-body-family,inherit);font-size:14px;font-weight:var(--font-body-weight,500);letter-spacing:.04em;box-sizing:border-box}',
    '#charma-annbar .ann-inner{display:flex;align-items:center;width:100%;justify-content:center;padding:10px 48px;box-sizing:border-box;position:relative}',
    '#charma-annbar .ann-text{text-align:center;flex:1;opacity:1;transition:opacity .3s ease;line-height:1.3}',
    '#charma-annbar .ann-text a{color:#fff;text-decoration:none;cursor:pointer}',
    '#charma-annbar .ann-text a:hover{opacity:.85}',
    '#charma-annbar .ann-btn{background:none;border:none;color:#fff;cursor:pointer;font-size:22px;line-height:1;padding:4px 10px;opacity:.55;transition:opacity .2s;position:absolute;top:50%;transform:translateY(-50%)}',
    '#charma-annbar .ann-btn:hover{opacity:1}',
    '#charma-annbar .ann-prev{left:6px}',
    '#charma-annbar .ann-next{right:6px}',
    '@media(max-width:600px){#charma-annbar{font-size:13px}#charma-annbar .ann-inner{padding:8px 36px}#charma-annbar .ann-text{white-space:normal;line-height:1.4}}',
    /* ── režim 3+1: jedna správa + tenký progres, bez šípok ── */
    '#charma-annbar.is-promo31{min-height:46px}',
    '#charma-annbar.is-promo31.is-clickable{cursor:pointer;-webkit-tap-highlight-color:transparent}',
    '#charma-annbar.is-promo31.is-clickable:focus-visible{outline:2px solid #C8A15A;outline-offset:-3px}',
    '#charma-annbar.is-promo31 .ann-inner{padding:9px 16px}',
    '#charma-annbar .ann-31{display:inline-flex;align-items:center;gap:10px;justify-content:center;max-width:100%}',
    '#charma-annbar .ann-31-txt{line-height:1.3;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}',
    '#charma-annbar .ann-31-prog{display:inline-flex;align-items:center;gap:4px;flex:0 0 auto}',
    '#charma-annbar .ann-dot{width:5px;height:5px;border-radius:50%;background:rgba(255,255,255,.3);display:inline-block;transition:background .25s ease}',
    '#charma-annbar .ann-dot.is-on{background:#C8A15A}',
    '#charma-annbar .ann-31-gift{display:inline-flex;align-items:center;margin-left:3px;opacity:.4;transition:opacity .25s ease,color .25s ease}',
    '#charma-annbar .ann-31-prog.is-done .ann-31-gift{opacity:1;color:#C8A15A}',
    '@media(max-width:600px){#charma-annbar.is-promo31{min-height:50px}#charma-annbar.is-promo31 .ann-inner{padding:7px 12px}#charma-annbar .ann-31{gap:8px}#charma-annbar .ann-31-txt{font-size:12.5px;letter-spacing:.02em}}'
  ].join('');
  document.head.appendChild(style);

  var bar = document.createElement('div');
  bar.id = 'charma-annbar';
  bar.innerHTML = [
    '<div class="ann-inner">',
    '<button class="ann-btn ann-prev" aria-label="Previous">&#8249;</button>',
    '<span class="ann-text"></span>',
    '<button class="ann-btn ann-next" aria-label="Next">&#8250;</button>',
    '</div>'
  ].join('');

  if (document.body) {
    document.body.insertBefore(bar, document.body.firstChild);
  } else {
    document.addEventListener('DOMContentLoaded', function() {
      document.body.insertBefore(bar, document.body.firstChild);
    });
  }

  var textEl = bar.querySelector('.ann-text');

  function setMsg(i, animate) {
    var m = msgs[i];
    if (animate) {
      textEl.style.opacity = '0';
      setTimeout(function() {
        textEl.innerHTML = window.CT(m.link ? '<a href="' + m.link + '">' + m.text + '</a>' : m.text);
        textEl.style.opacity = '1';
      }, 300);
    } else {
      textEl.innerHTML = window.CT(m.link ? '<a href="' + m.link + '">' + m.text + '</a>' : m.text);
    }
  }

  function goTo(i) {
    idx = ((i % msgs.length) + msgs.length) % msgs.length;
    setMsg(idx, true);
  }

  function startTimer() {
    clearInterval(timer);
    timer = setInterval(function() { goTo(idx + 1); }, 4500);
  }

  bar.querySelector('.ann-prev').addEventListener('click', function() { goTo(idx - 1); startTimer(); });
  bar.querySelector('.ann-next').addEventListener('click', function() { goTo(idx + 1); startTimer(); });

  // ────────────────────────────────────────────────────────────────────────
  // REŽIM 3+1 — len na stránkach príveskov
  //
  // Zdrojom pravdy je automatická zľava "zľava" (ACTIVE):
  //   kúp 3 ks z kolekcií frontpage / charms / naramky / nausnice /
  //   nahrdelnik / prstene / sales  →  1 ks za 1 % ceny,
  //   usesPerOrderLimit = 1, teda práve jeden darček na objednávku.
  //
  // Lišta NIČ nepočíta navyše a NIČ nepridáva do košíka — iba zobrazuje,
  // ako ďaleko je zákazník od podmienky, ktorú vyhodnotí Shopify.
  //
  // Nepočítajú sa:
  //   • darčekové riadky akcie 7+1 (majú marker _promo_reward)
  //   • prívesky Charma Italia — nie sú v žiadnej z kolekcií zľavy,
  //     detegujú sa cez existujúci tag Nomination / Italia
  // ────────────────────────────────────────────────────────────────────────
  var PROMO31_PAGES = [/^koralky$/i, /^privesky-/i];   // druhý vzor = podkategórie
  var PROMO31_NEED  = 3;

  var giftMini = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 12 20 22 4 22 4 12"/><rect x="2" y="7" width="20" height="5"/><line x1="12" y1="22" x2="12" y2="7"/><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/></svg>';
  var checkSVG = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" style="display:inline-block;vertical-align:middle;margin-right:5px;margin-top:-2px"><polyline points="20 6 9 17 4 12"/></svg>';

  function isPromo31Page() {
    var m = window.location.pathname.match(/\/collections\/([^/?#]+)/i);
    if (!m) return false;
    return PROMO31_PAGES.some(function(re) { return re.test(m[1]); });
  }

  // Tagy produktu s cache — rovnaký vzor ako isItaliaCollection nižšie.
  var _tagCache = {};
  function productTags(handle) {
    if (!handle) return Promise.resolve([]);
    if (_tagCache[handle]) return _tagCache[handle];

    var CK = 'cnb-tags-' + handle, cached = null;
    try { cached = sessionStorage.getItem(CK); } catch (e) {}
    if (cached !== null) {
      try {
        _tagCache[handle] = Promise.resolve(JSON.parse(cached));
        return _tagCache[handle];
      } catch (e) {}
    }

    _tagCache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function(r) { return r.json(); })
      .then(function(p) {
        var t = p.tags || [];
        if (typeof t === 'string') t = t.split(',');
        t = t.map(function(x) { return String(x).trim().toLowerCase(); });
        try { sessionStorage.setItem(CK, JSON.stringify(t)); } catch (e) {}
        return t;
      })
      .catch(function() { return []; });

    return _tagCache[handle];
  }

  function countEligible(cart) {
    var items = (cart && cart.items) || [];
    if (!items.length) return Promise.resolve(0);

    var checks = items.map(function(i) {
      if (window.CharmaReward && window.CharmaReward.isPromoLine &&
          window.CharmaReward.isPromoLine(i)) {
        return Promise.resolve(0);
      }
      return productTags(i.handle).then(function(tags) {
        var italia = tags.indexOf('nomination') !== -1 || tags.indexOf('italia') !== -1;
        return italia ? 0 : i.quantity;
      });
    });

    return Promise.all(checks).then(function(nums) {
      return nums.reduce(function(a, b) { return a + b; }, 0);
    });
  }

  function promo31Html(n) {
    var txt, left;
    if (n <= 0) {
      txt = giftSVG + '3+1 ZADARMO — vyberte si 3 prívesky a 4. máte od nás';
    } else if (n < PROMO31_NEED) {
      left = PROMO31_NEED - n;
      txt = window.CT('Ešte ') + left + window.CT(left === 1 ? ' prívesok' : ' prívesky') + window.CT(' a získate 4. ZADARMO');
    } else if (n === PROMO31_NEED) {
      txt = giftSVG + 'Darček je váš! Vyberte si prívesok ZADARMO →';
    } else {
      txt = checkSVG + 'Váš darček je v košíku · Skontrolovať košík →';
    }

    var filled = Math.min(n, PROMO31_NEED), dots = '';
    for (var d = 0; d < PROMO31_NEED; d++) {
      dots += '<i class="ann-dot' + (d < filled ? ' is-on' : '') + '"></i>';
    }

    return '<span class="ann-31">' +
             '<span class="ann-31-txt">' + txt + '</span>' +
             '<span class="ann-31-prog' + (n > PROMO31_NEED ? ' is-done' : '') + '" aria-hidden="true">' +
               dots + '<span class="ann-31-gift">' + giftMini + '</span>' +
             '</span>' +
           '</span>';
  }

  var _last31 = -1, _t31 = null;
  function render31(force) {
    return fetch('/cart.js', { cache: 'no-store' })
      .then(function(r) { return r.json(); })
      .then(countEligible)
      .then(function(n) {
        if (!force && n === _last31) return;
        _last31 = n;
        textEl.innerHTML = window.CT(promo31Html(n));
        setClickable31(n > PROMO31_NEED);
      })
      .catch(function() {});
  }

  // Finálny stav (darček je v košíku): celá lišta otvorí košík.
  // Používa existujúce window.charmaOpenCart (sekcia 1) — to samo otvorí
  // Opus drawer a pri neúspechu presmeruje na /cart.
  function setClickable31(on) {
    bar.classList.toggle('is-clickable', on);
    if (on) {
      bar.setAttribute('role', 'button');
      bar.setAttribute('tabindex', '0');
      bar.setAttribute('aria-label', window.CT('Otvoriť košík'));
    } else {
      bar.removeAttribute('role');
      bar.removeAttribute('tabindex');
      bar.removeAttribute('aria-label');
    }
  }

  function openCart31() {
    if (typeof window.charmaOpenCart === 'function') {
      try { window.charmaOpenCart(); return; } catch (e) {}
    }
    window.location.href = '/cart';
  }
  // Jedno pridanie vyvolá ~15× theme:cart:update a niekoľko requestov —
  // debounce ich zlúči do jedného čítania /cart.js po utíchnutí.
  function schedule31() { clearTimeout(_t31); _t31 = setTimeout(function() { render31(false); }, 350); }

  function start31() {
    msgs = [{ id: 'promo31', text: '', link: null }];
    clearInterval(timer);
    bar.classList.add('is-promo31');
    var p = bar.querySelector('.ann-prev'), nx = bar.querySelector('.ann-next');
    if (p)  p.style.display  = 'none';
    if (nx) nx.style.display = 'none';

    textEl.innerHTML = window.CT(promo31Html(0));   // okamžite, bez čakania na /cart.js
    render31(true);

    bar.addEventListener('click', function(e) {
      if (!bar.classList.contains('is-clickable')) return;
      e.preventDefault();
      openCart31();
    });
    bar.addEventListener('keydown', function(e) {
      if (!bar.classList.contains('is-clickable')) return;
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openCart31(); }
    });

    // Udalosti, ktoré na charma.sk REÁLNE vznikajú pri zmene košíka
    // (overené na živej stránke 26.09.2026 pri pridaní z karty produktu):
    //   theme:cart:update                          – téma
    //   OpusCartChange                             – Opus cart drawer
    //   codeblackbelt:collections-add-to-cart:added – tlačidlo "Pridať do košíka" v mriežke
    //   qsk.cart-added                             – quick-shop
    // Téma NEMÁ PUB_SUB_EVENTS a nevysiela cart:updated / cart:refresh,
    // preto na ne už nespoliehame.
    [
      'theme:cart:update',
      'OpusCartChange',
      'codeblackbelt:collections-add-to-cart:added',
      'qsk.cart-added',
      'cart:updated', 'cart:refresh', 'on:cart:update', 'cart-drawer:refresh'
    ].forEach(function(ev) {
      document.addEventListener(ev, schedule31, true);
      window.addEventListener(ev, schedule31, true);
    });

    // Záchranná sieť: akákoľvek úspešná zmena košíka cez AJAX API.
    // Reaguje iba na zapisujúce endpointy — /cart.js (čítanie) sem nepatrí,
    // inak by render31 spúšťal sám seba.
    var CART_WRITE = /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/i;

    if (window.fetch && !window.fetch.__charma31) {
      var _fetch = window.fetch;
      var wrapped = function() {
        var p = _fetch.apply(this, arguments);
        try {
          var a = arguments[0];
          var u = (a && a.url) ? a.url : String(a);
          if (CART_WRITE.test(u)) p.then(function(r) { if (r && r.ok) schedule31(); }, function() {});
        } catch (e) {}
        return p;
      };
      wrapped.__charma31 = true;
      window.fetch = wrapped;
    }

    if (window.XMLHttpRequest && !XMLHttpRequest.prototype.__charma31) {
      var _open = XMLHttpRequest.prototype.open;
      XMLHttpRequest.prototype.open = function(m, u) {
        try {
          if (CART_WRITE.test(String(u))) {
            this.addEventListener('load', function() {
              if (this.status >= 200 && this.status < 300) schedule31();
            });
          }
        } catch (e) {}
        return _open.apply(this, arguments);
      };
      XMLHttpRequest.prototype.__charma31 = true;
    }

    document.addEventListener('visibilitychange', function() {
      if (!document.hidden) schedule31();
    });
  }

  // ── Stránka produktu z kategórie Prívesky ────────────────────────────────
  // Kolekcia koralky = tag "Charms" (overené: všetky produkty v nej ho majú,
  // žiadny nemá Nomination/Italia). Produkt s týmto tagom dostane rovnakú
  // lištu 3+1 ako kategória. Charma Italia je vylúčená — do 3+1 nepatrí.
  function productHandleFromUrl() {
    var m = window.location.pathname.match(/\/products\/([^/?#]+)/i);
    return m ? decodeURIComponent(m[1]) : null;
  }
  function isPromo31Product(tags) {
    var charm  = tags.indexOf('charms') !== -1;
    var italia = tags.indexOf('nomination') !== -1 || tags.indexOf('italia') !== -1;
    return charm && !italia;
  }
  function startRotation() { setMsg(0, false); startTimer(); }

  var _prodHandle = productHandleFromUrl();

  if (isPromo31Page()) {
    start31();                         // kategória, podkategória aj /collections/koralky/products/…
  } else if (_prodHandle) {
    // Kým nevieme, či ide o prívesok, text skryjeme — inak by na sekundu
    // blikla rotácia a potom sa prepla na 3+1.
    textEl.style.opacity = '0';
    var _decided = false;
    var _fallback = setTimeout(function() {
      if (_decided) return;
      _decided = true;
      startRotation();
      textEl.style.opacity = '1';
    }, 1200);

    productTags(_prodHandle).then(function(tags) {
      var promo = isPromo31Product(tags);
      if (_decided) { if (promo) start31(); return; }   // pomalá sieť: prepni dodatočne
      _decided = true;
      clearTimeout(_fallback);
      if (promo) start31(); else startRotation();
      textEl.style.opacity = '1';
    });
  } else {
    startRotation();
  }

  // ──────────────────────────────────────────────────────────────────────
  // Akcia 3+1 na stránkach Charma Italia NEPLATÍ
  //
  // Automatická zľava "zľava" (3+1) má na strane nákupu kolekcie
  // frontpage, charms, naramky, nausnice, nahrdelnik, prstene, sales.
  // Prívesky Charma Italia (ACC/CHC) nie sú ani v jednej z nich — overené
  // na ACC170 a ACC175 — takže sa do trojky nepočítajú. Sľubovať na tých
  // stránkach "2+1=4" znamená sľubovať niečo, čo zákazník nedostane.
  //
  // Na stránkach Charma Italia preto ostáva len akcia 7+1 a doprava
  // zadarmo. Všade inde sa lišta nemení.
  //
  // Detekcia je rovnaká ako v sekcii 11 (tag Nomination / väčšina
  // produktov v kolekcii), vrátane zdieľanej sessionStorage cache
  // 'cnb-charmcoll-<handle>' — takže na kolekcii sa nerobí request navyše.
  // ──────────────────────────────────────────────────────────────────────
  function dropPandoraPromo() {
    var filtered = msgs.filter(function(m) { return m.id !== 'pandora31'; });
    if (filtered.length === msgs.length) return;
    msgs = filtered;
    idx = 0;
    setMsg(0, true);
    startTimer();
  }

  function isItaliaCollection(handle) {
    if (!handle) return Promise.resolve(false);
    if (/^(nomination|charma-italia|italia)/i.test(handle)) return Promise.resolve(true);

    var CK = 'cnb-charmcoll-' + handle;
    try {
      var cached = sessionStorage.getItem(CK);
      if (cached !== null) return Promise.resolve(cached === '1');
    } catch (e) {}

    return fetch('/collections/' + encodeURIComponent(handle) + '/products.json?limit=10')
      .then(function(r) { return r.json(); })
      .then(function(d) {
        var ps = (d && d.products) || [];
        if (!ps.length) return false;
        var ok = 0;
        ps.forEach(function(p) {
          var tags = p.tags;
          if (typeof tags === 'string') tags = tags.split(',');
          var tagged = (tags || []).some(function(t) {
            return /^\s*(nomination|italia)\s*$/i.test(String(t));
          });
          if (tagged) ok++;
        });
        return ok >= Math.ceil(ps.length * 0.6);
      })
      .catch(function() { return false; })
      .then(function(res) {
        try { sessionStorage.setItem(CK, res ? '1' : '0'); } catch (e) {}
        return res;
      });
  }

  (function detectContext() {
    if (isPromo31Page()) return;   // lišta je v režime 3+1, rotácia sa nepoužíva

    var path = window.location.pathname;

    var pm = path.match(/\/products\/([^/?#]+)/i);
    if (pm) {
      fetch('/products/' + pm[1] + '.js')
        .then(function(r) { return r.json(); })
        .then(function(p) {
          if (p.tags && p.tags.indexOf('Nomination') !== -1) dropPandoraPromo();
        })
        .catch(function() {});
      return;
    }

    var cm = path.match(/\/collections\/([^/?#]+)/i);
    if (cm) {
      isItaliaCollection(cm[1]).then(function(ok) { if (ok) dropPandoraPromo(); });
    }
    // Domovská stránka, košík, ostatné — lišta ostáva so všetkými tromi
  })();

  // Recalculate sticky header position to account for bar height
  setTimeout(function() {
    if (window.__charmaUpdateHeaderTop) window.__charmaUpdateHeaderTop();
  }, 150);
})();


// ============================================================
// 11. NOMINATION 7+1 REWARD BAR — na stránke kolekcie / produktu
//     NIE v košíku — motivuje počas prehliadania
// ============================================================
(function() {
  var NOM_THRESHOLD = 7;
  // všetkých 5 náramkov akcie 7+1 (silver, golden, rose gold, blue, black)
  var GIFT_VARIANT_IDS = window.CHARMA_BRACELET_VIDS ||
    [51879076594001, 51879089340753, 51879096779089, 54987325702481, 54987325800785];
  var path = window.location.pathname;

  var collMatch  = path.match(/\/collections\/([^/?#]+)/i);
  var collHandle = collMatch ? collMatch[1] : null;
  var isProductPage = !!document.querySelector('.product') && /\/products\//.test(path);

  // Main Charma Italia collections are recognisable straight from the handle.
  // Sub-category handles are generic words (silver, heart, pearls, zlate,
  // flowers …) so they cannot be matched by name — they are detected from their
  // actual products further down, and this flag is flipped on when they match.
  var isNomCollection = !!collHandle && /^(nomination|charma-italia|italia)/i.test(collHandle);

  if (!collHandle && !isProductPage) return;

  function isNomSku(sku) {
    return /^(ACC|A\d)/i.test(sku || '');
  }

  function isGiftItem(item) {
    // Delegate to the shared entitlement helper so the bar, the picker and the
    // cart reconciliation all agree on what a reward is. Identification is by
    // explicit marker only — a paid bracelet of the same variant, even one the
    // reward discount happens to zero out, is NOT a reward.
    if (window.CharmaReward && window.CharmaReward.isPromoLine) {
      return window.CharmaReward.isPromoLine(item);
    }
    var p = item.properties || {};
    return p._promo_reward === 'charma_7_plus_1' || p._gift === 'true' || p._gift === true;
  }

  function pluralSk(n) {
    if (n === 1) return window.CT('šperk');
    if (n >= 2 && n <= 4) return window.CT('šperky');
    return window.CT('šperkov');
  }

  function resizeShopifyImg(url, size) {
    if (!url) return '';
    return url.replace(/\?.*$/, '').replace(/(\.[^./]+)$/, '_' + size + 'x' + size + '_crop_center$1');
  }

  function pluralPrivesok(n) {
    if (n === 1) return window.CT('prívesok');
    if (n >= 2 && n <= 4) return window.CT('prívesky');
    return window.CT('príveskov');
  }

  function pluralBracelet(n) {
    if (n === 1) return window.CT('náramok získaný');
    if (n >= 2 && n <= 4) return window.CT('náramky získané');
    return window.CT('náramkov získaných');
  }

  function pluralEarned(n) {
    if (n === 1) return window.CT('NÁRAMOK ZADARMO');
    if (n >= 2 && n <= 4) return window.CT('NÁRAMKY ZADARMO');
    return window.CT('NÁRAMKY ZADARMO');
  }

  // ── Inline SVG constants ─────────────────────────────────────
  var CNB_CHECK_GRN =  // small green checkmark for earned label
    '<svg width="10" height="8" viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<path d="M1 3.5L3.8 6.5L9 1" stroke="#00594F" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var CNB_CHECK_WHT =  // white checkmark for bracelet badge
    '<svg width="8" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<path d="M1 2.5L3 4.5L7 1" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var CNB_ARROW =      // gold arrow between done charms and bracelet
    '<svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<path d="M1 5h8M6 2l3 3-3 3" stroke="#C8A15A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function injectBarStyles() {
    if (document.getElementById('cnb-styles')) return;
    var s = document.createElement('style');
    s.id = 'cnb-styles';
    s.textContent = [
      // Container
      '#charma-nom-bar{background:#F3F1EE;border:1px solid #E2DDD8;border-radius:12px;',
      'padding:10px 12px 9px;margin:10px 0;box-sizing:border-box;font-family:inherit}',

      // ── Earned header row ──
      '.cnb-earned-row{display:flex;align-items:center;justify-content:space-between;',
      'margin-bottom:6px;animation:cnb-fadein .3s ease}',
      '.cnb-earned-label{font-size:12px;font-weight:700;letter-spacing:.06em;text-transform:uppercase;color:#00594F;display:flex;align-items:center;gap:5px}',
      '.cnb-bracelets{display:flex;gap:4px;flex-shrink:0}',

      // Reward bracelet thumbnail
      '.cnb-rthumb{position:relative;width:36px;height:36px;border-radius:7px;',
      'overflow:hidden;border:1.5px solid #C8A15A;flex-shrink:0;background:#F0EDE8}',
      '.cnb-rthumb img{width:100%;height:100%;object-fit:cover;display:block}',
      '.cnb-rcheck{position:absolute;bottom:-1px;right:-1px;width:13px;height:13px;',
      'background:#00594F;border-radius:50%;display:flex;align-items:center;justify-content:center}',

      // ── Completed charm set row ──
      '.cnb-done-set{display:flex;align-items:center;gap:3px;margin-bottom:5px;',
      'overflow:hidden}',
      '.cnb-done-slot{width:23px;height:23px;border-radius:4px;overflow:hidden;',
      'flex-shrink:0;border:1px solid #E2DDD8;opacity:.75}',
      '.cnb-done-slot img{width:100%;height:100%;object-fit:cover;display:block}',
      '.cnb-done-slot--empty{background:#EDEAE6}',
      '.cnb-done-arrow{flex-shrink:0;display:flex;align-items:center;margin:0 1px}',
      '.cnb-done-bracelet{width:30px;height:30px;border-radius:6px;object-fit:cover;',
      'flex-shrink:0;border:1.5px solid #C8A15A;display:block}',
      '.cnb-done-bracelet--ph{width:30px;height:30px;border-radius:6px;',
      'flex-shrink:0;background:#EDEAE6;border:1px solid #E2DDD8}',

      // ── Separator ──
      '.cnb-sep{height:1px;background:#E2DDD8;margin:6px 0}',

      // ── Zero state (0/7 after earning) ──
      '.cnb-zero-row{display:flex;align-items:center;justify-content:space-between}',
      '.cnb-zero-label{font-size:12px;font-weight:600;letter-spacing:.05em;text-transform:uppercase;color:#171717}',
      '.cnb-zero-count{font-size:13px;font-weight:700;color:#044a40;letter-spacing:.01em;flex-shrink:0}',
      '.cnb-zero-hint{font-size:11px;color:#626560;margin-top:3px}',

      // ── Active state (earned === 0) ──
      '.cnb-count-row{display:flex;align-items:center;gap:9px;margin-bottom:6px}',
      '.cnb-count{font-size:20px;font-weight:800;color:#044a40;line-height:1;',
      'flex-shrink:0;letter-spacing:-.01em}',
      '.cnb-count-total{font-size:11px;font-weight:400;color:#aaa}',
      '.cnb-msg{font-size:11px;color:#555;line-height:1.3}',
      '.cnb-msg strong{color:#171717;font-weight:600}',

      // ── Active next-cycle state (compact) ──
      '.cnb-next-row{display:flex;align-items:center;justify-content:space-between;margin-bottom:4px}',
      '.cnb-next-label{font-size:12px;font-weight:600;letter-spacing:.05em;text-transform:uppercase;color:#171717}',
      '.cnb-count-sm{font-size:13px;font-weight:700;color:#044a40;line-height:1;flex-shrink:0}',
      '.cnb-msg-sm{font-size:11px;color:#626560;margin-top:3px}',

      // ── Slots ──
      '.cnb-slots{display:flex;gap:4px;margin-bottom:5px}',
      '.cnb-slot{width:26px;height:26px;border-radius:5px;flex-shrink:0;',
      'overflow:hidden;box-sizing:border-box}',
      '.cnb-slot--filled{border:1.5px solid #E2DDD8;animation:cnb-popin .22s ease}',
      '.cnb-slot--filled img{width:100%;height:100%;object-fit:cover;display:block}',
      '.cnb-slot--empty{border:1.5px dashed #D4CFC8;background:#F9F7F5}',

      // ── Progress bar (single-element gradient — no child div) ──
      '.cnb-bar{width:100%;height:6px;border-radius:3px;margin-bottom:4px;',
      'transition:background .35s cubic-bezier(.4,0,.2,1)}',

      // ── VAŠE PRÍVESKY row ──
      '.cnb-section-label{display:flex;justify-content:space-between;align-items:center;font-size:10px;font-weight:600;letter-spacing:.07em;text-transform:uppercase;color:#626560;margin-bottom:2px}',
      '.cnb-section-count{font-size:11px;font-weight:600;color:#626560;letter-spacing:.01em;text-transform:none}',
      '.cnb-charms-row{display:flex;align-items:center;gap:3px;flex-wrap:nowrap;overflow:hidden}',
      '.cnb-charm-thumb{width:26px;height:26px;border-radius:5px;flex-shrink:0;',
      'overflow:hidden;border:1px solid #E2DDD8;background:#F0EDE8}',
      '.cnb-charm-thumb img{width:100%;height:100%;object-fit:cover;display:block}',
      '.cnb-overflow{flex-shrink:0;height:26px;min-width:26px;border-radius:5px;',
      'background:#E2DDD8;font-size:10px;font-weight:700;color:#777;display:flex;',
      'align-items:center;justify-content:center;padding:0 5px}',

      // ── Unclaimed reward CTA ──
      '.cnb-unclaimed{background:#FFF8EC;border:1px solid #C8A15A;border-radius:8px;',
      'padding:8px 12px;display:flex;align-items:center;justify-content:space-between;gap:8px}',
      '.cnb-unclaimed-label{font-size:11px;font-weight:700;color:#7A5B1A;letter-spacing:.04em;',
      'text-transform:uppercase;white-space:nowrap}',
      '.cnb-unclaimed-btn{background:none;border:none;color:#C8A15A;font-size:12px;font-weight:700;',
      'cursor:pointer;white-space:nowrap;padding:0;font-family:inherit;',
      'text-decoration:underline;text-underline-offset:2px}',
      '.cnb-unclaimed-btn:hover{color:#A07830}',

      // ── Tap affordance on the charms block ──
      '.cnb-section-label,.cnb-charms-row{cursor:pointer;-webkit-tap-highlight-color:transparent}',
      '.cnb-more{display:inline-flex;align-items:center;gap:3px;font-size:10px;font-weight:700;',
      'letter-spacing:.04em;color:#044a40;text-transform:uppercase;margin-left:7px}',
      '.cnb-more svg{display:block}',

      // ── Bottom sheet ──
      '.cnb-bd{position:fixed;inset:0;background:rgba(23,23,23,.45);z-index:2147483000;',
      'opacity:0;transition:opacity .28s ease;-webkit-backdrop-filter:blur(2px);backdrop-filter:blur(2px)}',
      '.cnb-bd.is-open{opacity:1}',
      '.cnb-sheet{position:fixed;left:0;right:0;bottom:0;z-index:2147483001;background:#FBFAF8;',
      'border-radius:20px 20px 0 0;box-shadow:0 -8px 40px rgba(0,0,0,.22);display:flex;',
      'flex-direction:column;max-height:82vh;transform:translateY(100%);',
      'transition:transform .32s cubic-bezier(.32,.72,0,1);font-family:inherit;',
      'padding-bottom:env(safe-area-inset-bottom,0px);box-sizing:border-box}',
      '.cnb-sheet.is-open{transform:translateY(0)}',
      '@media(min-width:768px){.cnb-sheet{left:50%;right:auto;transform:translate(-50%,100%);',
      'width:520px;border-radius:20px;bottom:24px;max-height:78vh}',
      '.cnb-sheet.is-open{transform:translate(-50%,0)}}',

      // Grab handle
      '.cnb-grab{width:38px;height:4px;border-radius:2px;background:#D9D4CD;margin:9px auto 0;flex-shrink:0}',

      // Sheet header
      '.cnb-sh-head{display:flex;align-items:center;justify-content:space-between;gap:12px;',
      'padding:13px 20px 12px;border-bottom:1px solid #EDE9E4;flex-shrink:0}',
      '.cnb-sh-title{font-size:16px;font-weight:700;color:#171717;letter-spacing:-.01em}',
      '.cnb-sh-count{font-size:14px;font-weight:700;color:#044a40;margin-left:9px}',
      '.cnb-sh-x{width:30px;height:30px;border-radius:50%;border:none;background:#F0EDE8;',
      'color:#5A5A5A;font-size:19px;line-height:1;cursor:pointer;flex-shrink:0;display:flex;',
      'align-items:center;justify-content:center;font-family:inherit;padding:0;transition:background .18s}',
      '.cnb-sh-x:hover{background:#E2DDD8}',

      // Scrollable body
      '.cnb-sh-body{overflow-y:auto;-webkit-overflow-scrolling:touch;padding:14px 16px 4px;flex:1 1 auto;overscroll-behavior:contain}',
      '.cnb-sh-grid{display:grid;grid-template-columns:1fr 1fr;gap:12px}',
      '@media(min-width:520px){.cnb-sh-grid{grid-template-columns:1fr 1fr 1fr}}',

      // Charm card
      '.cnb-sc{background:#fff;border:1px solid #EDE9E4;border-radius:12px;padding:9px 9px 8px;',
      'display:flex;flex-direction:column;animation:cnb-popin .2s ease;box-sizing:border-box}',
      '.cnb-sc-img{display:block;width:100%;aspect-ratio:1/1;border-radius:8px;overflow:hidden;',
      'background:#F3F1EE;margin-bottom:7px}',
      '.cnb-sc-img img{width:100%;height:100%;object-fit:cover;display:block}',
      '.cnb-sc-title{font-size:12px;font-weight:600;color:#171717;line-height:1.32;',
      'display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;',
      'text-decoration:none;margin-bottom:3px;min-height:31px}',
      '.cnb-sc-meta{font-size:11px;color:#7A7A7A;margin-bottom:7px}',
      '.cnb-sc-meta b{color:#044a40;font-weight:700}',
      '.cnb-sc-rm{margin-top:auto;background:none;border:none;padding:0;font-family:inherit;',
      'font-size:11px;font-weight:600;color:#A33;cursor:pointer;display:flex;align-items:center;',
      'gap:4px;opacity:.82;transition:opacity .15s}',
      '.cnb-sc-rm:hover{opacity:1}',
      '.cnb-sc.is-busy{opacity:.45;pointer-events:none}',

      // Empty state
      '.cnb-sh-empty{text-align:center;color:#8A8A8A;font-size:13px;padding:34px 16px 30px}',

      // Sheet footer
      '.cnb-sh-foot{border-top:1px solid #EDE9E4;padding:12px 20px 14px;flex-shrink:0;background:#FBFAF8;',
      'border-radius:0 0 0 0}',
      '.cnb-sh-hint{font-size:12px;color:#626560;text-align:center;margin-bottom:9px}',
      '.cnb-sh-hint b{color:#044a40;font-weight:700}',
      // Primárna akcia — prechod na pokladňu
      '.cnb-sh-pay{width:100%;padding:14px 18px;border:none;border-radius:100px;background:#044a40;',
      'color:#fff;font-family:inherit;font-size:15px;font-weight:600;letter-spacing:.02em;',
      'cursor:pointer;transition:background .2s;display:flex;align-items:center;',
      'justify-content:center;gap:8px}',
      '.cnb-sh-pay:hover{background:#02362F}',
      '.cnb-sh-pay b{font-weight:700}',
      // Sekundárna akcia — pokračovať vo výbere (bolo primárne tlačidlo)
      '.cnb-sh-cta{width:100%;padding:11px 18px 2px;border:none;background:none;',
      'color:#626560;font-family:inherit;font-size:13px;font-weight:500;',
      'cursor:pointer;text-decoration:underline;text-underline-offset:3px;',
      'transition:color .15s}',
      '.cnb-sh-cta:hover{color:#171717}',

      // ── Animations ──
      '@keyframes cnb-fadein{from{opacity:0;transform:translateY(-3px)}',
      'to{opacity:1;transform:translateY(0)}}',
      '@keyframes cnb-popin{from{opacity:0;transform:scale(.65)}',
      'to{opacity:1;transform:scale(1)}}'
    ].join('');
    document.head.appendChild(s);
  }

  // ═══════════════════════════════════════════════════════════════════════════
  //  EXPANDABLE "VAŠE PRÍVESKY" BOTTOM SHEET
  //  Additive only — the compact reward card markup is untouched.
  // ═══════════════════════════════════════════════════════════════════════════

  var CNB_CHEVRON =
    '<svg width="9" height="9" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<path d="M3.5 1.5L7 5l-3.5 3.5" stroke="#044a40" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var CNB_TRASH =
    '<svg width="11" height="11" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<path d="M2 3h8M4.5 3V2h3v1M3 3l.5 7h5L9 3M5 5.2v3M7 5.2v3" stroke="#A33" stroke-width="1.1" ' +
    'stroke-linecap="round" stroke-linejoin="round"/></svg>';

  // Section label markup — shared by buildInner() and _reconcileBar() so the
  // tap affordance can never drift between full render and in-place update.
  function cnbSectionLabelHtml(nomCount) {
    return window.CT('<span>VAŠE PRÍVESKY</span>' +
      '<span class="cnb-section-count">' + nomCount + ' ks' +
        '<span class="cnb-more">Zobraziť ' + CNB_CHEVRON + '</span>' +
      '</span>');
  }

  function cnbMoney(cents) {
    if (typeof cents !== 'number' || isNaN(cents)) return '';
    return window.charmaMoney(cents);
  }

  // Latest data snapshot, kept fresh by renderBar() so the sheet can re-render live
  var _cnbItems = [];
  var _cnbCount = 0;
  var _cnbScrollY = 0;
  var _cnbTotal  = 0;   // total_price košíka (po zľavách) — pre tlačidlo pokladne

  function cnbSheetIsOpen() {
    var s = document.getElementById('cnb-sheet');
    return !!(s && s.classList.contains('is-open'));
  }

  function cnbSheetBodyHtml() {
    var items = _cnbItems || [];
    if (!items.length) {
      return window.CT('<div class="cnb-sh-empty">Zatiaľ ste nepridali žiadne prívesky.</div>');
    }
    var html = '<div class="cnb-sh-grid">';
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      var img = resizeShopifyImg(it.img, 300);
      var titleInner = '<span class="cnb-sc-title">' + (it.title || '') + '</span>';
      html +=
        '<div class="cnb-sc" data-key="' + (it.key || '') + '">' +
          (it.url
            ? '<a class="cnb-sc-img" href="' + it.url + '"><img src="' + img + '" alt="" loading="lazy"></a>'
            : '<span class="cnb-sc-img"><img src="' + img + '" alt="" loading="lazy"></span>') +
          (it.url ? '<a href="' + it.url + '" style="text-decoration:none">' + titleInner + '</a>' : titleInner) +
          '<div class="cnb-sc-meta"><b>' + it.qty + ' ks</b>' +
            (it.price ? ' · ' + cnbMoney(it.price) : '') + '</div>' +
          '<button class="cnb-sc-rm" data-rm="' + (it.key || '') + '" type="button">' +
            CNB_TRASH + 'Odstrániť</button>' +
        '</div>';
    }
    return window.CT(html + '</div>');
  }

  function cnbSheetFootHtml() {
    var cycle = _cnbCount % NOM_THRESHOLD;
    var left  = NOM_THRESHOLD - cycle;
    var hint  = (_cnbCount > 0 && cycle === 0)
      ? 'Máte nárok na náramok zdarma!'
      : 'Ešte <b>' + left + ' ' + pluralPrivesok(left) + '</b> do náramku zdarma';
    /* Tlačidlo pokladne sa ukáže len keď je v košíku čo platiť.
       Ide priamo na /checkout — rovnako ako tlačidlo v košíku. */
    var pay = _cnbTotal > 0
      ? '<button class="cnb-sh-pay" type="button" data-cnb-checkout="1">' +
          '<span>Prejsť k pokladni</span><b>' + cnbMoney(_cnbTotal) + '</b>' +
        '</button>'
      : '';
    return window.CT('<div class="cnb-sh-hint">' + hint + '</div>' + pay +
      '<button class="cnb-sh-cta" type="button" data-cnb-close="1">Pokračovať vo výbere</button>');
  }

  function cnbSyncSheet() {
    var sheet = document.getElementById('cnb-sheet');
    if (!sheet) return;
    var cyc = _cnbCount % NOM_THRESHOLD;
    var cnt = sheet.querySelector('.cnb-sh-count');
    if (cnt) cnt.textContent = cyc + ' / ' + NOM_THRESHOLD;
    var body = sheet.querySelector('.cnb-sh-body');
    if (body) body.innerHTML = cnbSheetBodyHtml();
    var foot = sheet.querySelector('.cnb-sh-foot');
    if (foot) foot.innerHTML = cnbSheetFootHtml();
  }

  function cnbCloseSheet() {
    var bd = document.getElementById('cnb-bd');
    var sheet = document.getElementById('cnb-sheet');
    if (!sheet) return;
    sheet.classList.remove('is-open');
    if (bd) bd.classList.remove('is-open');
    // Restore page scroll to the exact previous position
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    window.scrollTo(0, _cnbScrollY);
    setTimeout(function () {
      if (bd) bd.remove();
      if (sheet) sheet.remove();
    }, 340);
  }

  function cnbOpenSheet() {
    if (document.getElementById('cnb-sheet')) return;
    injectBarStyles();

    var cyc = _cnbCount % NOM_THRESHOLD;

    var bd = document.createElement('div');
    bd.id = 'cnb-bd';
    bd.className = 'cnb-bd';

    var sheet = document.createElement('div');
    sheet.id = 'cnb-sheet';
    sheet.className = 'cnb-sheet';
    sheet.setAttribute('role', 'dialog');
    sheet.setAttribute('aria-modal', 'true');
    sheet.setAttribute('aria-label', window.CT('Vaše prívesky'));
    sheet.innerHTML = window.CT(
      '<div class="cnb-grab"></div>' +
      '<div class="cnb-sh-head">' +
        '<div><span class="cnb-sh-title">Vaše prívesky</span>' +
        '<span class="cnb-sh-count">' + cyc + ' / ' + NOM_THRESHOLD + '</span></div>' +
        '<button class="cnb-sh-x" type="button" data-cnb-close="1" aria-label="Zavrieť">×</button>' +
      '</div>' +
      '<div class="cnb-sh-body">' + cnbSheetBodyHtml() + '</div>' +
      '<div class="cnb-sh-foot">' + cnbSheetFootHtml() + '</div>');

    document.body.appendChild(bd);
    document.body.appendChild(sheet);

    // Lock the page behind the sheet without losing scroll position
    _cnbScrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = -_cnbScrollY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';

    requestAnimationFrame(function () {
      bd.classList.add('is-open');
      sheet.classList.add('is-open');
    });

    // Swipe-down-to-close on the handle / header
    var startY = null, dy = 0;
    function onStart(e) {
      startY = e.touches ? e.touches[0].clientY : null;
      dy = 0;
      sheet.style.transition = 'none';
    }
    function onMove(e) {
      if (startY === null) return;
      dy = e.touches[0].clientY - startY;
      if (dy > 0) sheet.style.transform = 'translateY(' + dy + 'px)';
    }
    function onEnd() {
      if (startY === null) return;
      sheet.style.transition = '';
      sheet.style.transform = '';
      if (dy > 90) cnbCloseSheet();
      startY = null;
    }
    var grip = sheet.querySelector('.cnb-grab');
    var head = sheet.querySelector('.cnb-sh-head');
    [grip, head].forEach(function (n) {
      if (!n) return;
      n.addEventListener('touchstart', onStart, { passive: true });
      n.addEventListener('touchmove', onMove, { passive: true });
      n.addEventListener('touchend', onEnd);
    });

    bd.addEventListener('click', cnbCloseSheet);
  }

  // Delegated events — survive every re-render of the card and the sheet
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-cnb-close]')) { cnbCloseSheet(); return; }

    // Prechod na pokladňu. Odomknutie scrollu musí prebehnúť ešte pred
    // odchodom — cnbOpenSheet() zamkol body cez position:fixed a pri
    // návrate tlačidlom späť by stránka ostala zamrznutá.
    if (e.target.closest && e.target.closest('[data-cnb-checkout]')) {
      e.preventDefault();
      cnbCloseSheet();
      setTimeout(function () { window.location.href = '/checkout'; }, 120);
      return;
    }

    // Remove a charm line from the cart
    var rm = e.target.closest && e.target.closest('.cnb-sc-rm');
    if (rm) {
      e.preventDefault();
      var key = rm.getAttribute('data-rm');
      if (!key) return;
      var card = rm.closest('.cnb-sc');
      if (card) card.classList.add('is-busy');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (window.charmaNomRefresh) window.charmaNomRefresh();
          document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart } }));
          document.dispatchEvent(new CustomEvent('on:cart:update', { bubbles: true, detail: { cart: cart } }));
        })
        .catch(function () { if (card) card.classList.remove('is-busy'); });
      return;
    }

    // Open the sheet from the compact card's charms block
    var trigger = e.target.closest && e.target.closest('.cnb-section-label, .cnb-charms-row');
    if (trigger && document.getElementById('charma-nom-bar') &&
        document.getElementById('charma-nom-bar').contains(trigger)) {
      cnbOpenSheet();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && cnbSheetIsOpen()) cnbCloseSheet();
  });

  // Helper: build active progress (used for earned===0 and next-cycle)
  function buildActive(cycleProgress, cycleImgs, remaining, compact) {
    var pct   = Math.round(cycleProgress / NOM_THRESHOLD * 100);
    var slots = '';
    for (var s = 0; s < NOM_THRESHOLD; s++) {
      if (s < cycleProgress) {
        slots += cycleImgs[s]
          ? '<div class="cnb-slot cnb-slot--filled"><img src="' + cycleImgs[s] + '" alt="" loading="lazy"></div>'
          : '<div class="cnb-slot cnb-slot--filled" style="background:#E2DDD8"></div>';
      } else {
        slots += '<div class="cnb-slot cnb-slot--empty"></div>';
      }
    }
    var bar  = cycleProgress > 0
      ? '<div class="cnb-bar" style="display:block;width:100%;height:6px;border-radius:3px;margin:4px 0;background:linear-gradient(90deg,#044a40 ' + pct + '%,#E2DDD8 ' + pct + '%)"></div>'
      : '';
    if (compact) {
      // Next-cycle compact header
      return '<div class="cnb-next-row">' +
          '<span class="cnb-next-label">ĎALŠÍ NÁRAMOK ZADARMO</span>' +
          '<span class="cnb-count-sm">' + cycleProgress + ' / ' + NOM_THRESHOLD + '</span>' +
        '</div>' +
        '<div class="cnb-slots">' + slots + '</div>' +
        bar +
        '<div class="cnb-msg-sm">Ešte ' + remaining + ' ' + pluralPrivesok(remaining) + '</div>';
    }
    // Full active state (no earned bracelets yet)
    return '<div class="cnb-count-row">' +
        '<span class="cnb-count">' + cycleProgress + '<span class="cnb-count-total">/' + NOM_THRESHOLD + '</span></span>' +
        '<span class="cnb-msg">Ešte <strong>' + remaining + '</strong> ' + pluralPrivesok(remaining) + '</span>' +
      '</div>' +
      '<div class="cnb-slots">' + slots + '</div>' +
      bar;
  }

  function buildInner(nomCount, charmItems, giftItems) {
    var cycleProgress = nomCount % NOM_THRESHOLD;
    var earned        = Math.floor(nomCount / NOM_THRESHOLD);
    var claimed       = (giftItems || []).length;
    var unclaimed     = Math.max(0, earned - claimed);
    var remaining     = NOM_THRESHOLD - cycleProgress;

    // Flatten all charm images (1 per quantity unit, 64px CDN)
    var allImgs = [];
    (charmItems || []).forEach(function(item) {
      var src = resizeShopifyImg(item.img, 64);
      for (var q = 0; q < item.qty; q++) allImgs.push(src);
    });

    // Gift bracelet images
    var giftSrcs = (giftItems || []).map(function(g) { return resizeShopifyImg(g.img, 80); });

    // Collect sections, join with separators
    var sections = [];

    // SECTION A: Claimed bracelets
    if (claimed > 0) {
      var braceletHtml = '';
      for (var b = 0; b < claimed; b++) {
        braceletHtml +=
          '<div class="cnb-rthumb">' +
            (giftSrcs[b] ? '<img src="' + giftSrcs[b] + '" alt="" loading="lazy">' : '') +
            '<span class="cnb-rcheck">' + CNB_CHECK_WHT + '</span>' +
          '</div>';
      }
      sections.push(
        '<div class="cnb-earned-row">' +
          '<span class="cnb-earned-label">' + CNB_CHECK_GRN + ' ' + pluralEarned(claimed) + '</span>' +
          '<div class="cnb-bracelets">' + braceletHtml + '</div>' +
        '</div>'
      );
    }

    // Unclaimed reward CTA
    if (unclaimed > 0) {
      sections.push(
        '<div class="cnb-unclaimed">' +
          '<span class="cnb-unclaimed-label">🎁 DARČEK ODOMKNUTÝ</span>' +
          '<button class="cnb-unclaimed-btn" onclick="if(window.charmaCheckGift)window.charmaCheckGift()">Vybrať náramok zdarma →</button>' +
        '</div>'
      );
    }

    // SECTION B: All charms row
    if (nomCount > 0) {
      var MAX_SHOWN = 8;
      var overflow  = allImgs.length > MAX_SHOWN ? allImgs.length - MAX_SHOWN : 0;
      var shownImgs = allImgs.slice(0, MAX_SHOWN);
      var thumbsHtml = '';
      for (var ti = 0; ti < shownImgs.length; ti++) {
        thumbsHtml +=
          '<div class="cnb-charm-thumb"><img src="' + shownImgs[ti] + '" alt="" loading="lazy"></div>';
      }
      if (overflow > 0) {
        thumbsHtml += '<div class="cnb-overflow">+' + overflow + '</div>';
      }
      sections.push(
        '<div class="cnb-section-label">' + cnbSectionLabelHtml(nomCount) + '</div>' +
        '<div class="cnb-charms-row">' + thumbsHtml + '</div>'
      );
    }

    // SECTION C: Progress to next reward
    if (cycleProgress === 0) {
      sections.push(
        '<div class="cnb-zero-row">' +
          '<span class="cnb-zero-label">' + window.CT(earned === 0 ? 'NÁRAMOK ZADARMO' : 'ĎALŠÍ NÁRAMOK ZADARMO') + '</span>' +
          '<span class="cnb-zero-count">0 / ' + NOM_THRESHOLD + '</span>' +
        '</div>' +
        '<div class="cnb-zero-hint">Ešte ' + NOM_THRESHOLD + window.CT(' príveskov</div>')
      );
    } else {
      var pct = Math.round(cycleProgress / NOM_THRESHOLD * 100);
      sections.push(
        '<div class="cnb-next-row">' +
          '<span class="cnb-next-label">' + window.CT(earned === 0 ? 'NÁRAMOK ZADARMO' : 'ĎALŠÍ NÁRAMOK ZADARMO') + '</span>' +
          '<span class="cnb-count-sm">' + cycleProgress + ' / ' + NOM_THRESHOLD + '</span>' +
        '</div>' +
        '<div class="cnb-bar" style="display:block;width:100%;height:6px;border-radius:3px;margin:4px 0;background:linear-gradient(90deg,#044a40 ' + pct + '%,#E2DDD8 ' + pct + '%)"></div>' +
        '<div class="cnb-msg-sm">Ešte ' + remaining + ' ' + pluralPrivesok(remaining) + '</div>'
      );
    }

    return window.CT(sections.join('<div class="cnb-sep"></div>'));
  }
  // ── DOM reconciliation helpers ─────────────────────────────────────────────

  function _reconcileCharmThumbs(row, newImgs, overflow) {
    if (!row) return;
    var existing = Array.from(row.querySelectorAll('.cnb-charm-thumb'));
    for (var i = 0; i < newImgs.length; i++) {
      var src = newImgs[i];
      if (i < existing.length) {
        var img = existing[i].querySelector('img');
        if (img && img.getAttribute('src') !== src) img.setAttribute('src', src);
      } else {
        var thumb = document.createElement('div');
        thumb.className = 'cnb-charm-thumb';
        thumb.style.cssText = 'opacity:0;transform:scale(.88);transition:opacity .2s ease,transform .2s ease';
        var newImg = document.createElement('img');
        newImg.setAttribute('src', src);
        newImg.alt = '';
        newImg.loading = 'lazy';
        thumb.appendChild(newImg);
        var badge = row.querySelector('.cnb-overflow');
        row.insertBefore(thumb, badge || null);
        (function(t) {
          requestAnimationFrame(function() { requestAnimationFrame(function() {
            t.style.opacity = '1'; t.style.transform = 'scale(1)';
          }); });
        })(thumb);
      }
    }
    for (var j = existing.length - 1; j >= newImgs.length; j--) existing[j].remove();
    var badge = row.querySelector('.cnb-overflow');
    if (overflow > 0) {
      if (!badge) { badge = document.createElement('div'); badge.className = 'cnb-overflow'; row.appendChild(badge); }
      badge.textContent = '+' + overflow;
    } else if (badge) { badge.remove(); }
  }

  function _reconcileBraceletThumbs(container, giftSrcs, claimed) {
    if (!container) return;
    var existing = Array.from(container.querySelectorAll('.cnb-rthumb'));
    for (var i = 0; i < claimed; i++) {
      var src = giftSrcs[i] || '';
      if (i < existing.length) {
        var img = existing[i].querySelector('img');
        if (src && img && img.getAttribute('src') !== src) img.setAttribute('src', src);
      } else {
        var thumb = document.createElement('div');
        thumb.className = 'cnb-rthumb';
        if (src) {
          var newImg = document.createElement('img');
          newImg.setAttribute('src', src); newImg.alt = ''; newImg.loading = 'lazy';
          thumb.appendChild(newImg);
        }
        var chk = document.createElement('span'); chk.className = 'cnb-rcheck';
        chk.innerHTML = CNB_CHECK_WHT; thumb.appendChild(chk);
        container.appendChild(thumb);
      }
    }
    for (var j = existing.length - 1; j >= claimed; j--) existing[j].remove();
  }

  function _reconcileBar(inner, nomCount, charmItems, giftItems) {
    var cycleProgress = nomCount % NOM_THRESHOLD;
    var earned    = Math.floor(nomCount / NOM_THRESHOLD);
    var claimed   = (giftItems || []).length;
    var unclaimed = Math.max(0, earned - claimed);
    var remaining = NOM_THRESHOLD - cycleProgress;

    var allImgs = [];
    (charmItems || []).forEach(function(item) {
      var src = resizeShopifyImg(item.img, 64);
      for (var q = 0; q < item.qty; q++) allImgs.push(src);
    });
    var giftSrcs = (giftItems || []).map(function(g) { return resizeShopifyImg(g.img, 80); });

    // Structural diff: if sections need to appear / disappear, do a full rebuild
    var hasEarned    = !!inner.querySelector('.cnb-earned-row');
    var hasUnclaimed = !!inner.querySelector('.cnb-unclaimed');
    var hasCharms    = !!inner.querySelector('.cnb-charms-row');
    if (hasEarned !== (claimed > 0) || hasUnclaimed !== (unclaimed > 0) || hasCharms !== (nomCount > 0)) {
      inner.innerHTML = buildInner(nomCount, charmItems, giftItems);
      return;
    }

    // Section A: earned bracelets
    if (claimed > 0) {
      var el = inner.querySelector('.cnb-earned-label');
      if (el) el.innerHTML = CNB_CHECK_GRN + ' ' + pluralEarned(claimed);
      _reconcileBraceletThumbs(inner.querySelector('.cnb-bracelets'), giftSrcs, claimed);
    }

    // Section B: charm thumbnails (reconcile, no wipe)
    if (nomCount > 0) {
      var MAX_SHOWN = 8;
      var overflow = allImgs.length > MAX_SHOWN ? allImgs.length - MAX_SHOWN : 0;
      var lbl = inner.querySelector('.cnb-section-label');
      if (lbl) lbl.innerHTML = cnbSectionLabelHtml(nomCount);
      _reconcileCharmThumbs(inner.querySelector('.cnb-charms-row'), allImgs.slice(0, MAX_SHOWN), overflow);
    }

    // Section C: progress (text / style updates only)
    if (cycleProgress === 0) {
      if (!inner.querySelector('.cnb-zero-row')) {
        // active → zero transition
        var nr = inner.querySelector('.cnb-next-row'); if (nr) nr.remove();
        var be = inner.querySelector('.cnb-bar');      if (be) be.remove();
        var me = inner.querySelector('.cnb-msg-sm');   if (me) me.remove();
        var tmp = document.createElement('div');
        tmp.innerHTML = '<div class="cnb-zero-row">' +
          '<span class="cnb-zero-label">' + window.CT(earned === 0 ? 'NÁRAMOK ZADARMO' : 'ĎALŠÍ NÁRAMOK ZADARMO') + '</span>' +
          '<span class="cnb-zero-count">0 / ' + NOM_THRESHOLD + '</span></div>' +
          '<div class="cnb-zero-hint">Ešte ' + NOM_THRESHOLD + window.CT(' príveskov</div>');
        while (tmp.firstChild) inner.appendChild(tmp.firstChild);
      } else {
        var zl = inner.querySelector('.cnb-zero-label');
        if (zl) zl.textContent = window.CT(earned === 0 ? 'NÁRAMOK ZADARMO' : 'ĎALŠÍ NÁRAMOK ZADARMO');
      }
    } else {
      var pct = Math.round(cycleProgress / NOM_THRESHOLD * 100);
      if (!inner.querySelector('.cnb-next-row')) {
        // zero → active transition
        var zr = inner.querySelector('.cnb-zero-row'); if (zr) zr.remove();
        var zh = inner.querySelector('.cnb-zero-hint'); if (zh) zh.remove();
        var tmp2 = document.createElement('div');
        tmp2.innerHTML =
          '<div class="cnb-next-row"><span class="cnb-next-label">' + window.CT(earned === 0 ? 'NÁRAMOK ZADARMO' : 'ĎALŠÍ NÁRAMOK ZADARMO') + '</span>' +
          '<span class="cnb-count-sm">' + cycleProgress + ' / ' + NOM_THRESHOLD + '</span></div>' +
          '<div class="cnb-bar" style="display:block;width:100%;height:6px;border-radius:3px;margin:4px 0;background:linear-gradient(90deg,#044a40 ' + pct + '%,#E2DDD8 ' + pct + '%)"></div>' +
          '<div class="cnb-msg-sm">Ešte ' + remaining + ' ' + pluralPrivesok(remaining) + '</div>';
        while (tmp2.firstChild) inner.appendChild(tmp2.firstChild);
      } else {
        var nl = inner.querySelector('.cnb-next-label');
        if (nl) nl.textContent = window.CT(earned === 0 ? 'NÁRAMOK ZADARMO' : 'ĎALŠÍ NÁRAMOK ZADARMO');
        var csm = inner.querySelector('.cnb-count-sm');
        if (csm) csm.textContent = cycleProgress + ' / ' + NOM_THRESHOLD;
        var bf = inner.querySelector('.cnb-bar');
        if (bf) { bf.style.display='block'; bf.style.height='6px'; bf.style.background = 'linear-gradient(90deg,#044a40 ' + pct + '%,#E2DDD8 ' + pct + '%)'; }
        var ms = inner.querySelector('.cnb-msg-sm');
        if (ms) ms.textContent = window.CT('Ešte ') + remaining + ' ' + pluralPrivesok(remaining);
      }
    }
  }

  function renderBar(nomCount, charmItems, giftItems) {
    injectBarStyles();
    // Keep the sheet's data snapshot current, and live-update it while it is open
    _cnbItems = charmItems || [];
    _cnbCount = nomCount;
    if (cnbSheetIsOpen()) cnbSyncSheet();
    var el = document.getElementById('charma-nom-bar');
    if (el) {
      // Reconcile in-place — no innerHTML wipe, no flicker
      _reconcileBar(el.querySelector('.cnb-inner'), nomCount, charmItems, giftItems);
      return;
    }
    // First render: build full HTML
    el = document.createElement('div');
    el.id = 'charma-nom-bar';
    el.innerHTML = '<div class="cnb-inner">' + buildInner(nomCount, charmItems, giftItems) + '</div>';

    if (isNomCollection) {
      var grid = document.querySelector('#product-grid, #CollectionProductGrid, .product-grid');
      if (grid) {
        el.style.cssText += ';position:sticky;top:80px;z-index:2;box-shadow:0 2px 8px rgba(0,0,0,0.07)';
        grid.insertAdjacentElement('beforebegin', el);
        setTimeout(function() {
          var sh = document.querySelector('sticky-header');
          if (sh) { el.style.top = Math.round(sh.getBoundingClientRect().bottom) + 8 + 'px'; }
        }, 800);
      }
    } else {
      var anchor = document.querySelector('.price.price--large, .price--large, .price');
      if (anchor) anchor.insertAdjacentElement('afterend', el);
    }
  }

  var _prevNomCount = -1;

  function fireConfetti() {
    var script = document.createElement('script');
    script.src = 'https://cdn.jsdelivr.net/npm/canvas-confetti@1.9.2/dist/confetti.browser.min.js';
    script.onload = function() {
      var colors = ['#044a40', '#C9A35D', '#F3F1EE', '#ffffff', '#D4B483'];
      confetti({ particleCount: 120, spread: 70, origin: { y: 0.55 }, colors: colors });
      setTimeout(function() {
        confetti({ particleCount: 60, angle: 60, spread: 60, origin: { x: 0, y: 0.6 }, colors: colors });
      }, 250);
      setTimeout(function() {
        confetti({ particleCount: 60, angle: 120, spread: 60, origin: { x: 1, y: 0.6 }, colors: colors });
      }, 450);
    };
    document.head.appendChild(script);
  }

  var _renderSeq = 0;
  function refresh() {
    var seq = ++_renderSeq;
    fetch('/cart.js', { cache: 'no-store' })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        if (seq !== _renderSeq) return; // stale response — discard
        var charmItems = [];
        var giftItems  = [];
        var paidBr     = [];
        var n = cart.items.reduce(function(s, i) {
          if (isGiftItem(i)) {
            // Collect one entry per quantity for each gift bracelet
            var gUrl = (i.featured_image && i.featured_image.url) ? i.featured_image.url : i.image;
            for (var q = 0; q < i.quantity; q++) giftItems.push({ img: gUrl });
            return s; // exclude from charm count
          }
          // A paid bracelet is not a charm — its SKU matches the charm pattern,
          // so it must be skipped explicitly or the bar would over-count.
          if (GIFT_VARIANT_IDS.indexOf(i.variant_id) !== -1) {
            var bUrl = (i.featured_image && i.featured_image.url) ? i.featured_image.url : i.image;
            for (var bq = 0; bq < i.quantity; bq++) paidBr.push({ img: bUrl });
            return s;
          }
          if (!isNomSku(i.sku)) return s;
          var imgUrl = (i.featured_image && i.featured_image.url) ? i.featured_image.url : i.image;
          if (imgUrl) charmItems.push({
            img:   imgUrl,
            qty:   i.quantity,
            key:   i.key,                              // line key — used by /cart/change.js
            title: i.product_title || i.title || '',
            price: i.final_line_price,
            url:   i.url
          });
          return s + i.quantity;
        }, 0);
        // Náramok, ktorý si zákazník vybral sám (ktorákoľvek z 5 farieb), zľava
        // 7+1 vynuluje — rátame ho ako uplatnený darček, nie ako chýbajúci.
        var earnedN = Math.floor(n / NOM_THRESHOLD);
        while (giftItems.length < earnedN && paidBr.length) giftItems.push(paidBr.shift());
        // Fire confetti + show gift popup when new reward threshold crossed
        if (_prevNomCount >= 0 && Math.floor(n / NOM_THRESHOLD) > Math.floor(_prevNomCount / NOM_THRESHOLD)) {
          fireConfetti();
          // Cancel any pending "Pridané" toast and show gift popup instead (no cart open)
          var _existingToast = document.getElementById('charma-toast');
          if (_existingToast) { clearTimeout(_existingToast._hideTimer); _existingToast.remove(); }
          setTimeout(function() { if (window.charmaCheckGift) window.charmaCheckGift(); }, 300);
        }
        _prevNomCount = n;
        /* total_price je PO zľavách, takže darček za 0 € je už zarátaný */
        _cnbTotal = (typeof cart.total_price === 'number') ? cart.total_price : 0;
        renderBar(n, charmItems, giftItems);
      })
      .catch(function() {});
  }

  // startTracking — викликається ТІЛЬКИ після підтвердження що це Nomination сторінка
  function startTracking() {
    window.charmaNomRefresh = refresh;
    refresh();

    // Dawn PubSub
    if (window.subscribe && window.PUB_SUB_EVENTS) {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function() { setTimeout(refresh, 400); });
    }

    // Fallback: watch cart badge count
    var _prevCount = -1;
    setInterval(function() {
      var sp = document.querySelector('#cart-icon-bubble .cart-count-bubble span[aria-hidden]');
      var c = sp ? (parseInt(sp.textContent) || 0) : 0;
      if (c !== _prevCount) { _prevCount = c; setTimeout(refresh, 400); }
    }, 2000);
  }

  // Decide from the collection's own products whether it holds Charma Italia
  // charms. Handle-based matching cannot work for sub-categories, and this way
  // any new sub-category starts showing the bar without a code change.
  // Result is cached per handle for the session so it costs one request.
  function detectCharmCollection(handle) {
    if (!handle) return Promise.resolve(false);
    var CK = 'cnb-charmcoll-' + handle;
    try {
      var cached = sessionStorage.getItem(CK);
      if (cached !== null) return Promise.resolve(cached === '1');
    } catch (e) {}

    return fetch('/collections/' + encodeURIComponent(handle) + '/products.json?limit=10')
      .then(function(r) { return r.json(); })
      .then(function(d) {
        var ps = (d && d.products) || [];
        if (!ps.length) return false;
        var ok = 0;
        ps.forEach(function(p) {
          var tags = p.tags;
          if (typeof tags === 'string') tags = tags.split(',');
          // Tag is the precise signal: the main collection is literally built
          // from TAG = Nomination, so every Charma Italia product carries it.
          // SKU shape is deliberately NOT used here — /^A\d/ would also match
          // unrelated products and light the bar up on the wrong pages.
          var tagged = (tags || []).some(function(t) {
            return /^\s*(nomination|italia)\s*$/i.test(String(t));
          });
          if (tagged) ok++;
        });
        // Require a clear majority so unrelated collections never light up
        return ok >= Math.ceil(ps.length * 0.6);
      })
      .catch(function() { return false; })
      .then(function(res) {
        try { sessionStorage.setItem(CK, res ? '1' : '0'); } catch (e) {}
        return res;
      });
  }

  if (isProductPage) {
    var m = path.match(/\/products\/([^/?]+)/);
    if (!m) return;
    fetch('/products/' + m[1] + '.js')
      .then(function(r) { return r.json(); })
      .then(function(p) {
        if (p.tags && p.tags.indexOf('Nomination') !== -1) {
          startTracking();
        }
        // якщо не Nomination — нічого не робимо, setInterval НЕ запускається
      })
      .catch(function() {});
  } else if (isNomCollection) {
    // Main Charma Italia collection — start immediately
    startTracking();
  } else {
    // Sub-category collection (/collections/silver, /heart, /flowers, …)
    detectCharmCollection(collHandle).then(function(ok) {
      if (!ok) return;
      isNomCollection = true;   // lets renderBar() pin the bar above the grid
      startTracking();
    });
  }
})();

// ============================================================
// 12. VIDEO POSTER — захоплює перший кадр через canvas і встановлює як poster
//     Усуває чорний екран до початку відтворення HLS відео
// ============================================================
(function() {
  function capturePoster(video) {
    if (video.poster) return; // вже є poster
    function doCapture() {
      try {
        var canvas = document.createElement('canvas');
        canvas.width = video.videoWidth || 480;
        canvas.height = video.videoHeight || 854;
        var ctx = canvas.getContext('2d');
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
        var dataUrl = canvas.toDataURL('image/jpeg', 0.85);
        if (dataUrl.length > 5000) {
          video.poster = dataUrl;
        }
      } catch(e) {}
    }

    function seekAndCapture() {
      if (video.readyState < 1) return;
      video.addEventListener('seeked', doCapture, { once: true });
      video.currentTime = 0.5;
    }

    if (video.readyState >= 1) {
      seekAndCapture();
    } else {
      video.addEventListener('loadedmetadata', seekAndCapture, { once: true });
    }
  }

  function initPosters() {
    document.querySelectorAll('video').forEach(capturePoster);
  }

  // Запускаємо після завантаження сторінки
  if (document.readyState === 'complete') {
    setTimeout(initPosters, 500);
  } else {
    window.addEventListener('load', function() { setTimeout(initPosters, 500); });
  }

  // Також спостерігаємо за динамічно доданими відео (EcomPoser)
  if ('MutationObserver' in window) {
    var mo = new MutationObserver(function(mutations) {
      mutations.forEach(function(m) {
        m.addedNodes.forEach(function(node) {
          if (node.nodeName === 'VIDEO') capturePoster(node);
          if (node.querySelectorAll) {
            node.querySelectorAll('video').forEach(capturePoster);
          }
        });
      });
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }
})();


// ============================================================
// Плавающая кнопка корзины — мобил (коллекции + товары)
// ============================================================
(function() {
  var path = window.location.pathname;
  var show = path.indexOf('/collections/') !== -1 || path.indexOf('/products/') !== -1;
  if (!show) return;

  var btn = document.createElement('button');
  btn.id = 'charma-float-cart';
  btn.style.cssText = 'position:fixed;bottom:80px;right:16px;width:56px;height:56px;border-radius:50%;background:#fff;box-shadow:0 4px 16px rgba(0,0,0,0.2);border:none;cursor:pointer;z-index:9998;display:flex;align-items:center;justify-content:center;padding:0';
  btn.innerHTML =
    '<svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#044a40" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg>' +
    '<span id="charma-float-badge" style="display:none;position:absolute;top:4px;right:4px;background:#044a40;color:#fff;font-size:10px;font-weight:700;min-width:16px;height:16px;border-radius:8px;align-items:center;justify-content:center;padding:0 3px;line-height:1"></span>';
  document.body.appendChild(btn);

  var badge = document.getElementById('charma-float-badge');

  // Синхронизируем счётчик с иконкой корзины в хедере
  function syncBadge() {
    var sp = document.querySelector('#cart-icon-bubble .cart-count-bubble span[aria-hidden]');
    var n = sp ? (parseInt(sp.textContent) || 0) : 0;
    if (n > 0) {
      badge.textContent = n;
      badge.style.display = 'flex';
    } else {
      badge.style.display = 'none';
    }
  }

  syncBadge();

  // Следим за обновлениями счётчика в хедере
  var bubble = document.getElementById('cart-icon-bubble');
  if (bubble && window.MutationObserver) {
    new MutationObserver(syncBadge).observe(bubble, { childList: true, subtree: true });
  }

  btn.addEventListener('click', function() {
    // ВАЖНО: открывать только через charmaOpenCart() (секция 1).
    //
    // Раньше здесь дублировалась отправка событий на .opus-section-sticky,
    // но БЕЗ двух вещей, которые делает charmaOpenCart():
    //   window.__charmaAllowOpen = true   — снимает блокировку opusOpen
    //   removeShadowCSS()                 — убирает из shadow root правило
    //                                       .opus-drawer-container{display:none}
    //
    // Из-за этого при нажатии на эту кнопку корзина открывалась, тёмная
    // подложка появлялась, а сам ящик оставался скрытым — чёрный экран
    // без корзины. Проявлялось через раз: приложение рисует drawer то в
    // обычном DOM (там блокирующего CSS нет — работало), то в Shadow DOM
    // (там он есть — не работало).
    if (typeof window.charmaOpenCart === 'function') {
      window.charmaOpenCart();
      return;
    }
    // Запасной путь, если секция 1 почему-то не загрузилась
    var cartBtn = document.getElementById('cart-icon-bubble');
    if (cartBtn) cartBtn.click();
    else window.location.href = '/cart';
  });
})();

// ============================================================
// 14. FREE SHIPPING PROGRESS BAR
//     Cart drawer + /cart page + product page.
//     Threshold lives in ONE constant — change it in a single place.
// ============================================================
(function() {
  var L10N = window.CHARMA_L10N || {};
  var FREE_SHIP_CENTS = L10N.freeShipCents || 4900;      // 49 € / 1 199 Kč
  var SHIP_FROM_TEXT  = L10N.isPl
    ? 'Dostawa do Paczkomatu InPost już od <b>' + (L10N.pickupPrice || '2,49 €') + '</b>'
    : L10N.isCs
    ? 'Doprava na výdejní místo nebo do Z-BOXu jen <b>' + L10N.pickupPrice + '</b>'
    : 'Doprava na výdajné miesto alebo do Z-BOXu len <b>' + (L10N.pickupPrice || '2,49 €') + '</b>';

  function money(c) { return window.charmaMoney(c); }

  // Threshold without trailing ",00" — "40 €" reads cleaner than "40,00 €"
  function moneyShort(c) { return window.charmaMoney(c, true); }

  // ── Minimal line icons (no emoji) ─────────────────────────────────────────
  var ICON_TRUCK =
    '<svg width="12" height="12" viewBox="0 0 16 16" fill="none" aria-hidden="true">' +
    '<path d="M1.3 3.9h7v6.5h-7zM8.3 6.3h2.8l2.6 2.4v1.7H8.3z" stroke="#00584D" ' +
    'stroke-width="1.25" stroke-linejoin="round"/>' +
    '<circle cx="4.6" cy="12.2" r="1.35" stroke="#00584D" stroke-width="1.25"/>' +
    '<circle cx="11.3" cy="12.2" r="1.35" stroke="#00584D" stroke-width="1.25"/></svg>';
  var ICON_GIFT =
    '<svg width="9" height="9" viewBox="0 0 12 12" fill="none" aria-hidden="true">' +
    '<path d="M1.6 5.2h8.8v5.2H1.6zM1 3.4h10v1.8H1zM6 3.4v7" stroke="#A9A29A" ' +
    'stroke-width="1.1" stroke-linejoin="round"/></svg>';
  var ICON_CHECK =
    '<svg width="9" height="7" viewBox="0 0 10 8" fill="none" aria-hidden="true">' +
    '<path d="M1 4l2.6 2.8L9 1.2" stroke="#fff" stroke-width="1.8" ' +
    'stroke-linecap="round" stroke-linejoin="round"/></svg>';

  // One stylesheet, used in the document AND inside the Opus shadow root.
  var BAR_CSS = [
    '.cfs-bar{background:#fff;border:1px solid #E5E1D9;border-radius:12px;',
    'padding:9px 12px 10px;box-sizing:border-box;display:block;text-align:left;',
    'box-shadow:none;font-family:inherit}',

    '.cfs-row{display:flex;align-items:center;justify-content:space-between;gap:8px}',
    '.cfs-label{display:flex;align-items:center;gap:5px;font-size:11px;font-weight:700;',
    'letter-spacing:.09em;text-transform:uppercase;color:#171717;line-height:1}',
    '.cfs-label svg{display:block;flex-shrink:0}',
    '.cfs-amt{font-size:11.5px;font-weight:600;color:#171717;flex-shrink:0;',
    'line-height:1;white-space:nowrap}',
    '.cfs-amt i{font-style:normal;font-weight:500;color:#A09A92;margin-left:2px}',

    // min-height keeps the row from collapsing when the text swaps → no jump
    '.cfs-msg{font-size:11px;color:#666761;line-height:1.35;margin-top:4px;min-height:15px}',
    '.cfs-msg b{color:#00584D;font-weight:700}',
    '.cfs-note{font-size:10.5px;color:#8A847B;line-height:1.35;margin-top:6px}',
    '.cfs-note b{color:#00584D;font-weight:600}',
    '.cfs-bar.is-done .cfs-note{display:none}',

    '.cfs-barrow{display:flex;align-items:center;gap:7px;margin-top:6px}',
    '.cfs-track{flex:1 1 auto;height:6px;border-radius:99px;background:#E5E1D9;',
    'overflow:hidden;display:block}',
    // Výplň je SPAN, nie DIV — téma má pravidlo `div:empty{display:none}`,
    // ktoré by prázdny div zhaslo (presne to sa stalo lište 7+1).
    // Explicitná výška, nikdy height:100%. Animuje sa šírka, takže výplň
    // plynie namiesto skokov.
    '.cfs-fill{display:block;height:6px;width:0;border-radius:99px;background:#00584D;',
    'transition:width .5s cubic-bezier(.4,0,.2,1)}',

    '.cfs-mile{width:18px;height:18px;border-radius:50%;flex-shrink:0;background:#fff;',
    'border:1.2px solid #DCD6CD;display:flex;align-items:center;justify-content:center;',
    'box-sizing:border-box;transition:background .3s ease,border-color .3s ease}',
    '.cfs-mile svg{display:block}',

    '.cfs-bar.is-done{background:#F7F6F0;border-color:#E5E1D9}',
    '.cfs-bar.is-done .cfs-mile{background:#00584D;border-color:#00584D}'
  ].join('');

  function injectStyles() {
    if (document.getElementById('cfs-styles')) return;
    var s = document.createElement('style');
    s.id = 'cfs-styles';
    s.textContent = BAR_CSS + '.cfs-bar{margin:10px 0}';
    document.head.appendChild(s);
  }

  function skeleton() {
    return '<div class="cfs-row">' +
        '<span class="cfs-label">' + ICON_TRUCK + '<span>' + window.CT('Doprava zadarmo') + '</span></span>' +
        '<span class="cfs-amt"></span>' +
      '</div>' +
      '<div class="cfs-msg"></div>' +
      '<div class="cfs-barrow">' +
        '<span class="cfs-track"><span class="cfs-fill" style="height:6px;width:0"></span></span>' +
        '<span class="cfs-mile"></span>' +
      '</div>' +
      '<div class="cfs-note">' + SHIP_FROM_TEXT + '</div>';
  }

  // Builds the skeleton once, then only touches the values. Rewriting innerHTML
  // on every update would restart the CSS transition and kill the animation.
  function render(el, total) {
    if (!el.querySelector('.cfs-fill')) el.innerHTML = skeleton();

    var done = total >= FREE_SHIP_CENTS;
    var left = Math.max(0, FREE_SHIP_CENTS - total);
    var pct  = Math.max(0, Math.min(100, total / FREE_SHIP_CENTS * 100));

    if (el.classList.contains('is-done') !== done) el.classList.toggle('is-done', done);

    var amt = el.querySelector('.cfs-amt');
    var amtHtml = done ? money(total)
                       : money(total) + '<i>/ ' + moneyShort(FREE_SHIP_CENTS) + '</i>';
    if (amt && amt.innerHTML !== amtHtml) amt.innerHTML = amtHtml;

    var msg = el.querySelector('.cfs-msg');
    var msgHtml = window.CT(done ? '<b>Máte dopravu zadarmo</b>'
                       : 'Pridajte ešte <b>' + money(left) + '</b> a máte dopravu zadarmo');
    if (msg && msg.innerHTML !== msgHtml) msg.innerHTML = msgHtml;

    var fill = el.querySelector('.cfs-fill');
    var w = pct.toFixed(1) + '%';
    if (fill && fill.style.width !== w) fill.style.width = w;

    var mile = el.querySelector('.cfs-mile');
    var icon = done ? ICON_CHECK : ICON_GIFT;
    if (mile && mile.innerHTML !== icon) mile.innerHTML = icon;
  }

  // Each surface gets its own node id so all of them can coexist.
  function targets() {
    var out = [];
    var d = document.querySelector(
      'cart-drawer .drawer__footer, cart-drawer .cart-drawer__footer, #CartDrawer .drawer__footer');
    if (d && d.parentNode) out.push({ anchor: d, how: 'before', id: 'cfs-drawer' });

    var c = document.querySelector('#main-cart-footer, .cart__footer');
    if (c && c.parentNode) out.push({ anchor: c, how: 'before', id: 'cfs-cart' });

    var p = document.querySelector('.product-form__buttons');
    if (p) out.push({ anchor: p, how: 'after', id: 'cfs-product' });

    return out;
  }

  // ── Opus cart drawer (cdn.506.io) lives in a Shadow DOM ────────────────────
  // Styles in document.head do NOT cross the shadow boundary, so the CSS has to
  // be injected into the shadow root as well. Anchor is .opus-customization-text
  // — the static "Doprava zdarma pri nákupe nad 40 €" line above the checkout
  // button; it is hidden and this live bar takes its place.
  // Opus drawer sa vykresľuje RAZ v shadow roote, INOKEDY priamo v dokumente
  // — a medzi načítaniami stránky sa to prepína. Preto sa hľadá ten root,
  // ktorý práve obsahuje kotvu. Vracia null len keď drawer na stránke nie je.
  function opusRoot() {
    var host = document.getElementById('opus-shadow-container');
    if (host && host.shadowRoot &&
        host.shadowRoot.querySelector('.opus-customization-text')) {
      return host.shadowRoot;
    }
    if (document.querySelector('.opus-customization-text')) return document;
    return null;
  }

  // Same stylesheet as the document copy, plus the rule that hides the static
  // duplicate line. Delete that one rule to bring the original text back.
  var SHADOW_CSS = BAR_CSS +
    '.cfs-bar{margin:0 0 10px}' +
    '.opus-customization-text{display:none !important}';

  function paintOpus() {
    var root = opusRoot();
    if (!root) return;

    // Štýly musia ísť do toho istého rootu — do shadow rootu sa CSS
    // z document.head nedostane, a naopak.
    var styleHost = (root === document) ? document.head : root;
    if (!styleHost.querySelector('#cfs-shadow-styles')) {
      var st = document.createElement('style');
      st.id = 'cfs-shadow-styles';
      st.textContent = SHADOW_CSS;
      styleHost.appendChild(st);
    }

    var anchor = root.querySelector('.opus-customization-text');
    if (!anchor || !anchor.parentNode) return;

    var el = root.querySelector('#cfs-opus');
    if (!el || !el.isConnected) {
      el = document.createElement('div');
      el.id = 'cfs-opus';
      el.className = 'cfs-bar';
      anchor.parentNode.insertBefore(el, anchor);
    }
    render(el, _total);
  }

  var _total = null;

  function paint() {
    if (_total === null) return;
    injectStyles();
    targets().forEach(function(t) {
      var el = document.getElementById(t.id);
      if (!el || !el.isConnected) {
        el = document.createElement('div');
        el.id = t.id;
        el.className = 'cfs-bar';
        if (t.how === 'before') t.anchor.parentNode.insertBefore(el, t.anchor);
        else t.anchor.insertAdjacentElement('afterend', el);
      }
      render(el, _total);   // value-only updates, so the observer sees no churn
    });
    paintOpus();
  }

  var _seq = 0;
  function refresh() {
    var seq = ++_seq;
    fetch('/cart.js', { cache: 'no-store' })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        if (seq !== _seq) return;   // stale response
        // total_price is AFTER discounts, so a 0 € gift line is already handled
        _total = typeof cart.total_price === 'number' ? cart.total_price : 0;
        paint();
      })
      .catch(function() {});
  }

  function boot() {
    refresh();

    if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function() { setTimeout(refresh, 300); });
    }
    ['cart:updated', 'cart:refresh', 'on:cart:update'].forEach(function(ev) {
      document.addEventListener(ev, function() { setTimeout(refresh, 120); });
    });

    // Dawn swaps the drawer markup wholesale on every update, which deletes the
    // injected node — re-inject whenever the DOM changes, throttled.
    if (window.MutationObserver) {
      var pending = false;
      new MutationObserver(function() {
        if (pending) return;
        pending = true;
        setTimeout(function() { pending = false; paint(); }, 150);
      }).observe(document.body, { childList: true, subtree: true });
    }

    // A MutationObserver on document.body does NOT see mutations inside a shadow
    // root, and Opus re-renders its drawer constantly — so the shadow copy needs
    // its own watch. Cheap: paintOpus() is a no-op unless something changed.
    setInterval(function() { if (_total !== null) paintOpus(); }, 400);

    // Fallback for themes/apps that fire no events: watch the cart badge
    var prev = -1;
    setInterval(function() {
      var sp = document.querySelector('#cart-icon-bubble .cart-count-bubble span[aria-hidden]');
      var c = sp ? (parseInt(sp.textContent) || 0) : 0;
      if (c !== prev) { prev = c; setTimeout(refresh, 300); }
    }, 2000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
/* ─────────────────────────────────────────────────────────────────────────
   Module 16 — Charma Italia reward bar inside the cart drawer

   Prečo: aplikácia košíka vie vykresliť len JEDNU míľnikovú lištu naraz.
   Keď sú aktívne dve kampane (3+1 pre Pandora a 7+1 pre Charma Italia),
   v košíku sa zobrazí tá nesprávna — zákazník na stránke počíta do 7,
   ale v košíku mu svieti "pridaj 1 a získaj 4. produkt zadarmo".

   Čo robí: ak sú v košíku prívesky Charma Italia, skryje lištu aplikácie
   a na jej miesto vykreslí správnu 7+1 lištu. Ak sú v košíku len produkty
   Pandora, nechá lištu aplikácie tak, ako je.

   Žiadne Pro predplatné nie je potrebné.
   ───────────────────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  var THRESHOLD = 7;                    // príveskov na jeden náramok zadarmo
  var APP_BAR   = '.cd-rewards-container';
  var BAR_ID    = 'charma-cart-reward';
  var CSS_ID    = 'charma-cart-reward-css';
  var TICK_MS   = 500;

  var CSS =
    /* margin rovnaký ako v Module 17 — nech je lišta zarovnaná s kartami
       bez ohľadu na to, ktorý <style> sa vloží ako posledný */
    '#' + BAR_ID + '{background:#F3F0EB;border-radius:12px;padding:9px 14px;' +
      'margin:12px 10px 10px;font-family:inherit;text-align:left}' +
    '#' + BAR_ID + ' .ccr-top{display:flex;align-items:baseline;' +
      'justify-content:space-between;gap:8px;margin-bottom:6px}' +
    '#' + BAR_ID + ' .ccr-label{font-size:11px;font-weight:700;letter-spacing:.09em;' +
      'text-transform:uppercase;color:#075B4C}' +
    '#' + BAR_ID + ' .ccr-count{font-size:12px;font-weight:700;color:#075B4C;white-space:nowrap}' +
    /* Jeden element s gradientom namiesto vnoreného .ccr-fill.
       Téma má CSS, ktoré vnorené výplne v progress baroch schováva
       (display:none) — rovnaký problém bol pri lište na kolekcii.
       Gradient sa nastavuje inline vo funkcii paint(). */
    '#' + BAR_ID + ' .ccr-track{display:block;height:6px;border-radius:99px;' +
      'background:#EAE4D9;transition:background .45s ease}' +
    '#' + BAR_ID + ' .ccr-msg{margin-top:5px;font-size:12px;line-height:1.35;color:#5d574e}';

  /* ── Košík aplikácie môže byť v light DOM aj v shadow root ───────────── */
  function roots() {
    var out  = [document];
    var host = document.getElementById('opus-shadow-container');
    if (host && host.shadowRoot) out.push(host.shadowRoot);
    return out;
  }

  function q(sel) {
    var rs = roots();
    for (var i = 0; i < rs.length; i++) {
      var el = rs[i].querySelector(sel);
      if (el) return el;
    }
    return null;
  }

  function injectCss(target) {
    if (target.querySelector && target.querySelector('#' + CSS_ID)) return;
    var s = document.createElement('style');
    s.id = CSS_ID;
    s.textContent = CSS;
    (target === document ? document.head : target).appendChild(s);
  }

  /* ── Prívesok Charma Italia? Darčekové riadky sa nerátajú ────────────── */
  function isItaliaCharm(item) {
    if (window.CharmaReward && window.CharmaReward.isPromoLine &&
        window.CharmaReward.isPromoLine(item)) return false;
    var p = item.properties || {};
    if (p._promo_reward || p._gift === 'true' || p._gift === true) return false;
    if (isBracelet(item)) return false;       // náramok nie je prívesok
    return /^(ACC|A\d)/i.test(item.sku || '');
  }

  function isBracelet(item) {
    var ids = window.CHARMA_BRACELET_VIDS ||
      [51879076594001, 51879089340753, 51879096779089, 54987325702481, 54987325800785];
    return ids.indexOf(item.variant_id) !== -1;
  }

  /* ── Krátka cache, aby sme netrieskali /cart.js pri každom tiku ──────── */
  var cache = null, fetchedAt = 0, busy = false;

  function getCart(cb) {
    if (cache && Date.now() - fetchedAt < 1200) { cb(cache); return; }
    if (busy) return;
    busy = true;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { cache = c; fetchedAt = Date.now(); busy = false; cb(c); })
      .catch(function () { busy = false; });
  }

  function plural(n) {
    if (n === 1) return window.CT(' prívesok');
    if (n < 5)   return window.CT(' prívesky');
    return window.CT(' príveskov');
  }

  function paint() {
    var appBar = q(APP_BAR);
    if (!appBar) return;                       // košík nie je otvorený

    getCart(function (cart) {
      var qty = (cart.items || []).reduce(function (s, i) {
        return s + (isItaliaCharm(i) ? i.quantity : 0);
      }, 0);

      /* Žiadne Charma Italia — necháme lištu aplikácie na pokoji */
      if (!qty && !(window.CHARMA_L10N && window.CHARMA_L10N.isPl && (cart.items || []).some(isBracelet))) {
        appBar.style.display = '';
        var old = q('#' + BAR_ID);
        if (old) old.remove();
        return;
      }

      appBar.style.display = 'none';

      var root = appBar.getRootNode ? appBar.getRootNode() : document;
      injectCss(root === document || !root.querySelector ? document : root);

      var bar = q('#' + BAR_ID);
      if (!bar) {
        bar = document.createElement('div');
        bar.id = BAR_ID;
        bar.innerHTML =
          '<div class="ccr-top"><span class="ccr-label"></span>' +
          '<span class="ccr-count"></span></div>' +
          '<div class="ccr-track"></div>' +
          '<div class="ccr-msg"></div>';
        appBar.parentNode.insertBefore(bar, appBar);
      }

      var earned = Math.floor(qty / THRESHOLD);
      var into   = qty % THRESHOLD;
      var left   = THRESHOLD - into;
      var done   = earned > 0 && into === 0;
      var shown  = done ? THRESHOLD : into;

      bar.classList.toggle('is-done', earned > 0);
      bar.querySelector('.ccr-label').textContent =
        window.CT(earned > 0 ? 'ĎALŠÍ NÁRAMOK ZADARMO' : 'NÁRAMOK ZADARMO');
      bar.querySelector('.ccr-count').textContent = shown + ' / ' + THRESHOLD;
      /* Inline gradient — prebije akékoľvek pravidlo z témy aj z Module 17.
         Zlatá #C8A15A = akcia / darček. Zelená #00584D ostáva lište
         dopravy zdarma, aby sa tie dve lišty nezlievali. */
      var pct = Math.round(shown / THRESHOLD * 100);
      bar.querySelector('.ccr-track').style.background =
        'linear-gradient(90deg,#C8A15A ' + pct + '%,#EAE4D9 ' + pct + '%)';
      var hasBracelet = (cart.items || []).some(function (i) {
        return isBracelet(i) || (window.CharmaReward && window.CharmaReward.isPromoLine &&
          window.CharmaReward.isPromoLine(i));
      });
      bar.querySelector('.ccr-msg').textContent = done
        ? window.CT(hasBracelet ? 'Váš náramok je zadarmo 🎁' : 'Máte nárok na náramok zadarmo 🎁')
        : window.CT('Ešte ') + left + plural(left);
    });
  }

  setInterval(paint, TICK_MS);

  /* Po kliknutí (+/-/odstrániť) zhodíme cache, nech sa lišta prekreslí hneď */
  document.addEventListener('click', function () {
    setTimeout(function () { cache = null; paint(); }, 400);
  }, true);

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) { cache = null; paint(); }
  });

  paint();
})();


/* ─────────────────────────────────────────────────────────────────────────
   Module 17 — Cart drawer skin

   Vizuálne zjednotenie košíka: teplá ivory paleta, emerald CTA,
   karty produktov s okrajom, odstránenie zelenkavého nádychu v spodnej
   časti (#F1F7E9 → #F7F6F0).

   Rozsah: výhradne #opus-drawer-id — toto ID existuje len vnútri cart
   draweru, takže na ostatné stránky to nemá žiadny vplyv.

   Paleta: emerald #00584D · cart bg #FCFBF8 · karta #FFFFFF
           promo #F3F0EB · spodok #F7F6F0 · text #171917
           text vedľajší #666761 · okraje #E5E1D9

   !important je len na troch miestach — aplikácia košíka sama používa
   `#opus-drawer-id .bottom-section { padding: … !important }` a inak sa
   odsadenia nedajú prebiť.
   ───────────────────────────────────────────────────────────────────────── */
(function () {
  'use strict';
  if (window.__charmaCartSkin) return;
  window.__charmaCartSkin = true;

  var css = [
    /* shell + hlavička */
    '#opus-drawer-id .opus-drawer-container{background:#FCFBF8}',
    '#opus-drawer-id .opus-drawer-container-header,',
    '#opus-drawer-id .opus-drawer-container-close{background:#00584D}',
    '#opus-drawer-id .opus-title-header{color:#fff;letter-spacing:.01em}',

    /* scrollovacia plocha */
    '#opus-drawer-id .cdr-main-color{background:#FCFBF8}',

    /* blok "náramok zadarmo" */
    '#opus-drawer-id #charma-cart-reward{background:#F3F0EB;border-radius:12px;' +
      'margin:12px 10px 10px}',
    '#opus-drawer-id #charma-cart-reward .ccr-label,',
    '#opus-drawer-id #charma-cart-reward .ccr-count{color:#00584D}',
    /* .ccr-track dostáva gradient inline z Module 16 — tu je len základ,
       kým prvý paint() prebehne */
    '#opus-drawer-id #charma-cart-reward .ccr-track{background:#EAE4D9}',
    '#opus-drawer-id #charma-cart-reward .ccr-msg{color:#666761}',

    /* ── Lišta akcie od aplikácie (3+1 pre Pandora) ────────────────────
       Zlatá #C8A15A, aby sa nezlievala so zelenou lištou dopravy zdarma.
       Zelená ostáva doprave — dva rôzne ciele, dve rôzne farby.
       Text lišty sa nemení, len výplň, ikona darčeka a podklad.         */
    '#opus-drawer-id .cd-progress-bar{background:#C8A15A !important}',
    '#opus-drawer-id .cd-icon-reward-2{background:#C8A15A !important}',
    '#opus-drawer-id .cd-progress-bar-background{background:#EAE4D9 !important}',

    /* karty produktov */
    /* Užší bočný odsadenie zoznamu = širšie karty (355 z 375 px na mobile),
       tak ako vo variante, ktorý sa páčil viac. */
    '#opus-drawer-id .cd-product-list{padding:12px 10px 0 !important}',
    '#opus-drawer-id .cd-product-item{background:#fff;border:1px solid #E0DACF;' +
      'border-radius:14px;padding:12px;margin:0 0 10px;' +
      'box-shadow:0 1px 3px rgba(23,25,23,.06)}',
    /* Väčšia fotka produktu — 80 -> 96 px.
       DÔLEŽITÉ: zväčšiť treba aj obal .opus-product-item-image-container.
       Ten má od aplikácie pevných 80x80 a overflow:hidden — keď sa zväčší
       len samotný <img>, obal mu odreže pravý a spodný okraj o 16 px. */
    '#opus-drawer-id .opus-product-item-image-container{width:96px !important;' +
      'height:96px !important;flex:0 0 96px !important}',
    '#opus-drawer-id .opus-product-item-image{width:96px !important;height:96px !important}',
    '#opus-drawer-id .opus-product-item-details{margin-left:14px !important}',
    '#opus-drawer-id .cd-product-item-header{color:#171917;font-weight:600}',
    '#opus-drawer-id .opus-wrapper-price-section{color:#171917}',

    /* odporúčania — !important je nutné: aplikácia dáva na nadpis inline
       style (font-size:20px; color:#000), ktorý inak prebiť nejde */
    '#opus-drawer-id .cd-upsell-title{font-size:18px !important;font-weight:600;' +
      'color:#171917 !important;letter-spacing:.04em;text-align:left;margin:4px 0 12px}',
    '#opus-drawer-id .opus-carousel-container{padding:0 10px !important}',

    /* spodná sekcia — preč so zelenkavým nádychom */
    '#opus-drawer-id .bottom-section{background:#F7F6F0;border-top:1px solid #E5E1D9;' +
      'padding:14px 16px 16px !important}',

    /* doprava zdarma */
    '#opus-drawer-id .opus-customization-text{background:#fff;border:1px solid #E5E1D9;' +
      'border-radius:10px;padding:10px 12px;margin:0 0 12px;text-align:center;' +
      'font-size:13px;color:#171917}',
    '#opus-drawer-id .opus-customization-text .label{color:#171917;font-size:13px}',

    /* checkout CTA */
    '#opus-drawer-id .cd-checkout-section-container{border-radius:12px}',
    '#opus-drawer-id .cd-checkout-section-button,',
    '#opus-drawer-id .cd-main-button{background:#00584D !important;color:#fff;border:0;' +
      'border-radius:12px;min-height:56px;font-size:16px;font-weight:600;' +
      'letter-spacing:.01em;box-shadow:none}',
    '#opus-drawer-id .cd-checkout-section-button:hover,',
    '#opus-drawer-id .cd-main-button:hover{background:#00463D !important}',
    '#opus-drawer-id .cd-checkout-section-button:active,',
    '#opus-drawer-id .cd-main-button:active{background:#003D35 !important}',

    /* platobné logá */
    '#opus-drawer-id .cd-image-grid-row-trustBg{margin-top:12px;opacity:.6}',

    /* "Pokračovať v nákupe" */
    '#opus-drawer-id .cd-bottom-button-group{margin:0;padding-top:10px}',
    '#opus-drawer-id .continue-shopping{font-size:13px;font-weight:500;color:#171917;' +
      'background:none;text-decoration:underline;text-underline-offset:3px}'
  ].join('\n');

  /* ── Vloženie štýlov ─────────────────────────────────────────────────
     Aplikácia košíka vykresľuje drawer raz v bežnom DOM, inokedy
     v Shadow DOM (mení sa to medzi načítaniami stránky — rovnaký problém
     mala lišta dopravy zdarma v Module 14).

     <style> v document.head sa do shadow rootu NEDOSTANE. Preto ho
     vkladáme do oboch a kontrolujeme opakovane, lebo shadow root
     vzniká až keď sa košík prvýkrát otvorí.

     V shadow roote pridávame aj kópiu pravidiel BEZ prefixu
     #opus-drawer-id — to ID tam nemusí existovať (býva na hostiteľovi).
     Ak existuje, vyhrá prefixovaná verzia (vyššia špecificita), takže
     duplicita nič nerozbije.                                            */
  var CSS_ID  = 'charma-cart-skin';
  var cssBare = css.replace(/#opus-drawer-id /g, '');

  function inject() {
    if (!document.getElementById(CSS_ID)) {
      var s = document.createElement('style');
      s.id = CSS_ID;
      s.textContent = css;
      document.head.appendChild(s);
    }
    var host = document.getElementById('opus-shadow-container');
    var root = host && host.shadowRoot;
    if (root && !root.querySelector('#' + CSS_ID)) {
      var s2 = document.createElement('style');
      s2.id = CSS_ID;
      s2.textContent = css + '\n' + cssBare;
      root.appendChild(s2);
    }
  }

  inject();
  setInterval(inject, 700);
  document.addEventListener('click', function () {
    setTimeout(inject, 300);
  }, true);
})();


/* ─────────────────────────────────────────────────────────────────────────
   Module 18 — Nadpis odporúčaní

   "Mohlo by sa vám tiež páčiť" → "Doplňte svoj výber"

   Prečo JS a nie CSS: nadpis vykresľuje aplikácia košíka, text sa cez CSS
   zmeniť nedá. Správne miesto je pole nadpisu v nastaveniach Opus — kým
   tam nie je prepísaný, drží ho tento modul.

   Mení sa VÝHRADNE text. Logika odporúčaní, karusel ani nič iné sa
   nedotýka.
   ───────────────────────────────────────────────────────────────────────── */
(function () {
  'use strict';
  if (window.__charmaUpsellTitle) return;
  window.__charmaUpsellTitle = true;

  var SEL  = '.cd-upsell-title';
  var TEXT = window.CT('Doplňte svoj výber');

  function roots() {
    var out = [document];
    var h = document.getElementById('opus-shadow-container');
    if (h && h.shadowRoot) out.push(h.shadowRoot);
    return out;
  }

  function apply() {
    var rs = roots();
    for (var i = 0; i < rs.length; i++) {
      var els = rs[i].querySelectorAll(SEL);
      for (var j = 0; j < els.length; j++) {
        if (els[j].textContent.trim() !== TEXT) els[j].textContent = TEXT;
      }
    }
  }

  setInterval(apply, 500);
  if (window.MutationObserver) {
    new MutationObserver(apply).observe(document.body, { childList: true, subtree: true });
  }
  apply();
})();


/* ─────────────────────────────────────────────────────────────────────────
   Module 19 — Spodný priestor v scrollovacej ploche košíka

   PROBLÉM
   Posledný blok v scrollovacej ploche (karusel "VYBRANÉ PRE VÁS") sa nedá
   doscrollovať celý. Spodná časť karty — tlačidlo do košíka, šípky a bodky
   karuselu — ostáva schovaná za spodnou lištou (doprava zdarma + checkout).

   PREČO
   Scrollovacia plocha .cdr-main-color má padding-bottom len 16 px. To stačí,
   kým je karta odporúčania nízka. Keď sa názov produktu zalomí do dvoch
   riadkov, karta narastie a 16 px nestačí.
   Navyše .opus-carousel-container má overflow:visible — šípky a bodky
   pretekajú mimo jeho box. Prečnievajúca časť sa NEPOČÍTA do scrollHeight
   scrollovacej plochy, takže sa k nej jednoducho nedá doscrollovať.

   RIEŠENIE
   Dynamicky dopočítať padding-bottom scrollovacej plochy zo skutočných
   rozmerov:

     padding-bottom = prekryv spodnou lištou
                    + env(safe-area-inset-bottom)   (iPhone home indicator)
                    + presah karuselu mimo jeho box
                    + 24 px rezerva

   Prekryv sa meria naozaj (bottom scrollovacej plochy mínus top lišty).
   Keď je lišta bežný flex súrodenec a neprekrýva nič, prekryv = 0 a padding
   ostáva malý — žiadna zbytočná diera pod obsahom. Keby aplikácia lištu
   niekedy prepla na position:fixed/sticky, prekryv sa započíta sám.

   NEMENÍ SA: veľkosť kariet, fotiek, karuselu, správanie spodnej lišty,
   výška draweru, ani žiadna logika košíka, akcií, odporúčaní či checkoutu.
   Zasahuje sa výhradne do padding-bottom jedného prvku — .cdr-main-color.
   ───────────────────────────────────────────────────────────────────────── */
(function () {
  'use strict';
  if (window.__charmaCartScrollPad) return;
  window.__charmaCartScrollPad = true;

  var SCROLL_SEL   = '.cdr-main-color';
  var FOOTER_SEL   = '.bottom-section';
  var CAROUSEL_SEL = '.opus-carousel-container';
  var RESERVE      = 24;     // vizuálna rezerva pod poslednou kartou
  var TICK_MS      = 700;

  /* Drawer býva raz v bežnom DOM, raz v Shadow DOM */
  function roots() {
    var out  = [document];
    var host = document.getElementById('opus-shadow-container');
    if (host && host.shadowRoot) out.push(host.shadowRoot);
    return out;
  }

  /* env(safe-area-inset-bottom) sa z JS priamo prečítať nedá — zmeriame ho
     neviditeľným prvkom, ktorého výška je presne tá hodnota. */
  var probe = null;
  function safeAreaBottom() {
    if (!probe || !probe.isConnected) {
      probe = document.createElement('div');
      probe.id = 'charma-safe-area-probe';
      probe.setAttribute('aria-hidden', 'true');
      probe.style.cssText =
        'position:fixed;left:-9999px;bottom:0;width:0;' +
        'height:env(safe-area-inset-bottom,0px);' +
        'pointer-events:none;visibility:hidden';
      (document.body || document.documentElement).appendChild(probe);
    }
    return probe.offsetHeight || 0;
  }

  function applyIn(root) {
    var sc = root.querySelector(SCROLL_SEL);
    var ft = root.querySelector(FOOTER_SEL);
    if (!sc || !ft) return;

    var s = sc.getBoundingClientRect();
    var f = ft.getBoundingClientRect();
    if (!s.height || !f.height) return;          // košík je zavretý

    /* Koľko z scrollovacej plochy zakrýva spodná lišta.
       Pri bežnom flex layoute vyjde 0. */
    var overlap = Math.max(0, Math.round(s.bottom - f.top));

    /* Koľko obsahu preteká mimo box karuselu (šípky, bodky) */
    var car   = root.querySelector(CAROUSEL_SEL);
    var bleed = car ? Math.max(0, car.scrollHeight - car.clientHeight) : 0;

    var pad = overlap + safeAreaBottom() + bleed + RESERVE;

    /* Zapisujeme len pri skutočnej zmene — nech to nerobí layout thrashing */
    if (sc.getAttribute('data-charma-pad') === String(pad)) return;
    sc.setAttribute('data-charma-pad', String(pad));
    sc.style.setProperty('padding-bottom', pad + 'px', 'important');
  }

  function apply() {
    var rs = roots();
    for (var i = 0; i < rs.length; i++) applyIn(rs[i]);
  }

  apply();
  setInterval(apply, TICK_MS);
  window.addEventListener('resize', apply);
  window.addEventListener('orientationchange', function () {
    setTimeout(apply, 250);
  });

  /* Keď sa zmení výška spodnej lišty (napr. pribudne riadok o doprave),
     prepočítame okamžite, nie až pri ďalšom tiku. */
  if (window.ResizeObserver) {
    var ro = new ResizeObserver(apply);
    var watched = [];
    setInterval(function () {
      var rs = roots();
      for (var i = 0; i < rs.length; i++) {
        var els = [rs[i].querySelector(FOOTER_SEL), rs[i].querySelector(CAROUSEL_SEL)];
        for (var j = 0; j < els.length; j++) {
          if (els[j] && watched.indexOf(els[j]) === -1) {
            watched.push(els[j]);
            ro.observe(els[j]);
          }
        }
      }
      if (watched.length > 20) watched = watched.slice(-10);
    }, 1500);
  }
})();


/* ─────────────────────────────────────────────────────────────────────────
   Module 20 — Kompaktná sekcia odporúčaní v košíku

   PREDTÝM
   Nadpis "VYBRANÉ PRE VÁS" + vysoká karta s fotkou nad textom a veľkým
   štvorcovým tlačidlom s ikonou vozíka. Celá sekcia zaberala ~218 px.

   TERAZ
   Nadpis "Doplňte svoj výber" (text drží Module 18) + dynamický podnadpis
   viazaný na akciu 7+1 + jeden kompaktný riadok:

       [ fotka 86px ]  Názov produktu (max 2 riadky)
                       3,90 €            [ + Pridať ]

   Sekcia: 177 px (bolo 218). Karta: 110 px (bolo 158).

   ČO SA NEMENÍ
   Žiadna logika. Tlačidlo "+ Pridať" je TO ISTÉ tlačidlo aplikácie
   (.cd-buy-button) — len preštýlované. Ikona vozíka sa skryje cez CSS
   a text sa vykreslí cez ::after, takže sa DOM tlačidla vôbec nemení
   a jeho pôvodný click handler ostáva nedotknutý.
   Karusel, swipe, šípky, bodky aj AJAX fungujú ďalej tak ako predtým.

   PODNADPIS
   Neráta si nič vlastné — číta stav cez window.CharmaReward.read(), teda
   presne ten istý zdroj pravdy, z ktorého žije celá akcia 7+1 (sekcia 7b).
   Keď CharmaReward z akéhokoľvek dôvodu nie je k dispozícii, podnadpis
   spadne na neutrálne "Vybrané pre vás" — nikdy nezobrazí vlastný odhad.

   ROZSAH
   Výhradne .opus-carousel-container. Karty v košíku, fotky, lišty,
   checkout ani spodná sekcia sa nedotýkajú.
   ───────────────────────────────────────────────────────────────────────── */
(function () {
  'use strict';
  if (window.__charmaUpsellCompact) return;
  window.__charmaUpsellCompact = true;

  var CSS_ID    = 'charma-upsell-css';
  var SUB_ID    = 'charma-upsell-sub';
  var THRESHOLD = 7;
  var PAINT_MS  = 500;
  var POLL_MS   = 1500;

  var C = '.opus-carousel-container ';

  var CSS = [
    /* ── Nadpis ───────────────────────────────────────────────────────
       Prebíja Module 17 (ten dáva letter-spacing a väčší spodný margin).
       !important je nutné, nadpis dostáva od aplikácie inline style.     */
    C + '.cd-upsell-title{font-size:19px !important;font-weight:600 !important;' +
      'color:#171917 !important;letter-spacing:0 !important;text-transform:none !important;' +
      'text-align:left !important;line-height:1.25 !important;margin:2px 0 1px !important}',

    /* ── Dynamický podnadpis ──────────────────────────────────────────── */
    '#' + SUB_ID + '{font-size:12.5px;line-height:1.35;color:#666761;' +
      'margin:0 0 9px;text-align:left}',

    /* ── Karta odporúčania — jeden vodorovný riadok ───────────────────── */
    C + '.cd-carousel-product{display:flex !important;align-items:center;gap:12px;' +
      'border:1px solid #E5E1D9;border-radius:15px;padding:11px !important;' +
      'box-shadow:none;box-sizing:border-box}',

    /* Fotka — contain, nikdy sa neoreže */
    C + '.opus-img-upsell{width:86px !important;height:86px !important;flex:0 0 86px !important}',
    C + '.cd-carousel-img{width:86px !important;height:86px !important;' +
      'object-fit:contain !important;border-radius:10px !important}',

    /* Text: názov na celú šírku, pod ním cena a tlačidlo vedľa seba.
       Tlačidlo NEDÁVAME do prvého riadku vedľa názvu — pri 375 px by
       názvu ostalo ~130 px a dvojriadkový názov by sa nezmestil. */
    C + '.cd-carousel-details{flex:1 1 auto;min-width:0;display:flex;flex-wrap:wrap;' +
      'align-items:center;gap:6px 10px}',
    /* Aplikácia vkladá prázdne divy (.opus-prod-type, .opus-discount-wrapper).
       V bežnom DOM ich schová téma pravidlom div:empty, do shadow rootu sa
       to pravidlo nedostane — inak by robili medzery navyše. */
    C + '.cd-carousel-details > *:empty{display:none !important}',

    C + '.cd-product-title-href{flex:1 1 100%;min-width:0;text-decoration:none}',
    C + '.cd-product-title{font-size:15px !important;font-weight:600 !important;' +
      'line-height:1.3 !important;color:#171917 !important;margin:0 !important;' +
      'display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}',

    C + '.cd-item-price{flex:0 0 auto;margin:0 !important;padding:0 !important}',
    C + '.opus-upsell-price{font-size:16px !important;font-weight:600 !important;' +
      'color:#171917 !important}',

    /* ── Tlačidlo "+ Pridať" ──────────────────────────────────────────
       To isté tlačidlo aplikácie, len preštýlované. Module 17 mu dáva
       min-height:56px a radius 12px cez .cd-main-button — preto !important.
       Text ide cez ::after, ikona sa skryje. DOM sa nemení, handler žije.  */
    C + '.cd-carousel-options{flex:0 0 auto;margin-left:auto;display:flex;align-items:center}',
    C + '.cd-carousel-options .cd-buy-button{background:#00584D !important;color:#fff !important;' +
      'border:0 !important;border-radius:10px !important;min-height:0 !important;' +
      'height:38px !important;min-width:0 !important;width:auto !important;' +
      'padding:0 14px !important;font-size:14px !important;font-weight:600 !important;' +
      'letter-spacing:0 !important;text-transform:none !important;line-height:1;' +
      'display:inline-flex !important;align-items:center;justify-content:center;' +
      'white-space:nowrap;box-shadow:none !important}',
    C + '.cd-buy-button svg{display:none !important}',
    C + '.cd-buy-button::after{content:"' + window.CT('+ Pridať') + '"}',
    C + '.cd-buy-button[aria-busy="true"]::after{content:"' + window.CT('Pridávam…') + '"}',

    /* ── Karusel — šípky jemnejšie, menej vzduchu okolo bodiek ────────── */
    C + '.ego-slider{margin:0 !important}',
    C + '.ego-slider-arrow{opacity:.3;transition:opacity .2s}',
    C + '.ego-slider-arrow:hover{opacity:.65}',
    C + '.ego-slider-dots{margin:7px 0 0 !important;padding:0 !important}'
  ].join('\n');

  /* Drawer býva raz v bežnom DOM, raz v Shadow DOM */
  function roots() {
    var out  = [document];
    var host = document.getElementById('opus-shadow-container');
    if (host && host.shadowRoot) out.push(host.shadowRoot);
    return out;
  }

  function injectCss(root) {
    var target = (root === document) ? document.head : root;
    if (!target || target.querySelector('#' + CSS_ID)) return;
    var s = document.createElement('style');
    s.id = CSS_ID;
    s.textContent = CSS;
    target.appendChild(s);
  }

  function plural(n) {
    if (n === 1) return window.CT('prívesok');
    if (n < 5)   return window.CT('prívesky');
    return window.CT('príveskov');
  }

  var _text = window.CT('Vybrané pre vás');
  var _busy = false, _at = 0;

  /* Stav akcie sa NEPOČÍTA znova — berie sa z CharmaReward.read(),
     jediného zdroja pravdy pre 7+1. */
  function refreshSubtitle(force) {
    if (_busy) return;
    if (!force && Date.now() - _at < POLL_MS) return;
    _busy = true;
    fetch('/cart.js', { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        _busy = false; _at = Date.now();
        var txt = window.CT('Vybrané pre vás');
        if (window.CharmaReward && window.CharmaReward.read) {
          var st   = window.CharmaReward.read(cart);
          var into = st.charmQty % THRESHOLD;
          if (st.charmQty > 0 && into > 0) {
            var left = THRESHOLD - into;
            txt = window.CT('Ešte ') + left + ' ' + plural(left) + ' ' + window.CT('do náramku zdarma');
          }
        }
        if (txt !== _text) { _text = txt; }
        paint();
      })
      .catch(function () { _busy = false; });
  }

  function paint() {
    var rs = roots();
    for (var i = 0; i < rs.length; i++) {
      var root = rs[i];
      var car  = root.querySelector('.opus-carousel-container');
      if (!car) continue;
      injectCss(root);

      var title = car.querySelector('.cd-upsell-title');
      if (!title || !title.parentNode) continue;

      var sub = car.querySelector('#' + SUB_ID);
      if (!sub) {
        sub = document.createElement('div');
        sub.id = SUB_ID;
        title.parentNode.insertBefore(sub, title.nextSibling);
      } else if (title.nextElementSibling !== sub) {
        /* Aplikácia prekreslila karusel — vrátime podnadpis pod nadpis */
        title.parentNode.insertBefore(sub, title.nextSibling);
      }
      if (sub.textContent !== _text) sub.textContent = _text;
    }
  }

  refreshSubtitle(true);
  paint();
  setInterval(paint, PAINT_MS);
  setInterval(function () { refreshSubtitle(false); }, POLL_MS);

  ['cart:updated', 'cart:refresh', 'on:cart:update', 'cart-drawer:refresh'].forEach(function (ev) {
    document.addEventListener(ev, function () {
      setTimeout(function () { refreshSubtitle(true); }, 300);
    });
  });
  if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
    window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function () {
      setTimeout(function () { refreshSubtitle(true); }, 300);
    });
  }
  /* +/- , odstránenie, "+ Pridať" — po kliku prepočítame */
  document.addEventListener('click', function () {
    setTimeout(function () { refreshSubtitle(true); }, 600);
  }, true);
  /* Otvorenie košíka */
  new MutationObserver(function () {
    if (document.body.classList.contains('opus-modal-open')) refreshSubtitle(true);
  }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
})();


/* ─────────────────────────────────────────────────────────────────────────
   Module 21 — Jedna ikona košíka naraz

   PROBLÉM
   Na kolekciách a produktoch boli na mobile vidieť DVE ikony košíka
   súčasne: tá v hlavičke a plávajúca vpravo dole. Plávajúca navyše
   prekrývala tlačidlá "Pridať do košíka".

   PREČO SA TO NEDALO VYRIEŠIŤ SAMOTNÝM IntersectionObserverom
   Module 5 dáva hlavičke position:fixed natrvalo. Odmerané na živom
   webe: ikona košíka v hlavičke sedí na top:70px pri KAŽDEJ pozícii
   scrollu a z viewportu nezmizne nikdy. Observer by teda navždy hlásil
   "vidno" a plávajúca ikona by sa nezobrazila ani raz.

   RIEŠENIE
   1. Hlavička sa pri scrollovaní nadol odsunie nahor (len transform,
      žiadna zmena layoutu — preto sa nič neposunie a padding tela
      z Module 5 ostáva správny). Pri scrollovaní nahor sa vráti.
      Pri vrchu stránky je vždy vidieť.
   2. IntersectionObserver sleduje SKUTOČNÚ ikonu #cart-icon-bubble.
      Keď je mimo viewportu, plávajúca ikona sa zobrazí, inak je skrytá.

   Takto majú obe ikony zmysel a nikdy nie sú vidieť naraz. Ako bonus
   sa na mobile uvoľní 97 px výšky pre obsah.

   Lišta s akciami (#charma-annbar) ostáva hore stále — mení sa jej len
   z-index, aby hlavička pri odchode zmizla ZA ňou, nie cez ňu.

   NEMENÍ SA: dizajn hlavičky ani ikon, ich veľkosť, počítadlo (obe ikony
   ďalej čítajú ten istý stav košíka), drawer, karty produktov, tlačidlá,
   akcie, checkout. Ani pozícia plávajúcej ikony — tá ostáva tam, kde bola.
   ───────────────────────────────────────────────────────────────────────── */
(function () {
  'use strict';
  if (window.__charmaOneCartIcon) return;
  window.__charmaOneCartIcon = true;

  var HDR_SEL   = 'sticky-header';
  var CART_SEL  = '#cart-icon-bubble';
  var FLOAT_SEL = '#charma-float-cart';
  var OFF_CLS   = 'charma-hdr-off';
  var ON_CLS    = 'charma-float-on';
  var DELTA     = 6;     // px — mŕtva zóna, nech sa hlavička netrasie

  var css = [
    /* Hlavička — len transform, žiadna zmena výšky ani layoutu */
    HDR_SEL + '{transition:transform .28s cubic-bezier(.4,0,.2,1);will-change:transform}',
    HDR_SEL + '.' + OFF_CLS + '{transform:translateY(calc(-1 * var(--charma-hdr-shift,160px)))}',

    /* Lišta akcií nad hlavičkou, nech pod ňu hlavička zapadne */
    '#charma-annbar{z-index:100001}',

    /* Sticky lišta 7+1 na kolekcii sa prilepí pod to, čo hore naozaj
       ostalo. Module 11 jej zapisuje pevné top do inline štýlu — keď
       hlavička odíde, lišta by inak visela v prázdne nad produktmi.
       !important prebije inline hodnotu, premennú drží tento modul. */
    '#charma-nom-bar{top:var(--charma-sticky-top,161px) !important;' +
      'transition:top .28s cubic-bezier(.4,0,.2,1)}',

    /* Plávajúca ikona — skrytá je default.
       Inline štýly na tlačidle nastavujú position/bottom/right/display…,
       tieto vlastnosti sa ich nedotýkajú, takže sa nič neprebíja.
       visibility sa prepína skokovo (0s), aby prvok po skrytí naozaj
       zmizol až po dobehnutí fade-u. */
    FLOAT_SEL + '{opacity:0;transform:translateY(8px);pointer-events:none;' +
      'visibility:hidden;transition:opacity .2s ease,transform .2s ease,' +
      'visibility 0s linear .2s}',
    FLOAT_SEL + '.' + ON_CLS + '{opacity:1;transform:translateY(0);pointer-events:auto;' +
      'visibility:visible;transition:opacity .2s ease,transform .2s ease,visibility 0s}'
  ].join('\n');

  var style = document.createElement('style');
  style.id = 'charma-one-cart-icon';
  style.textContent = css;
  document.head.appendChild(style);

  /* ── Hlavička: skryť pri scrollovaní nadol ──────────────────────────── */
  function header() { return document.querySelector(HDR_SEL); }

  function shiftPx(sh) {
    /* Výška hlavičky + jej odsadenie zhora (lišta akcií) = o koľko
       ju treba posunúť, aby zmizla celá. Module 5 to odsadenie zapisuje
       do sh.style.top. */
    return Math.ceil(sh.getBoundingClientRect().height + (parseFloat(sh.style.top) || 0));
  }

  /* CSS premenná ide na documentElement, NIE na body — Module 5 má na
     body MutationObserver s attributeFilter ['style'] a zbytočne by sa
     spúšťal pri každom prepočte. */
  function syncShift() {
    var sh = header();
    if (!sh) return;
    var v = shiftPx(sh) + 'px';
    if (document.documentElement.style.getPropertyValue('--charma-hdr-shift') !== v) {
      document.documentElement.style.setProperty('--charma-hdr-shift', v);
    }
  }

  /* Kam sa má prilepiť sticky lišta 7+1 na kolekcii.
     Počíta sa z rozloženia, NIE z rectu hlavičky — ten sa počas
     animácie mení a lišta by poskakovala.
       sh.style.top ... čo ostáva hore stále (lišta akcií + QAB banner)
       offsetHeight ... výška hlavičky, transformom sa nemení            */
  function stickyTop(sh) {
    var t = parseFloat(sh.style.top) || 0;
    return (sh.classList.contains(OFF_CLS) ? t : t + sh.offsetHeight) + 8;
  }

  function syncStickyTop() {
    var sh = header();
    if (!sh) return;
    var v = Math.round(stickyTop(sh)) + 'px';
    if (document.documentElement.style.getPropertyValue('--charma-sticky-top') !== v) {
      document.documentElement.style.setProperty('--charma-sticky-top', v);
    }
  }

  var lastY = Math.max(0, window.scrollY), ticking = false;

  function showHeader() {
    var sh = header();
    if (sh) sh.classList.remove(OFF_CLS);
    syncStickyTop();
  }
  function hideHeader() {
    var sh = header();
    if (sh) sh.classList.add(OFF_CLS);
    syncStickyTop();
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      var sh = header();
      if (!sh) return;

      /* Otvorený košík / modál — hlavičku nechávame na pokoji */
      if (document.body.classList.contains('opus-modal-open') ||
          document.getElementById('cg-overlay') ||
          document.querySelector('.cnb-sheet.is-open')) {
        showHeader();
        return;
      }

      var y   = Math.max(0, window.scrollY);
      var top = shiftPx(sh);

      if (y <= top + 20)        showHeader();   // pri vrchu vždy vidieť
      else if (y > lastY + DELTA) hideHeader(); // scroll nadol
      else if (y < lastY - DELTA) showHeader(); // scroll nahor
      lastY = y;
    });
  }

  syncShift();
  syncStickyTop();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () { syncShift(); showHeader(); });
  window.addEventListener('orientationchange', function () {
    setTimeout(function () { syncShift(); showHeader(); }, 250);
  });
  /* Výška hlavičky sa môže zmeniť (lišta akcií sa schová, QAB banner…) */
  setInterval(function () { syncShift(); syncStickyTop(); }, 1000);

  /* ── Plávajúca ikona: presne vtedy, keď tá v hlavičke nie je vidieť ── */
  var io = null, watched = null;

  function attach() {
    var fl = document.querySelector(FLOAT_SEL);
    var hc = document.querySelector(CART_SEL);
    if (!fl || !hc) return;                    // na tejto stránke nie sú

    if (watched === hc && io) return;          // už sledujeme ten správny

    if (io) io.disconnect();
    io = new IntersectionObserver(function (entries) {
      var f = document.querySelector(FLOAT_SEL);
      if (!f) return;
      /* ikona v hlavičke mimo viewportu -> plávajúca sa ukáže */
      f.classList.toggle(ON_CLS, !entries[0].isIntersecting);
    }, { threshold: 0 });
    io.observe(hc);
    watched = hc;
  }

  attach();
  /* Po AJAX prekresleniach sa môže ktorýkoľvek prvok vymeniť —
     observer sa vtedy prilepí na nový. Žiadne duplikáty nevznikajú,
     tlačidlo si vytvára pôvodný modul, tento ho len prepína. */
  setInterval(attach, 1200);
})();


/* ─────────────────────────────────────────────────────────────────────────
   Module 18 — Hodinky za 29,90 € ako doplnok k akcii 7+1 (v košíku)

   Kedy sa blok ukáže (len v existujúcom Opus košíku, bez popupu a bez
   automatického otvárania košíka):
     • v košíku je aspoň 7 príveskov Charma Italia (CharmaReward.read),
     • náramok zadarmo je už v košíku (vybraný zákazníkom alebo darček),
     • v košíku ešte nie sú žiadne hodinky.

   Zoznam hodiniek = kolekcia /collections/hodinky (vypredané sa skryjú).
   Cenu 29,90 € robia skryté kódy CHARMA-HODINKY-3490/3990 (−5/−10 €
   jednorazovo na hodinky danej cenovej hladiny). Hodinky, ktoré bežne stoja
   29,90 €, v ponuke nie sú — nemali by žiadnu výhodu. Automatická zľava sa použiť
   nedá — Shopify nedovolí, aby tých istých 7 príveskov odomklo náramok aj
   hodinky. Kód sa pridá len k hodinkám pridaným z tejto ponuky (riadok má
   vlastnosť _charma_offer) a odoberie sa hneď, keď podmienka 7+1 prestane
   platiť alebo hodinky z košíka zmiznú. Iné kódy zákazníka ostávajú.
   ───────────────────────────────────────────────────────────────────────── */
(function () {
  // Ponuka hodiniek je nastavená len pre € (kódy −5/−10 €). V Kč by cena
  // nevyšla na peknú sumu, preto sa na českej verzii zatiaľ nezobrazuje.
  if (window.CHARMA_L10N && window.CHARMA_L10N.isCzk) return;
  var COLL      = 'hodinky';
  var OFFER     = 2990;                                   // v centoch
  var CODE_BY   = { 3490: 'CHARMA-HODINKY-3490', 3990: 'CHARMA-HODINKY-3990' };
  // + vypnutý starý kód, aby sa z košíka odstránil, ak tam ešte ostal
  var ALL_CODES = Object.keys(CODE_BY).map(function (k) { return CODE_BY[k]; }).concat(['CHARMA-HODINKY-2990']);
  var BOX_ID    = 'charma-watch-upsell';
  var CSS_ID    = 'charma-watch-upsell-css';
  var CACHE_KEY = 'cwu-list-v2';
  var TICK_MS   = 1200;

  var TXT_H     = 'Špeciálna ponuka k vašej objednávke ✨';
  var TXT_S     = 'Vyberte si hodinky CHARMA za <b>29,90 €</b>';
  var TXT_NOTE  = 'Ponuka dostupná iba k tejto objednávke.';
  var TXT_BTN   = 'Pridať';
  var TXT_BUSY  = 'Pridávam…';
  var TXT_ERR   = 'Skúste znova';

  var CSS = [
    '#' + BOX_ID + '{margin:10px 12px 6px;padding:12px 0 12px 12px;background:#FBF8F2;',
    'border:1px solid #ECE4D5;border-radius:12px;box-sizing:border-box;max-width:100%;overflow:hidden;font-family:inherit;text-align:left}',
    '#' + BOX_ID + ' .cwu-h{font-size:13px;font-weight:600;color:#1E2A23;margin:0 12px 2px 0;line-height:1.3;letter-spacing:.005em}',
    '#' + BOX_ID + ' .cwu-s{font-size:12.5px;color:#4E4A43;margin:0 12px 1px 0;line-height:1.35}',
    '#' + BOX_ID + ' .cwu-s b{color:#044A40;font-weight:700}',
    '#' + BOX_ID + ' .cwu-n{font-size:10.5px;color:#9A9388;margin:0 12px 9px 0;line-height:1.3}',
    '#' + BOX_ID + ' .cwu-rail{display:flex;gap:8px;overflow-x:auto;overflow-y:hidden;scroll-snap-type:x mandatory;',
    '-webkit-overflow-scrolling:touch;overscroll-behavior-x:contain;scrollbar-width:none;padding:0 12px 2px 0;scroll-padding-left:0}',
    '#' + BOX_ID + ' .cwu-rail::-webkit-scrollbar{display:none}',
    '#' + BOX_ID + ' .cwu-card{flex:0 0 calc((100% - 16px) / 2.35);max-width:150px;scroll-snap-align:start;background:#fff;',
    'border:1px solid #EFE8DC;border-radius:10px;padding:6px 6px 8px;box-sizing:border-box;display:flex;flex-direction:column;min-width:0}',
    '#' + BOX_ID + ' .cwu-img{display:block;width:100%;aspect-ratio:1/1;height:auto;object-fit:cover;border-radius:7px;background:#F5F1EA}',
    '#' + BOX_ID + ' .cwu-t{font-size:11px;line-height:1.3;color:#2A2A2A;margin:6px 0 3px;min-height:2.6em;',
    'display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;text-decoration:none}',
    '#' + BOX_ID + ' .cwu-p{display:flex;align-items:baseline;gap:5px;margin:0 0 7px;flex-wrap:wrap}',
    '#' + BOX_ID + ' .cwu-old{font-size:10.5px;color:#A8A196;text-decoration:line-through}',
    '#' + BOX_ID + ' .cwu-new{font-size:12.5px;font-weight:700;color:#044A40}',
    '#' + BOX_ID + ' .cwu-btn{margin-top:auto;height:30px;width:100%;border:1px solid #044A40;border-radius:999px;background:#fff;',
    'color:#044A40;font-size:12px;font-weight:600;letter-spacing:.02em;cursor:pointer;font-family:inherit;padding:0 8px;',
    '-webkit-tap-highlight-color:transparent;transition:background .15s,color .15s}',
    '#' + BOX_ID + ' .cwu-btn:hover{background:#044A40;color:#fff}',
    '#' + BOX_ID + ' .cwu-btn:disabled{opacity:.6;cursor:default;background:#fff;color:#044A40}'
  ].join('');

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(c) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; }
  function cents(v) { return Math.round(parseFloat(v || 0) * 100); }
  function img(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }

  function roots() {
    var out  = [document];
    var host = document.getElementById('opus-shadow-container');
    if (host && host.shadowRoot) out.push(host.shadowRoot);
    return out;
  }
  function q(sel) {
    var rs = roots();
    for (var i = 0; i < rs.length; i++) { var el = rs[i].querySelector(sel); if (el) return el; }
    return null;
  }

  /* ── Zoznam hodiniek z kolekcie (cache 10 min v rámci relácie) ─────────── */
  var list = null, listLoading = false;
  function loadList() {
    if (list || listLoading) return;
    try {
      var c = JSON.parse(sessionStorage.getItem(CACHE_KEY) || 'null');
      if (c && Date.now() - c.t < 600000) { list = c.l; return; }
    } catch (e) {}
    listLoading = true;
    fetch('/collections/' + COLL + '/products.json?limit=50', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var l = [];
        (d.products || []).forEach(function (p) {
          var v = (p.variants || []).filter(function (x) { return x.available; })[0];
          if (!v) return;                                   // vypredané sa nezobrazia
          var price = cents(v.price);
          if (!CODE_BY[price]) return;                      // len hodinky drahšie ako 29,90 € (majú kód)
          l.push({
            vid: v.id, price: price, title: p.title,
            url: '/products/' + p.handle,
            img: (p.images && p.images[0] && p.images[0].src) || ''
          });
        });
        list = l; listLoading = false;
        try { sessionStorage.setItem(CACHE_KEY, JSON.stringify({ t: Date.now(), l: l })); } catch (e) {}
      })
      .catch(function () { listLoading = false; });
  }

  /* ── Košík (krátka cache) ─────────────────────────────────────────────── */
  var cart = null, cartAt = 0, cartBusy = false;
  function getCart(cb, force) {
    if (!force && cart && Date.now() - cartAt < 1000) { cb(cart); return; }
    if (cartBusy) return;
    cartBusy = true;
    fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (c) { cart = c; cartAt = Date.now(); cartBusy = false; cb(c); })
      .catch(function () { cartBusy = false; });
  }

  function isWatch(i) { return /^CHC/i.test(i.sku || ''); }
  function offerLine(c) {
    return (c.items || []).filter(function (i) {
      return i.properties && i.properties._charma_offer === 'hodinky_2490';
    })[0] || null;
  }
  function state(c) {
    var st = (window.CharmaReward && window.CharmaReward.read) ? window.CharmaReward.read(c) : null;
    var qualifies = !!st && st.allowed >= 1;
    var braceletFree = qualifies && (st.current + st.paidBracelets) >= 1;
    var hasWatch = (c.items || []).some(isWatch);
    return { qualifies: qualifies, braceletFree: braceletFree, hasWatch: hasWatch };
  }

  /* ── Kód zľavy drží krok s košíkom ────────────────────────────────────── */
  var codeBusy = false;
  function syncCode(c) {
    if (codeBusy) return;
    var line    = offerLine(c);
    var st      = state(c);
    var want    = (line && st.qualifies) ? CODE_BY[line.original_price] || null : null;
    var applied = (c.discount_codes || []).map(function (d) { return d.code; });
    var ours    = applied.filter(function (k) { return ALL_CODES.indexOf(k.toUpperCase()) !== -1; });
    var others  = applied.filter(function (k) { return ALL_CODES.indexOf(k.toUpperCase()) === -1; });
    var ok = want ? (ours.length === 1 && ours[0].toUpperCase() === want) : ours.length === 0;
    if (ok) return;
    codeBusy = true;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ discount: others.concat(want ? [want] : []).join(',') })
    })
      .then(function (r) { return r.json(); })
      .then(function (nc) {
        codeBusy = false; cart = nc; cartAt = Date.now();
        if (typeof window.opusRefreshCart === 'function') { try { window.opusRefreshCart(); } catch (e) {} }
      })
      .catch(function () { codeBusy = false; });
  }

  /* ── Vykreslenie bloku ────────────────────────────────────────────────── */
  function build(items) {
    var box = document.createElement('div');
    box.id = BOX_ID;
    box.setAttribute('role', 'region');
    box.setAttribute('aria-label', 'Špeciálna ponuka hodiniek');
    box.innerHTML =
      '<p class="cwu-h">' + TXT_H + '</p>' +
      '<p class="cwu-s">' + TXT_S + '</p>' +
      '<p class="cwu-n">' + TXT_NOTE + '</p>' +
      '<div class="cwu-rail">' + items.map(function (w) {
        return '<div class="cwu-card">' +
          '<a href="' + esc(w.url) + '" tabindex="-1"><img class="cwu-img" src="' + esc(img(w.img, 300)) + '" alt="' + esc(w.title) + '" loading="lazy"></a>' +
          '<a class="cwu-t" href="' + esc(w.url) + '">' + esc(w.title) + '</a>' +
          '<div class="cwu-p"><span class="cwu-new">' + money(OFFER) + '</span>' +
            (w.price > OFFER ? '<span class="cwu-old">' + money(w.price) + '</span>' : '') + '</div>' +
          '<button type="button" class="cwu-btn" data-vid="' + w.vid + '">' + TXT_BTN + '</button>' +
        '</div>';
      }).join('') + '</div>';
    box.addEventListener('click', onClick);
    return box;
  }

  var adding = false;
  function onClick(e) {
    var b = e.target.closest ? e.target.closest('.cwu-btn') : null;
    if (!b || adding) return;
    e.preventDefault(); e.stopPropagation();
    adding = true;
    b.disabled = true; b.textContent = TXT_BUSY;
    var vid = parseInt(b.getAttribute('data-vid'), 10);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: vid, quantity: 1, properties: { _charma_offer: 'hodinky_2490' } })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) throw res.d;
        getCart(function (c) {
          adding = false;
          var box = q('#' + BOX_ID);
          if (box) box.style.display = 'none';            // hodinky sú v košíku → ponuka zmizne
          syncCode(c);                                     // 29,90 € + obnovenie košíka
          if (typeof window.opusRefreshCart === 'function') { try { window.opusRefreshCart(); } catch (e2) {} }
        }, true);
      })
      .catch(function (err) {
        adding = false;
        b.disabled = false;
        b.textContent = (err && err.description) ? TXT_ERR : TXT_ERR;
        setTimeout(function () { b.textContent = TXT_BTN; }, 2200);
      });
  }

  var shownSig = '';
  function paint() {
    var drawerOpen = document.body.classList.contains('opus-modal-open');
    getCart(function (c) {
      syncCode(c);                                         // beží aj pri zatvorenom košíku
      if (!drawerOpen) return;
      var anchor = q('.cd-product-list');
      var box    = q('#' + BOX_ID);
      var st     = state(c);
      var show   = st.braceletFree && !st.hasWatch && !adding && list && list.length;
      if (!show || !anchor) { if (box) box.style.display = 'none'; return; }

      var root = anchor.getRootNode ? anchor.getRootNode() : document;
      var cssTarget = (root === document || !root.querySelector) ? document.head : root;
      if (!cssTarget.querySelector('#' + CSS_ID)) {
        var s = document.createElement('style'); s.id = CSS_ID; s.textContent = CSS; cssTarget.appendChild(s);
      }

      var sig = list.map(function (w) { return w.vid; }).join(',');
      if (!box || sig !== shownSig) {
        if (box) box.remove();
        box = build(list); shownSig = sig;
      }
      if (box.previousElementSibling !== anchor || !box.isConnected) {
        anchor.parentNode.insertBefore(box, anchor.nextSibling);   // hneď pod zoznamom produktov
      }
      box.style.display = '';
    });
  }

  loadList();
  paint();                                                 // kontrola kódu pri načítaní stránky
  /* Pri otvorenom košíku sa stav obnovuje pravidelne. Pri zatvorenom sa
     /cart.js volá len keď sa zmení počítadlo v hlavičke — žiadne zbytočné
     požiadavky na každej stránke. */
  var prevBadge = null;
  setInterval(function () {
    if (document.body.classList.contains('opus-modal-open')) { paint(); return; }
    var sp = document.querySelector('#cart-icon-bubble .cart-count-bubble span[aria-hidden]');
    var n  = sp ? sp.textContent : '0';
    if (prevBadge !== null && n !== prevBadge) { cart = null; paint(); }
    prevBadge = n;
  }, TICK_MS);
  new MutationObserver(function () {
    if (document.body.classList.contains('opus-modal-open')) { cart = null; paint(); }
  }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  document.addEventListener('visibilitychange', function () { if (!document.hidden) { cart = null; paint(); } });
})();


/* ─────────────────────────────────────────────────────────────────────────
   Module 19 — 3+1 pripomienka v košíku ("berú po jednom prívesku")

   Keď sú v košíku 1–3 položky, ktoré sa rátajú do akcie 3+1 (nie Charma
   Italia, nie darček 7+1) a aspoň jedna z nich je Pandora prívesok (tag
   "Charms"), ukáže sa pod zoznamom produktov kompaktný blok:
     1–2 ks → "Pridajte ešte X prívesky a 4. máte od nás zadarmo"
     3 ks   → "Vyberte si 4. prívesok — máte ho ZADARMO"
   s karuselom podobných príveskov (Shopify odporúčania k poslednému
   príveskom v košíku, záložne kolekcia /koralky). Pri 4+ ks blok zmizne.
   Nič sa nepridáva samo, košík sa neotvára, zľavu počíta Shopify.
   ───────────────────────────────────────────────────────────────────────── */
(function () {
  var BOX_ID = 'charma-31-nudge';
  var CSS_ID = 'charma-31-nudge-css';
  var NEED = 3;
  var TICK_MS = 1200;

  var GIFT = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" style="display:inline-block;vertical-align:-2px;margin-right:4px"><polyline points="20 12 20 22 4 22 4 12"/><rect x="2" y="7" width="20" height="5"/><line x1="12" y1="22" x2="12" y2="7"/><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/></svg>';

  var CSS = [
    '#' + BOX_ID + '{margin:10px 12px 6px;padding:11px 0 11px 12px;background:#FBF8F2;border:1px solid #ECE4D5;',
    'border-radius:12px;box-sizing:border-box;max-width:100%;overflow:hidden;font-family:inherit;text-align:left}',
    '#' + BOX_ID + ' .c31-h{font-size:12.5px;font-weight:700;color:#8A6A28;letter-spacing:.04em;margin:0 12px 2px 0;line-height:1.3}',
    '#' + BOX_ID + ' .c31-s{font-size:12.5px;color:#3E3A33;margin:0 12px 9px 0;line-height:1.35}',
    '#' + BOX_ID + ' .c31-s b{color:#044A40}',
    '#' + BOX_ID + ' .c31-rail{display:flex;gap:8px;overflow-x:auto;overflow-y:hidden;scroll-snap-type:x mandatory;',
    '-webkit-overflow-scrolling:touch;overscroll-behavior-x:contain;scrollbar-width:none;padding:0 12px 2px 0}',
    '#' + BOX_ID + ' .c31-rail::-webkit-scrollbar{display:none}',
    '#' + BOX_ID + ' .c31-card{flex:0 0 calc((100% - 24px) / 3.3);max-width:120px;scroll-snap-align:start;background:#fff;',
    'border:1px solid #EFE8DC;border-radius:10px;padding:5px 5px 7px;box-sizing:border-box;display:flex;flex-direction:column;min-width:0}',
    '#' + BOX_ID + ' .c31-img{display:block;width:100%;aspect-ratio:1/1;height:auto;object-fit:cover;border-radius:7px;background:#F5F1EA}',
    '#' + BOX_ID + ' .c31-t{font-size:10.5px;line-height:1.25;color:#2A2A2A;margin:5px 0 2px;min-height:2.5em;',
    'display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;text-decoration:none}',
    '#' + BOX_ID + ' .c31-p{font-size:11.5px;font-weight:700;color:#1E2A23;margin:0 0 6px}',
    '#' + BOX_ID + ' .c31-btn{margin-top:auto;height:28px;width:100%;border:1px solid #044A40;border-radius:999px;background:#fff;',
    'color:#044A40;font-size:11.5px;font-weight:600;cursor:pointer;font-family:inherit;padding:0 6px;',
    '-webkit-tap-highlight-color:transparent;transition:background .15s,color .15s}',
    '#' + BOX_ID + ' .c31-btn:hover{background:#044A40;color:#fff}',
    '#' + BOX_ID + ' .c31-btn:disabled{opacity:.6;cursor:default;background:#fff;color:#044A40}'
  ].join('');

  function T(s) { return window.CT ? window.CT(s) : s; }
  function money(c) { return window.charmaMoney ? window.charmaMoney(c) : (c / 100).toFixed(2).replace('.', ',') + ' €'; }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function imgUrl(u, w) {
    if (!u) return '';
    if (u.indexOf('//') === 0) u = 'https:' + u;
    return u + (u.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }
  function lowerTags(t) {
    if (typeof t === 'string') t = t.split(',');
    return (t || []).map(function (x) { return String(x).trim().toLowerCase(); });
  }
  function isItaliaTags(t) { return t.indexOf('nomination') !== -1 || t.indexOf('italia') !== -1; }
  function priceCents(p) {
    var v = p.price;
    if (typeof v === 'number') return v;                                    // /recommendations, /products.js
    var vv = p.variants && p.variants[0] && p.variants[0].price;           // /products.json → "18.90"
    return Math.round(parseFloat(vv || v || 0) * 100);
  }

  function roots() {
    var out = [document];
    var h = document.getElementById('opus-shadow-container');
    if (h && h.shadowRoot) out.push(h.shadowRoot);
    return out;
  }
  function q(sel) {
    var rs = roots();
    for (var i = 0; i < rs.length; i++) { var el = rs[i].querySelector(sel); if (el) return el; }
    return null;
  }

  /* Tagy produktu — rovnaká sessionStorage cache ako lišta 3+1 (cnb-tags-*) */
  var tagMem = {};
  function productTags(handle) {
    if (!handle) return Promise.resolve([]);
    if (tagMem[handle]) return tagMem[handle];
    var CK = 'cnb-tags-' + handle, c = null;
    try { c = sessionStorage.getItem(CK); } catch (e) {}
    if (c !== null) { try { tagMem[handle] = Promise.resolve(JSON.parse(c)); return tagMem[handle]; } catch (e) {} }
    tagMem[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var t = lowerTags(p.tags);
        try { sessionStorage.setItem(CK, JSON.stringify(t)); } catch (e) {}
        return t;
      })
      .catch(function () { return []; });
    return tagMem[handle];
  }

  /* Stav košíka pre 3+1 */
  function analyse(cart) {
    var items = (cart && cart.items) || [];
    var list = items.filter(function (i) {
      return !(window.CharmaReward && window.CharmaReward.isPromoLine && window.CharmaReward.isPromoLine(i));
    });
    return Promise.all(list.map(function (i) {
      return productTags(i.handle).then(function (t) { return { i: i, t: t }; });
    })).then(function (rows) {
      var n = 0, lastCharm = null, inCart = {};
      rows.forEach(function (r) {
        inCart[r.i.product_id] = true;
        if (isItaliaTags(r.t)) return;
        n += r.i.quantity;
        if (!lastCharm && r.t.indexOf('charms') !== -1) lastCharm = r.i;   // items[0] = naposledy pridaný
      });
      return { n: n, lastCharm: lastCharm, inCart: inCart };
    });
  }

  /* Návrhy príveskov */
  var recMem = {};
  function normalise(p) {
    var v = (p.variants || []).filter(function (x) { return x.available; })[0];
    if (!v || !p.available && p.available !== undefined) return null;
    var img = p.featured_image || (p.images && p.images[0] && (p.images[0].src || p.images[0])) || '';
    return { pid: p.id, vid: v.id, title: p.title, url: '/products/' + p.handle, img: img, price: priceCents(p), tags: lowerTags(p.tags) };
  }
  function suggestions(st) {
    var key = st.lastCharm ? st.lastCharm.product_id : 'fallback';
    if (!recMem[key]) {
      var recs = st.lastCharm
        ? fetch('/recommendations/products.json?product_id=' + st.lastCharm.product_id + '&limit=10&intent=related')
            .then(function (r) { return r.json(); }).then(function (d) { return d.products || []; }).catch(function () { return []; })
        : Promise.resolve([]);
      recMem[key] = recs.then(function (list) {
        var out = list.map(normalise).filter(function (x) {
          return x && x.tags.indexOf('charms') !== -1 && !isItaliaTags(x.tags) && x.price > 0;
        });
        if (out.length >= 4) return out;
        return fetch('/collections/koralky/products.json?limit=24')
          .then(function (r) { return r.json(); })
          .then(function (d) {
            var more = (d.products || []).map(normalise).filter(function (x) { return x && x.price > 0; });
            var seen = {}; out.forEach(function (x) { seen[x.pid] = 1; });
            return out.concat(more.filter(function (x) { return !seen[x.pid]; }));
          })
          .catch(function () { return out; });
      });
    }
    return recMem[key].then(function (all) {
      return all.filter(function (x) { return !st.inCart[x.pid]; }).slice(0, 8);
    });
  }

  function texts(n) {
    if (n >= NEED) {
      return { h: GIFT + '3+1 ZADARMO', s: 'Vyberte si <b>4. prívesok</b> — máte ho ZADARMO' };
    }
    var left = NEED - n;
    return {
      h: GIFT + '3+1 ZADARMO',
      s: 'Pridajte ešte <b>' + left + (left === 1 ? ' prívesok' : ' prívesky') + '</b> a 4. máte od nás zadarmo'
    };
  }

  function build(n, items) {
    var t = texts(n);
    var box = document.createElement('div');
    box.id = BOX_ID;
    box.setAttribute('role', 'region');
    box.setAttribute('aria-label', 'Akcia 3+1');
    box.innerHTML = T(
      '<p class="c31-h">' + t.h + '</p>' +
      '<p class="c31-s">' + t.s + '</p>' +
      '<div class="c31-rail">' + items.map(function (w) {
        return '<div class="c31-card">' +
          '<a href="' + esc(w.url) + '" tabindex="-1"><img class="c31-img" src="' + esc(imgUrl(w.img, 240)) + '" alt="' + esc(w.title) + '" loading="lazy"></a>' +
          '<a class="c31-t" href="' + esc(w.url) + '">' + esc(w.title) + '</a>' +
          '<div class="c31-p">' + money(w.price) + '</div>' +
          '<button type="button" class="c31-btn" data-vid="' + w.vid + '">Pridať</button>' +
        '</div>';
      }).join('') + '</div>');
    box.addEventListener('click', onClick);
    box._n = n;
    return box;
  }

  var adding = false;
  function onClick(e) {
    var b = e.target.closest ? e.target.closest('.c31-btn') : null;
    if (!b || adding) return;
    e.preventDefault(); e.stopPropagation();
    adding = true;
    b.disabled = true; b.textContent = T('Pridávam…');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(b.getAttribute('data-vid'), 10), quantity: 1 })
    })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function () {
        adding = false; lastSig = ''; cartAt = 0;
        if (typeof window.opusRefreshCart === 'function') { try { window.opusRefreshCart(); } catch (e2) {} }
        setTimeout(paint, 500);
      })
      .catch(function () {
        adding = false; b.disabled = false; b.textContent = T('Skúste znova');
        setTimeout(function () { b.textContent = T('Pridať'); }, 2200);
      });
  }

  var cart = null, cartAt = 0, busy = false, lastSig = '';
  function paint() {
    if (!document.body.classList.contains('opus-modal-open') || busy || adding) return;
    var list = q('.cd-product-list');
    var box = q('#' + BOX_ID);
    if (!list) { if (box) box.style.display = 'none'; return; }
    busy = true;
    var getC = (cart && Date.now() - cartAt < 1000) ? Promise.resolve(cart)
      : fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); })
          .then(function (c) { cart = c; cartAt = Date.now(); return c; });
    getC.then(analyse).then(function (st) {
      var show = st.n >= 1 && st.n <= NEED && !!st.lastCharm;
      if (!show) { busy = false; if (box) box.style.display = 'none'; return; }
      return suggestions(st).then(function (items) {
        busy = false;
        if (items.length < 2) { if (box) box.style.display = 'none'; return; }
        var root = list.getRootNode ? list.getRootNode() : document;
        var cssTarget = (root === document || !root.querySelector) ? document.head : root;
        if (!cssTarget.querySelector('#' + CSS_ID)) {
          var s = document.createElement('style'); s.id = CSS_ID; s.textContent = CSS; cssTarget.appendChild(s);
        }
        var sig = st.n + '|' + items.map(function (x) { return x.vid; }).join(',');
        if (!box || sig !== lastSig) {
          var scroll = box && box.querySelector('.c31-rail') ? box.querySelector('.c31-rail').scrollLeft : 0;
          if (box) box.remove();
          box = build(st.n, items); lastSig = sig;
          var rail = box.querySelector('.c31-rail'); if (rail && box._n === st.n) rail.scrollLeft = scroll;
        }
        // Pod zoznam produktov; ak je tam ponuka hodiniek, až pod ňu (nech sa nebijú o poradie)
        var watch = q('#charma-watch-upsell');
        var after = (watch && watch.style.display !== 'none' && watch.parentNode === list.parentNode) ? watch : list;
        if (box.previousElementSibling !== after || !box.isConnected) after.parentNode.insertBefore(box, after.nextSibling);
        box.style.display = '';
      });
    }).catch(function () { busy = false; });
  }

  // Zdieľané s Module 20 (toast po pridaní do košíka)
  window.charma31Analyse = analyse;
  window.charma31Tags = productTags;

  setInterval(function () {
    if (document.body.classList.contains('opus-modal-open')) paint();
  }, TICK_MS);
  new MutationObserver(function () {
    if (document.body.classList.contains('opus-modal-open')) { cartAt = 0; paint(); }
  }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
})();


/* ─────────────────────────────────────────────────────────────────────────
   Module 20 — Viac viditeľnosti pre akciu 3+1
     A) Karta produktu (Pandora prívesok): pod cenou
        "Akcia 3+1: kúpte 3 prívesky, 4. máte zadarmo"
     B) Toast po pridaní do košíka: namiesto "Pridané do košíka"
        "Pridané ✓ Ešte 2 prívesky a 4. máte zadarmo" (1–3 ks v akcii)
   Rozhodujú tagy produktu: "Charms" áno, Nomination/Italia nie.
   ───────────────────────────────────────────────────────────────────────── */
(function () {
  function T(s) { return window.CT ? window.CT(s) : s; }
  function money(c) { return window.charmaMoney ? window.charmaMoney(c) : (c / 100).toFixed(2).replace('.', ',') + ' €'; }
  function lower(t) {
    if (typeof t === 'string') t = t.split(',');
    return (t || []).map(function (x) { return String(x).trim().toLowerCase(); });
  }
  function eligible(tags) {
    return tags.indexOf('charms') !== -1 && tags.indexOf('nomination') === -1 && tags.indexOf('italia') === -1;
  }
  var GIFT = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="display:inline-block;vertical-align:-1px;margin-right:5px"><polyline points="20 12 20 22 4 22 4 12"/><rect x="2" y="7" width="20" height="5"/><line x1="12" y1="22" x2="12" y2="7"/><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/></svg>';

  var CSS = [
    '.c31-per{display:inline-flex;align-items:center;margin:6px 0 2px;padding:5px 10px;border-radius:999px;',
    'background:#FBF6EC;border:1px solid #EAD9B5;color:#7A5B1A;font-size:12.5px;font-weight:600;line-height:1.2}',
    '.c31-per b{color:#044A40;font-weight:700;margin-left:3px}'
  ].join('');
  function injectCss() {
    if (document.getElementById('c31-promo-css')) return;
    var s = document.createElement('style'); s.id = 'c31-promo-css'; s.textContent = CSS; document.head.appendChild(s);
  }

  /* ── A) Karta produktu ─────────────────────────────────────────────────── */
  function productLine() {
    var m = location.pathname.match(/\/products\/([^/?#]+)/);
    if (!m) return;
    fetch('/products/' + m[1] + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) {
        if (!eligible(lower(p.tags))) return;
        var v = (p.variants || []).filter(function (x) { return x.available; })[0] || (p.variants || [])[0];
        if (!v || !v.price) return;
        var tries = 0;
        (function place() {
          var price = document.querySelector('.product__info-container .price, product-info .price');
          if (!price) { if (++tries < 20) setTimeout(place, 300); return; }
          if (document.getElementById('c31-per')) return;
          injectCss();
          var el = document.createElement('div');
          el.id = 'c31-per';
          el.className = 'c31-per';
          el.innerHTML = T(GIFT + 'Akcia 3+1: <b>kúpte 3 prívesky, 4. máte zadarmo</b>');
          var host = price.parentElement && price.parentElement.classList.contains('no-js-hidden') ? price.parentElement : price;
          host.insertAdjacentElement('afterend', el);
        })();
      }).catch(function () {});
  }

  /* ── B) Toast po pridaní ───────────────────────────────────────────────── */
  function upgradeToast(toast) {
    if (toast._c31) return;
    var spans = toast.querySelectorAll('span');
    var msg = null;
    for (var i = 0; i < spans.length; i++) {
      var t = spans[i].textContent.trim();
      if (t === 'Pridané do košíka' || t === T('Pridané do košíka')) { msg = spans[i]; break; }
    }
    if (!msg || !window.charma31Analyse) return;
    toast._c31 = true;
    fetch('/cart.js', { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(window.charma31Analyse)
      .then(function (st) {
        if (!st || !st.lastCharm || st.n < 1 || st.n > 3 || !toast.isConnected) return;
        var left = 3 - st.n;
        var txt = left > 0
          ? 'Pridané · Ešte ' + left + (left === 1 ? ' prívesok' : ' prívesky') + ' a 4. máte zadarmo'
          : 'Pridané · Teraz si vyberte 4. prívesok ZADARMO';
        msg.innerHTML = T(txt);
        msg.style.cssText = 'white-space:normal;font-size:13px;line-height:1.25;min-width:0';
        toast.style.whiteSpace = 'normal';
        toast.style.width = 'max-content';
        toast.style.maxWidth = 'calc(100vw - 24px)';
      })
      .catch(function () {});
  }
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var add = muts[i].addedNodes;
      for (var j = 0; j < add.length; j++) {
        if (add[j].id === 'charma-toast') upgradeToast(add[j]);
      }
    }
  }).observe(document.body, { childList: true });

  function start() {
    productLine();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();


/* ─────────────────────────────────────────────────────────────────────────
   Module 21 — Český preklad textov z aplikácií a vlastných sekcií
   Translate & Adapt nepreloží texty, ktoré sú natvrdo v aplikáciách
   (EasyTabs na karte produktu), vo vlastnej skladačke Charma Italia a vo
   filtroch (typ produktu). Na českej verzii sa v týchto blokoch preložia
   textové uzly cez CT / CT_EXACT. Na slovenskej verzii modul nerobí nič.
   ───────────────────────────────────────────────────────────────────────── */
(function () {
  if (!(window.CHARMA_L10N && (window.CHARMA_L10N.isCs || window.CHARMA_L10N.isPl)) || !window.CT_EXACT) return;
  var SEL = '.easytabs-container, [id*="ci-charm-picker"], [id^="ci-steps"], ' +
            'facet-filters-form, .facets-container, .mobile-facets, .active-facets, .facets, #opus-shadow-container, #opus-drawer-id';
  if (window.CHARMA_L10N.isPl) SEL += ', #MainContent';
  var translatedShadows = new WeakSet();

  function fixNode(n) {
    if (n.parentElement && /^(SCRIPT|STYLE)$/.test(n.parentElement.tagName)) return;
    var v = n.nodeValue;
    if (!v || !v.trim()) return;
    var t = window.CT_EXACT(v);
    if (t !== v) n.nodeValue = t;
  }
  function fixTree(root) {
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var n; while ((n = w.nextNode())) fixNode(n);
    // placeholder / aria / value tlačidiel
    var els = root.querySelectorAll ? root.querySelectorAll('[aria-label],[placeholder],[href],[alt],[title]') : [];
    for (var i = 0; i < els.length; i++) {
      ['aria-label', 'placeholder', 'href', 'alt', 'title'].forEach(function (a) {
        var v = els[i].getAttribute(a); if (!v) return;
        var t = window.CT(v); if (t !== v) els[i].setAttribute(a, t);
      });
    }
  }
  function run() {
    var roots = document.querySelectorAll(SEL);
    for (var i = 0; i < roots.length; i++) fixTree(roots[i]);
    if (window.CHARMA_L10N.isPl) {
      var host = document.getElementById('opus-shadow-container');
      var sr = host && host.shadowRoot;
      if (sr) {
        fixTree(sr);
        if (!translatedShadows.has(sr)) { translatedShadows.add(sr); new MutationObserver(schedule).observe(sr, {childList:true,subtree:true,characterData:true}); }
      }
    }
  }

  var pending = false;
  function schedule() {
    if (pending) return; pending = true;
    // setTimeout, nie requestAnimationFrame — rAF v skrytej karte nebeží a preklad by sa zasekol
    setTimeout(function () { pending = false; run(); }, 60);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  window.addEventListener('load', function () { setTimeout(run, 300); setTimeout(run, 1500); });
  // aplikácie a skladačka dokresľujú obsah neskôr — sledujeme zmeny
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var t = muts[i].target;
      var el = t.nodeType === 1 ? t : t.parentElement;
      if (el && el.closest && el.closest(SEL)) { schedule(); return; }
      var add = muts[i].addedNodes;
      for (var j = 0; j < add.length; j++) {
        var a = add[j];
        if (a.nodeType === 1 && (a.matches && a.matches(SEL) || a.querySelector && a.querySelector(SEL))) { schedule(); return; }
      }
    }
  }).observe(document.body, { childList: true, subtree: true, characterData: true });
})();

;(() => {
  if (!location.pathname.includes('/collections/')) return;
  let active;
  const nextLink = root => root.querySelector('.pagination__item--prev[href]');
  const connection = navigator.connection;
  const conserve = connection && (connection.saveData || /(^|-)2g$/.test(connection.effectiveType));
  function start() {
    const grid = document.querySelector('ul#product-grid');
    if (!grid || (active && active.grid === grid)) return;
    if (active) { active.controller.abort(); clearTimeout(active.timer); }
    const container = grid.closest('#ProductGridContainer');
    if (!container) return;
    const state = { grid, controller: new AbortController(), loading: false, seen: new Set(), failures: 0 };
    active = state; grid.dataset.charmaBackground = 'ready';
    const valid = () => active === state && grid.isConnected && !state.controller.signal.aborted;
    const schedule = () => { if (valid()) state.timer = setTimeout(load, conserve ? 1500 : 700); };
    async function load() {
      if (!valid() || state.loading) return;
      if (document.hidden || container.querySelector('.loading')) { schedule(); return; }
      const next = nextLink(container);
      if (!next) return;
      const gridBottom = grid.getBoundingClientRect().bottom;
      if (gridBottom < 0 || gridBottom > innerHeight + 800) { schedule(); return; }
      const url = new URL(next.href, location.href);
      if (url.origin !== location.origin || state.seen.has(url.href)) return;
      const pageKey = url.href;
      url.searchParams.set('section_id', grid.dataset.id);
      state.loading = true; grid.dataset.charmaBackground = 'loading';
      let timeout;
      try {
        timeout = setTimeout(() => state.controller.abort(), 20000);
        const response = await fetch(url.href, { signal: state.controller.signal, priority: 'low' });
        if (!response.ok) throw new Error('Collection request failed');
        const html = await response.text();
        if (!valid()) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const incoming = doc.querySelector('ul#product-grid');
        if (!incoming || !incoming.children.length) throw new Error('Missing collection grid');
        const fragment = document.createDocumentFragment();
        for (const card of Array.from(incoming.children)) {
          card.querySelectorAll('img').forEach(img => { img.loading = 'lazy'; img.decoding = 'async'; img.removeAttribute('fetchpriority'); });
          card.classList.remove('scroll-trigger', 'animate--slide-in', 'scroll-trigger--offscreen');
          card.removeAttribute('data-cascade');
          fragment.appendChild(card);
        }
        grid.appendChild(fragment);
        state.seen.add(pageKey);
        state.failures = 0; grid.dataset.charmaBackground = 'loaded';
        const oldPagination = container.querySelector('.pagination-wrapper');
        const newPagination = doc.querySelector('.pagination-wrapper');
        if (oldPagination && newPagination) oldPagination.replaceWith(newPagination);
        else if (oldPagination) oldPagination.remove();
        document.dispatchEvent(new CustomEvent('charma:collection-updated', { detail: { grid } }));
      } catch (error) {
        if (!valid()) return;
        state.failures++; grid.dataset.charmaBackground = error.message;
      } finally {
        clearTimeout(timeout);
        state.loading = false;
        if (valid() && state.failures < 2) schedule();
      }
    }
    state.timer = setTimeout(load, 1500);
  }
  function init() {
    start();
    const main = document.querySelector('#MainContent');
    if (main) new MutationObserver(start).observe(main, { childList: true, subtree: true });
  }
  if (document.readyState === 'complete') init();
  else window.addEventListener('load', init, { once: true });
})();

/* Charma homepage: compact photo banner, 10.10.2026. */
(function(){if(!/^\/(?:pl\/?)?$/.test(location.pathname))return;var s=document.createElement('style');s.textContent=`
main [id$="__image_banner"] .banner{padding-top:0!important;min-height:0!important;height:clamp(500px,40.7vw,650px)!important}
main [id$="__image_banner"] .banner:before,main [id$="__image_banner"] .banner:after,main [id$="__image_banner"] .banner__media:before,main [id$="__image_banner"] .banner__content:before{display:none!important}
main [id$="__image_banner"] .banner__content{display:none!important}
main [id$="__image_banner"] .banner__media{inset:0;width:100%;height:100%}
main [id$="__image_banner"] .banner__media img{object-fit:cover;object-position:center center!important}
@media(max-width:749px){main [id$="__image_banner"] .banner{height:420px!important}main [id$="__image_banner"] .banner__media img{object-position:center top!important}}
`;document.head.appendChild(s)})();

/* Polish storefront: accessible labels and clear local delivery/payment copy. */
(function () {
  if (!(window.CHARMA_L10N && window.CHARMA_L10N.isPl)) return;
  var pending = false;
  function set(el, attr, value) { if (value && el.getAttribute(attr) !== value) el.setAttribute(attr, value); }
  function run() {
    pending = false;
    var main = document.getElementById('MainContent');
    if (!main) return;
    var heading = main.querySelector('h1');
    main.querySelectorAll('[id^="pwzrswiper-img-"]').forEach(function (img) { if (heading) set(img, 'alt', heading.textContent.trim()); });
    main.querySelectorAll('[data-charma-promo]').forEach(function (el) { set(el, 'title', 'Kliknij, aby poznać szczegóły promocji'); set(el, 'aria-label', 'Zasady promocji Charma Italia: 7 charmsów i bransoletka gratis'); });
    main.querySelectorAll('a[id^="CardLink-"]').forEach(function (a) {
      var card = a.closest('.card'); if (!card) return;
      var title = a.textContent.replace(/W promocji/g, '').trim();
      card.querySelectorAll('img').forEach(function (img) { set(img, 'alt', title); });
    });
    main.querySelectorAll('img').forEach(function (img) {
      if (/Detail ucha/.test(img.alt)) set(img, 'alt', 'Ucho ze złotą biżuterią do piercingu');
    });
    document.querySelectorAll('#insta-feed a').forEach(function (a, i) { set(a, 'aria-label', 'Zobacz post Charma na Instagramie'); });
    document.querySelectorAll('#insta-feed img').forEach(function (img) { set(img, 'alt', 'Biżuteria Charma na Instagramie'); });
    main.querySelectorAll('.product__info-container li').forEach(function (li) {
      if (li.textContent.trim() === 'Płatność przy odbiorze') li.innerHTML = "<svg class=\"icon icon-accordion\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"32\" height=\"32\" aria-hidden=\"true\" focusable=\"false\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.4\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect x=\"2.5\" y=\"4.5\" width=\"19\" height=\"15\" rx=\"2\" fill=\"none\"/><path d=\"M2.5 9h19M6 15h4M15 15h3\" fill=\"none\"/></svg><span class=\"h4 inline-richtext\">Płatności BLIK i kartą</span>";
    });
  }
  function schedule() { if (!pending) { pending = true; setTimeout(run, 100); } }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  new MutationObserver(schedule).observe(document.body, {childList:true,subtree:true});
})();

/* Polish Italia product: use the matching offer beside the charm picker. */
(function(){
  if (!(window.CHARMA_L10N && window.CHARMA_L10N.isPl)) return;
  function fix(){
    if (!document.getElementById('ci-charm-picker')) return;
    document.querySelectorAll('p').forEach(function(el){
      if (/^Wybierz cztery ozdoby, które Ci się podobają/.test(el.textContent.trim())) {
        el.textContent='Wybierz 7 charmsów Charma Italia i dodaj do koszyka wybraną bransoletkę Charma Italia — jej cena obniży się automatycznie do 0 zł.';
      }
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',fix); else fix();
  setTimeout(fix,1800);
})();

/* InPost pickup-point selection is handled after order placement. */
